// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-10-22T20:06:27.774Z
// Property: Millcroft Apartments & Townhomes (ID: 6767906449166332)
// Collections: 28 amenities, 15 floorplans (live), 42 photos, 84 POIs, 2 reviews, 1 virtual tours, 6 office hours, 4 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162442",
  "multihub_property_id": "6767906449166332",
  "property_external_id": "33416",
  "property_zillow_url": "https://www.zillow.com/apartments/milford-oh/millcroft-apartments/5XtP4V/",
  "property_apartments_url": "https://www.apartments.com/millcroft-apartments-townhomes-milford-oh/f90p9vs/",
  "property_google_business_url": "https://www.google.com/maps/place/Millcroft+Apartments+%26+Townhomes/data=!4m2!3m1!1s0x0:0xc97bbe3efe27ce0?sa=X&ved=2ahUKEwjZrrylxriSAxWlkyYFHUeZNgMQ_BJ6BAgXEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": "58895523170",
  "property_crm_software": "EliseAI",
  "property_pm_software": "RealPage",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "millcroft-apartments-&-townhomes",
  "property_name": "Millcroft Apartments & Townhomes",
  "property_website_url": "https://www.millcroftapts.com/",
  "property_domain": "https://www.millcroftapts.com/",
  "property_address": "10 Commons Drive",
  "property_full_address": "10 Commons Dr, Milford, OH 45150",
  "property_address_1": "10 Commons Dr",
  "property_address_2": null,
  "property_address_city": "Milford",
  "property_address_state": "OH",
  "property_address_zip_full": "45150-1928",
  "property_address_zip": "45150",
  "property_address_country": "US",
  "property_address_county": "Clermont County",
  "property_neighborhood_address": "Outer Clermont County",
  "property_address_latitude": "39.1892944",
  "property_address_longitude": "-84.25142149999999",
  "property_email": "millcroft@aionmanagement.com",
  "property_phone": "(740) 926-6950",
  "property_call_tracking_phone": "740-444-4171",
  "property_company_name": "AION Management ",
  "property_company_url": "https://www.aionmanagement.com",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "At Millcroft Apartments & Townhomes in Milford, OH, your ideal lifestyle awaits! Choose from spacious one and two-bedroom floor plans while enjoying amenities like a refreshing swimming pool, inviting dog park, and vibrant resident activities. Embrace comfort, convenience, and community—your new home is just a click away!",
  "property_long_description": "Welcome to Millcroft Apartments & Townhomes, your ideal living destination in scenic Milford, OH! Our vibrant community features an array of thoughtfully designed floor plans, including one and two-bedroom apartments, tailored to meet your lifestyle needs. Embrace the comfort and convenience of a pet-friendly environment featuring both townhomes and spacious apartments equipped with modern amenities.\n\nAt Millcroft, we prioritize your leisure and well-being. Enjoy our resort-style amenities, which include a refreshing swimming pool, a state-of-the-art fitness center, and an expansive sundeck perfect for soaking up the sun. For outdoor enthusiasts, our basketball and pickleball courts, playground, and dog park offer endless activities. Gather with friends in our resident lounge, or host a barbecue at one of our grilling stations.\n\nAdditionally, our community offers practical features such as a 24-hour emergency maintenance team, online resident portal, and flexible rent payment options for your peace of mind. Families will appreciate the picnic areas and the scheduled resident activities fostering a strong sense of community. \n\nWith ample on-site and off-street parking, combined with short-term leasing options, moving here couldn’t be easier. Experience the perfect blend of comfort and convenience at Millcroft Apartments & Townhomes! \n\nFind your new home today—browse our availability or schedule a tour to visit our community! Adventure and relaxation await at Millcroft!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/019fce02-d423-7377-a00c-e2e6d25e5fca.webp",
  "property_featured_image_media": {
    "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas.",
    "public_id": "019fce02-d423-7377-a00c-e2e6d25e5fca",
    "storage_key": "property/6767906449166332/019fce02-d423-7377-a00c-e2e6d25e5fca.webp",
    "width": 1478,
    "height": 986
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "234",
  "property_year_built": "1976",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "97.86324786324786",
  "property_admin_fee": "100",
  "property_application_fee": "75",
  "property_fees_deposit_info": "Security Deposit: $750",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "350",
  "property_pet_deposit": null,
  "property_monthly_pet_rent": "50",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": null,
  "property_pet_restrictions": "Maximum 2 pets per unit. Breed restrictions apply; certain breeds and mixes over 50% are prohibited.",
  "property_pet_policy_description": "Dogs and cats allowed. Maximum 2 pets per unit. One-time non‑refundable pet fee: $350. Monthly pet rent: $150 per pet. Breed restrictions apply; certain breeds and mixes over 50% are prohibited. All pets must be housebroken, and residents must sign a Pet Addendum and provide a photo of each pet.",
  "property_petpolicy_info": null,
  "property_online_leasing_url": null,
  "property_resident_portal_url": "https://millcroftapartments.loftliving.com/login",
  "property_apply_now_url": "https://www.millcroftapts.com/apply-now",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/019d026a-1d89-728f-89c1-932727b2f7a3.webp",
  "property_primary_logo_media": {
    "alt_text": "Millcroft Apartments & Townhomes logo.",
    "public_id": "019d026a-1d89-728f-89c1-932727b2f7a3",
    "storage_key": "property/6767906449166332/019d026a-1d89-728f-89c1-932727b2f7a3.webp",
    "width": 300,
    "height": 65
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/019d026a-1340-72df-b764-841d203c03ff.webp",
  "property_secondary_logo_media": {
    "alt_text": "AI ON MANAGEMENT logo",
    "public_id": "019d026a-1340-72df-b764-841d203c03ff",
    "storage_key": "property/6767906449166332/019d026a-1340-72df-b764-841d203c03ff.webp",
    "width": 325,
    "height": 131
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/019d026a-2bb2-74ac-bbad-22e36e4f03e1.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Millcroft Apartments & Townhomes logo",
    "public_id": "019d026a-2bb2-74ac-bbad-22e36e4f03e1",
    "storage_key": "property/6767906449166332/019d026a-2bb2-74ac-bbad-22e36e4f03e1.webp",
    "width": 300,
    "height": 65
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/019d026a-376a-77aa-ad34-e45fe352736c.webp",
  "property_mono_black_logo_media": {
    "alt_text": "Millcroft Apartments & Townhomes logo",
    "public_id": "019d026a-376a-77aa-ad34-e45fe352736c",
    "storage_key": "property/6767906449166332/019d026a-376a-77aa-ad34-e45fe352736c.webp",
    "width": 300,
    "height": 65
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162442/019fcb00-e4bd-730e-be09-fdc89126e5de.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162442/019d0264-670c-7240-a629-183122c7de9e.webp",
  "property_company_logo_media": {
    "alt_text": "AION MANAGEMENT logo",
    "public_id": "019d0264-670c-7240-a629-183122c7de9e",
    "storage_key": "company/5767906449162442/019d0264-670c-7240-a629-183122c7de9e.webp",
    "width": 598,
    "height": 250
  },
  "property_company_mono_black_logo": null,
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": null,
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#002142",
  "property_secondary_color": "#494747",
  "property_font_color": "#002142",
  "property_color_4": null,
  "property_color_3": "#f18c20",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 2",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": "1 - 1.5",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "1.5",
  "property_sqft_range": "650 - 1200",
  "property_sqft_min": "650",
  "property_sqft_max": "1200",
  "property_price_range": "1161 - 1788",
  "property_price_min": "1161",
  "property_price_max": "1788",
  "property_available_units": 5,
  "property_facebook_url": "https://www.facebook.com/MillcroftApts",
  "property_instagram_url": "https://www.instagram.com/millcroftapts/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJr4tXIeb_QIgR4Hzi7-O7lww",
  "property_youtube_url": "https://www.youtube.com/watch?v=EWGuRgHXuTE",
  "property_yelp_url": "https://m.yelp.com/search?find_desc=Indoor+Public+Space&find_loc=Mulberry%2C+OH",
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Millcroft Apartments & Townhomes",
  "property_home_romance_title": "Embrace Life and Love in Your New Apartment Community",
  "property_home_amenities_blurb": "At Millcroft Apartments & Townhomes in Milford, OH, experience a lifestyle brimming with comfort and fun. From cozy one- and two-bedroom layouts to vibrant amenities like our basketball court and peaceful dog park, there's something for everyone. Join a community where relaxation and recreation coexist beautifully!",
  "property_home_floorplans_blurb": "Welcome to Millcroft Apartments & Townhomes in charming Milford, OH, where comfort meets style. With spacious one and two-bedroom floor plans, each home reflects modern living. Dive into our unique community and browse available apartment homes to find your perfect fit in this inviting neighborhood. Your new life awaits!",
  "property_home_gallery_blurb": "Welcome to Millcroft Apartments & Townhomes in Milford, OH, where comfort meets community. Choose from spacious one and two-bedroom floor plans, enjoy vibrant resident activities, and indulge in amenities like a swimming pool, fitness center, and dog park. Picture yourself living here, where every day feels like a getaway!",
  "property_home_neighborhood_blurb": "Nestled in the heart of Milford, Millcroft Apartments & Townhomes offers a serene retreat surrounded by nature and vibrant community life. Enjoy easy access to local parks, top-rated schools, and essential services. Experience the perfect blend of tranquility and convenience, making your home a launchpad for adventure!",
  "property_home_reviews_blurb": "At Millcroft Apartments & Townhomes in Milford, OH, residents are greeted with warmth and exceptional service. One satisfied visitor raved, “Staff were very friendly and helpful… A great place!” Join a community where neighborly care and prompt assistance from our team create a welcoming atmosphere. See what our residents have to say!",
  "property_neighborhood_blurb": "At Millcroft Apartments & Townhomes in Milford, OH, vibrant community life awaits! Enjoy access to engaging recreational spots like the Cincinnati Nature Center, scenic Valley View Nature Preserve, and the Milford Trailhead. With excellent schools and convenient shopping nearby, our neighborhood caters to every lifestyle. See what’s around and embrace local charm!",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "At Millcroft Apartments & Townhomes in Milford, OH, vibrant living meets modern convenience. Enjoy a sun-soaked sundeck by the swimming pool, stay active with our basketball and pickleball courts, and unwind in our cozy resident lounge. Embrace a lifestyle that celebrates comfort and community, all in a pet-friendly environment.",
  "property_applynow_blurb": "At Millcroft Apartments & Townhomes in Milford, OH, embrace a vibrant lifestyle with one and two-bedroom floor plans that cater to your every need. Enjoy amenities like a refreshing swimming pool, engaging resident activities, and pet-friendly spaces, all designed to make each day extraordinary. Lease online today and find your perfect fit!",
  "property_contactus_blurb": "At Millcroft Apartments & Townhomes in Milford, OH, a perfect blend of comfort and style awaits. Choose from spacious one or two-bedroom floor plans tailored to suit your lifestyle. Have questions? Our friendly leasing team is here to help you find your next home sweet home—reach out today!",
  "property_faqs_blurb": "Nestled in the heart of Milford, OH, Millcroft Apartments & Townhomes offers thoughtfully designed one and two-bedroom floor plans tailored to your lifestyle. Have questions about our vibrant community? Dive into our FAQs page for insights and details that transform your apartment search into a seamless experience.",
  "property_floorplans_blurb": "At Millcroft Apartments & Townhomes in Milford, OH, your ideal living space awaits. Choose from our stylish one and two-bedroom floor plans designed for comfort and convenience. Each layout enhances your lifestyle. Browse our available apartment homes today and envision the perfect blend of comfort and modern living.",
  "property_gallery_blurb": "At Millcroft Apartments & Townhomes in Milford, OH, vibrant living meets modern comfort. With spacious one and two-bedroom floor plans, a refreshing swimming pool, and amenities like a dog park and basketball court, this community is perfect for everyone. Picture yourself relaxing on the sundeck or enjoying resident activities today!",
  "property_interactivemap_blurb": "At Millcroft Apartments & Townhomes in Milford, OH, choose from spacious one and two-bedroom floor plans tailored for comfort. Enjoy a vibrant lifestyle with amenities that include a pet-friendly dog park, fitness center, and modern clubhouse. Unleash your next adventure with our interactive community map to find your perfect home!",
  "property_pets_blurb": "At Millcroft Apartments & Townhomes in Milford, OH, your furry companions can enjoy a welcoming home too. With a pet-friendly policy for dogs and cats, you can create lasting memories together, with the comfort of knowing that your pets are part of the family. Enrich your lifestyle today!",
  "property_referafriend_blurb": "At Millcroft Apartments & Townhomes in Milford, OH, your ideal living space awaits, whether you seek a cozy one-bedroom or a spacious two-bedroom. Embrace vibrant community living—refer a friend today, and together, enjoy all the comforts of home with incredible neighbors right next door!",
  "property_residentaccess_blurb": "Welcome to Millcroft Apartments & Townhomes in Milford, OH, where your comfort meets convenience. Our diverse floor plans include spacious one and two-bedroom options designed to fit your lifestyle. Access your resident portal for easy rent payments, maintenance requests, and exclusive community updates—all just a click away!",
  "property_reviews_blurb": "At Millcroft Apartments & Townhomes in Milford, OH, our residents rave about their experience! With comments like “Great place!” and praises for our friendly staff, it’s clear we prioritize community and comfort. Want to see why everyone feels so welcome? Read our reviews to learn more about life here!",
  "property_created_at": "1757008513739",
  "property_scheduletour_blurb": "At Millcroft Apartments & Townhomes in Milford, OH, your perfect living space awaits with stylish one and two-bedroom floor plans. Experience the vibrant community life and exceptional amenities that make us home. Schedule a tour today and hear firsthand from our residents about their experiences living here!",
  "property_thankyou_blurb": "Thank you for reaching out to Millcroft Apartments & Townhomes in Milford, OH! Your interest in our spacious one and two-bedroom floor plans is appreciated. Our team will be in touch soon to help you find the perfect home tailored to your lifestyle. Stay tuned for exciting updates!",
  "property_virtualtours_blurb": "At Millcroft Apartments & Townhomes in Milford, OH, you can find the perfect floor plan tailored to your lifestyle, whether it’s a cozy one-bedroom or a spacious two-bedroom. Experience our inviting community from the comfort of your own home—take a virtual tour today and envision your new life!",
  "property_copyright": "2025 All Rights Reserved. Millcroft Apartments & Townhomes",
  "property_seo_title_home": "Millcroft Apartments & Townhomes | Milford, OH",
  "property_seo_description_home": "Unwind at Millcroft Apartments & Townhomes in Milford, OH! Enjoy modern amenities, diverse floor plans, and a vibrant community. Your perfect home awaits!",
  "property_seo_title_floorplans": "Floor Plans | Milford, OH Apartments for Rent",
  "property_seo_description_floorplans": "Find your ideal living space at Millcroft Apartments & Townhomes in Milford, OH. Browse our unique one and two-bedroom floor plans tailored for you!",
  "property_seo_title_amenities": "Amenities | Milford, OH Apartments for Rent",
  "property_seo_description_amenities": "Discover vibrant living at Millcroft Apartments in Milford, OH! Enjoy pet-friendly amenities like a pool, fitness center, and more!",
  "property_seo_title_gallery": "Gallery | Apartments in Milford, OH",
  "property_seo_description_gallery": "Experience vibrant living at Millcroft Apartments & Townhomes in Milford, OH. Picture cozy nights, community fun, and modern amenities right at your doorstep!",
  "property_seo_title_virtualtours": "Virtual Tours | Millcroft Apartments & Townhomes Apartments",
  "property_seo_description_virtualtours": "Experience Millcroft Apartments & Townhomes in Milford, OH. Take a virtual tour to explore our stylish one and two-bedroom floor plans—your new home awaits!",
  "property_seo_title_interactivemap": "Interactive Map | Millcroft Apartments & Townhomes Apartments",
  "property_seo_description_interactivemap": "Find your perfect apartment at Millcroft Apartments & Townhomes in Milford, OH. Use our interactive map to explore layouts, amenities, and pricing today!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Milford, OH",
  "property_seo_description_neighborhood": "Experience the charm of Milford, OH! At Millcroft Apartments & Townhomes, uncover local favorites and vibrant attractions just steps from your doorstep.",
  "property_seo_title_contact": "Contact Us | Millcroft Apartments & Townhomes",
  "property_seo_description_contact": "Connect with Millcroft Apartments in Milford, OH! From cozy one-bedrooms to spacious twos, our leasing team is ready to assist you today!",
  "property_seo_title_faqs": "FAQs | Apartments in Milford, OH",
  "property_seo_description_faqs": "Get the answers you need about Millcroft Apartments & Townhomes in Milford, OH! Explore our FAQs to learn about amenities, floor plans, pet policies, and more!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Milford, OH",
  "property_seo_description_reviews": "Discover Millcroft Apartments & Townhomes in Milford, OH—enjoy cozy living, vibrant amenities, and resident stories from their journeys!",
  "property_seo_title_applynow": "Apply Now | Apartments in Milford, OH",
  "property_seo_description_applynow": "Elevate your lifestyle at Millcroft Apartments & Townhomes in Milford, OH! Enjoy modern amenities and pet-friendly living. Lease online today!",
  "property_seo_title_residentaccess": "Resident Access | Millcroft Apartments & Townhomes",
  "property_seo_description_residentaccess": "Seamless living awaits at Millcroft Apartments & Townhomes! Log in to your resident portal for easy rent payment, maintenance requests, and community updates.",
  "property_seo_title_referafriend": "Refer A Friend | Millcroft Apartments & Townhomes",
  "property_seo_description_referafriend": "Refer a friend to Millcroft Apartments & Townhomes in Milford, OH. Great friends make great neighbors—experience life together in a vibrant community!",
  "property_seo_title_scheduletour": "Schedule a Tour | Millcroft Apartments & Townhomes",
  "property_seo_description_scheduletour": "Experience the charm of Millcroft Apartments & Townhomes in Milford, OH. Schedule your tour today and envision your new life in our vibrant community!",
  "property_seo_title_privacy": "Privacy Policy | Millcroft Apartments & Townhomes",
  "property_seo_description_privacy": "At Millcroft Apartments in Milford, OH, your privacy matters. Review our policy to see how we protect your information for your peace of mind!",
  "property_seo_title_accessibility": "Website Accessibility | Millcroft Apartments & Townhomes",
  "property_seo_description_accessibility": "At Millcroft Apartments & Townhomes in Milford, OH, we prioritize accessibility for all. Join us in creating an inclusive community where everyone belongs.",
  "property_seo_title_sitemap": "Sitemap | Millcroft Apartments & Townhomes",
  "property_seo_description_sitemap": "Uncover the layout of Millcroft Apartments & Townhomes in Milford, OH. Navigate our sitemap for a seamless journey through your future home!",
  "property_seo_title_thankyou": "Thank You | Millcroft Apartments & Townhomes",
  "property_seo_description_thankyou": "Thank you for reaching out! Your interest in Millcroft Apartments & Townhomes in Milford, OH, is valued. Expect to hear from us soon about your next home!",
  "property_seo_title_pets": "Pet Policy | Apartments in Milford, OH",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1791293651457",
  "amenities": [
    {
      "id": "custom_12df2cb5-bcf6-4eaf-a8e3-4249d281f5f0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166332",
      "source": "custom",
      "external_id": "false",
      "title": "24-Hour Emergency Maintenance",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_b608e6a0-109b-4249-b7ab-083a424bb6d4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166332",
      "source": "custom",
      "external_id": "false",
      "title": "Clubhouse",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_fad53527-eb2b-49e5-861a-956012259503",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166332",
      "source": "custom",
      "external_id": "false",
      "title": "Fitness Center",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_d5b71989-bc8f-46b1-ad30-b918f8910563",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166332",
      "source": "custom",
      "external_id": "false",
      "title": "Laundry Facilities",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_7da850da-3d41-4e82-9fa3-4b04e60ac69e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166332",
      "source": "custom",
      "external_id": "false",
      "title": "Online Rental Payments",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_a7e8820b-cf39-4ffc-8e51-60e64f493a1c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166332",
      "source": "custom",
      "external_id": "false",
      "title": "On-Site Maintenance",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_bd18e6b0-4a05-48b4-8f6c-5c169d4c356c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166332",
      "source": "custom",
      "external_id": "false",
      "title": "On-Site Management",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_97cd53a6-cb28-47be-8ba0-0c8173cde976",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166332",
      "source": "custom",
      "external_id": "false",
      "title": "Package Receiving",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_54cfcba5-09b7-4a54-bdcb-9f91c39ad95e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166332",
      "source": "custom",
      "external_id": "false",
      "title": "Short Term Leases",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_53797f05-122b-45b7-93d4-2b5cb53b0b84",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166332",
      "source": "custom",
      "external_id": "false",
      "title": "Wi-Fi in Common Areas",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_25b52644-d509-495b-97d0-e24f54a95412",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166332",
      "source": "custom",
      "external_id": "false",
      "title": "Air Conditioning",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_7ed3a062-c1c9-416a-925e-75e6182608e0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166332",
      "source": "custom",
      "external_id": "false",
      "title": "Brick Accent Walls*",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_b9933595-3bc6-4d75-a5c2-153bb9ba627d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166332",
      "source": "custom",
      "external_id": "false",
      "title": "Ceiling Fans*",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_70b0e67a-1ea9-4e13-90ac-2544762a7f23",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166332",
      "source": "custom",
      "external_id": "false",
      "title": "Dishwasher",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_295a9cb4-f31c-41cf-8549-2fac23622368",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166332",
      "source": "custom",
      "external_id": "false",
      "title": "Microwave*",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_886e562e-7e03-4bbe-b871-171cde6374d8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166332",
      "source": "custom",
      "external_id": "false",
      "title": "Private Patio or Balcony",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_f9a1584a-39e0-41f6-aba9-0a18932e3f2e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166332",
      "source": "custom",
      "external_id": "false",
      "title": "Stainless-Steel Appliances*",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_d9fb73d2-0c23-4f91-8ac3-be47f47b4590",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166332",
      "source": "custom",
      "external_id": "false",
      "title": "Walk-In Closets*",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_46ae58c9-657b-4115-a1e5-4741ba916660",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166332",
      "source": "custom",
      "external_id": "false",
      "title": "Washer & Dryer Connections*",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_5b499827-7e11-42df-8ce4-cabebd6d5715",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166332",
      "source": "custom",
      "external_id": "false",
      "title": "White Tile Backsplash*",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_b9b6da74-bdd8-43d7-9c41-8e452d1dc603",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166332",
      "source": "custom",
      "external_id": "false",
      "title": "Wood-Style Flooring",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_6ad5fa76-2e70-43c8-84d4-bb4ca557e0ba",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166332",
      "source": "custom",
      "external_id": "false",
      "title": "Basketball Court",
      "amount": "false",
      "description": "false",
      "group": "Outdoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_c6a14416-90a6-4a3d-a267-e6d64a000694",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166332",
      "source": "custom",
      "external_id": "false",
      "title": "Dog Park",
      "amount": "false",
      "description": "false",
      "group": "Outdoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_0b3cd526-2a5b-4175-ad6e-ae792e21af7b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166332",
      "source": "custom",
      "external_id": "false",
      "title": "Free Resident Parking",
      "amount": "false",
      "description": "false",
      "group": "Outdoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_f90183c4-c43b-46a4-a39a-c19670b5d60a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166332",
      "source": "custom",
      "external_id": "false",
      "title": "Grilling & Picnic Area",
      "amount": "false",
      "description": "false",
      "group": "Outdoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_af06deb1-ea49-4c34-9785-941afd5bba8d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166332",
      "source": "custom",
      "external_id": "false",
      "title": "Pickleball Court",
      "amount": "false",
      "description": "false",
      "group": "Outdoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_1a8421ae-df62-4efb-887f-7c6dde65e9ac",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166332",
      "source": "custom",
      "external_id": "false",
      "title": "Playground",
      "amount": "false",
      "description": "false",
      "group": "Outdoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_c56a56e0-a918-459e-862f-5fcd6165dcb2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166332",
      "source": "custom",
      "external_id": "false",
      "title": "Swimming Pool",
      "amount": "false",
      "description": "false",
      "group": "Outdoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_63345ff9-7983-4e88-8a84-048b395ffdec",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166332",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/019fce02-e47d-749f-bcea-56a9bf4f5abc.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, granite countertops, and white cabinetry.",
        "public_id": "019fce02-e47d-749f-bcea-56a9bf4f5abc",
        "storage_key": "property/6767906449166332/019fce02-e47d-749f-bcea-56a9bf4f5abc.webp",
        "width": 1486,
        "height": 991
      },
      "title": "Apartment",
      "description": "Bright, contemporary kitchen in a modern apartment with granite countertops, white cabinets, and stainless-steel appliances.",
      "link": "",
      "alt_text": "Modern kitchen with white cabinets, dark lower cabinets, granite countertops, and stainless steel appliances.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/35bad03d/dms3rep/multi/5767906449162442/6767906449166332/408218ddc6e59b059d68193d8bcc8824.jpg"
    },
    {
      "id": "custom_8140a9f8-8ffb-41ce-8187-eed91dc8c925",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166332",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/019fce02-e4ad-712f-b142-6e4f72a9434b.webp",
      "image_media": {
        "alt_text": "A stylish communal lounge area with a dining table and seating, a fireplace, and a television.",
        "public_id": "019fce02-e4ad-712f-b142-6e4f72a9434b",
        "storage_key": "property/6767906449166332/019fce02-e4ad-712f-b142-6e4f72a9434b.webp",
        "width": 1481,
        "height": 988
      },
      "title": "Community",
      "description": "Spacious resident lounge with a fireplace, mounted TV, and a round glass dining table for gatherings.",
      "link": "",
      "alt_text": "Modern community lounge with gray seating, a fireplace, TV, and round glass dining table.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/35bad03d/dms3rep/multi/5767906449162442/6767906449166332/634450d1dddcfb88a7a35b3884609ad0.jpg"
    },
    {
      "id": "custom_0105b410-e954-4106-921f-5e25621aad29",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166332",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/019fce02-e4c9-73d7-b94f-a56a1a243682.webp",
      "image_media": {
        "alt_text": "Dining area with a wood table, chairs, and a ceiling fan, leading to a kitchen.",
        "public_id": "019fce02-e4c9-73d7-b94f-a56a1a243682",
        "storage_key": "property/6767906449166332/019fce02-e4c9-73d7-b94f-a56a1a243682.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Bright open living/dining space in a modern apartment, featuring a staircase, kitchen pass-through, and a potted plant.",
      "link": "",
      "alt_text": "Open-concept living and dining area with stairs and kitchen pass-through in a modern apartment.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/35bad03d/dms3rep/multi/4d39614d8930b54dab1fcac84bdd028d-a3868646.webp"
    },
    {
      "id": "custom_4f05d99e-2927-410b-b14d-75acd2aefc9d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166332",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/019fce02-e43c-764f-b851-798e13281d15.webp",
      "image_media": {
        "alt_text": "Living room with brick accent wall, mirror, and comfortable seating.",
        "public_id": "019fce02-e43c-764f-b851-798e13281d15",
        "storage_key": "property/6767906449166332/019fce02-e43c-764f-b851-798e13281d15.webp",
        "width": 1486,
        "height": 991
      },
      "title": "Apartment",
      "description": "Spacious apartment living room with a brick accent wall, contemporary furniture, and an open layout.",
      "link": "",
      "alt_text": "Living room with a brick accent wall, neutral furniture, and sheer white curtains.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/35bad03d/dms3rep/multi/5767906449162442/6767906449166332/7a16cca353258e275114d140cd81842c.jpg"
    },
    {
      "id": "custom_51a56208-51c9-4361-8c24-b10b08824176",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166332",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/019fce02-efbe-74d8-9923-baf652079b4a.webp",
      "image_media": {
        "alt_text": "Kitchen area with granite countertops, stainless steel dishwasher, and white cabinetry.",
        "public_id": "019fce02-efbe-74d8-9923-baf652079b4a",
        "storage_key": "property/6767906449166332/019fce02-efbe-74d8-9923-baf652079b4a.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Modern apartment kitchen with granite countertops, a stainless dishwasher, white upper cabinets, and a stairway nearby.",
      "link": "",
      "alt_text": "Open kitchen area with granite countertop, dishwasher, white cabinets, and stairs to the left.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/35bad03d/dms3rep/multi/5767906449162442/6767906449166332/2aa91d6b72c6f484d5c7c228456f7a56.webp"
    },
    {
      "id": "custom_dd6f193e-1119-4053-8970-511c3ef1888c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166332",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/019fce02-f180-71fe-8b15-7dd560968442.webp",
      "image_media": {
        "alt_text": "Modern kitchen with dark lower cabinets, white upper cabinets, stainless steel appliances, and granite countertops.",
        "public_id": "019fce02-f180-71fe-8b15-7dd560968442",
        "storage_key": "property/6767906449166332/019fce02-f180-71fe-8b15-7dd560968442.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Bright and modern kitchen featuring a full suite of stainless steel appliances, ample cabinet space, and stylish countertops. Perfect for any home chef.",
      "link": "",
      "alt_text": "Modern apartment kitchen with white upper cabinets, dark lower cabinets, granite countertops, and stainless steel appliances.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/35bad03d/dms3rep/multi/5767906449162442/6767906449166332/14eab76757a5c70d23b26ae1b7ed43ae.webp"
    },
    {
      "id": "custom_9e669ade-87ed-4b0e-be4f-875b6f63af83",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166332",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/019fce02-f19b-74e4-882a-178b141576cd.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances and a dining area.",
        "public_id": "019fce02-f19b-74e4-882a-178b141576cd",
        "storage_key": "property/6767906449166332/019fce02-f19b-74e4-882a-178b141576cd.webp",
        "width": 1486,
        "height": 991
      },
      "title": "Apartment",
      "description": "Bright, modern apartment kitchen with white cabinets, black appliances, and an open dining area.",
      "link": "",
      "alt_text": "Kitchen in a modern apartment: white cabinets, black refrigerator and stove, adjacent dining area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/35bad03d/dms3rep/multi/5767906449162442/6767906449166332/e55e8f911bdb09b39c77228b6d23e2c3.jpg"
    },
    {
      "id": "custom_ec7777b3-5247-437d-8234-0c581edda17e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166332",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/019fce02-f9c1-705c-8c45-e4cc6d096643.webp",
      "image_media": {
        "alt_text": "Cozy living room with a sectional sofa, armchairs, coffee table, and a home office setup.",
        "public_id": "019fce02-f9c1-705c-8c45-e4cc6d096643",
        "storage_key": "property/6767906449166332/019fce02-f9c1-705c-8c45-e4cc6d096643.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Bright, modern living room with neutral tones, featuring a sofa, two lounge chairs, a glass coffee table, and a small desk in the back.",
      "link": "",
      "alt_text": "Living room in a neutral apartment interior with a sofa, two chairs, a glass coffee table, and a desk.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/35bad03d/dms3rep/multi/5767906449162442/6767906449166332/01cb6a8fe0059be34fafb432b2e64568.webp"
    },
    {
      "id": "custom_6bdaf649-3517-4b36-bdcf-344132e235f2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166332",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/019fce02-fac6-7141-aeeb-598480ff82ac.webp",
      "image_media": {
        "alt_text": "Interior staircase leading to an open door revealing a half bathroom.",
        "public_id": "019fce02-fac6-7141-aeeb-598480ff82ac",
        "storage_key": "property/6767906449166332/019fce02-fac6-7141-aeeb-598480ff82ac.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Bright apartment interior with a staircase and an adjacent small bathroom, showcasing clean, modern finishes.",
      "link": "",
      "alt_text": "Interior stairwell with white walls and an open doorway to a small bathroom featuring a toilet.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/35bad03d/dms3rep/multi/5767906449162442/6767906449166332/7032c12d83fa4d246367cd24fb57939f.webp"
    },
    {
      "id": "custom_5c1a7966-036e-42a3-be78-da516e026488",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166332",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/019fce02-fc65-705a-9cf7-499765f72f55.webp",
      "image_media": {
        "alt_text": "Living room with gray sofa, coffee table, and chair.",
        "public_id": "019fce02-fc65-705a-9cf7-499765f72f55",
        "storage_key": "property/6767906449166332/019fce02-fc65-705a-9cf7-499765f72f55.webp",
        "width": 1486,
        "height": 991
      },
      "title": "Apartment",
      "description": "Bright, contemporary living room in a modern apartment with neutral decor and a balcony view.",
      "link": "",
      "alt_text": "Living room in a modern apartment with a gray sofa, chair, and a balcony door.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/35bad03d/dms3rep/multi/5767906449162442/6767906449166332/c449171149583c17037a250e16b7986d.jpg"
    },
    {
      "id": "custom_de06891b-7fbb-4e04-a904-ca8db0f429b3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166332",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/019fce02-fcf5-775b-a541-a1310cbd5679.webp",
      "image_media": {
        "alt_text": "Dining area and living room of an apartment.",
        "public_id": "019fce02-fcf5-775b-a541-a1310cbd5679",
        "storage_key": "property/6767906449166332/019fce02-fcf5-775b-a541-a1310cbd5679.webp",
        "width": 1486,
        "height": 991
      },
      "title": "Apartment",
      "description": "Bright, open-plan living space with a cozy gray sofa, dining area, and tasteful wall art.",
      "link": "",
      "alt_text": "Open-concept living room and dining area in a modern apartment with a gray sofa, round dining table, and neutral decor.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/35bad03d/dms3rep/multi/5767906449162442/6767906449166332/afc02fba1b48963e7dfaab3d9d2fa4eb.jpg"
    },
    {
      "id": "custom_e42c81c5-ffdb-47a6-b8d8-7a71accd5115",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166332",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/019fce03-0623-76c2-8018-2941b81828a9.webp",
      "image_media": {
        "alt_text": "A cozy bedroom with a queen-size bed, armchair, and dresser.",
        "public_id": "019fce03-0623-76c2-8018-2941b81828a9",
        "storage_key": "property/6767906449166332/019fce03-0623-76c2-8018-2941b81828a9.webp",
        "width": 1486,
        "height": 991
      },
      "title": "Apartment",
      "description": "A cozy, modern bedroom in a multifamily unit featuring a light wood bed frame, neutral bedding, and soft natural light.",
      "link": "",
      "alt_text": "Bright bedroom in an apartment with a wooden bedframe, ceiling fan, and white curtains over a window.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/35bad03d/dms3rep/multi/5767906449162442/6767906449166332/21f5c0c454af2e837ebc7d84ce4a3f84.jpg"
    },
    {
      "id": "custom_82166962-0f77-4713-b38d-55466d89825f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166332",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/019fce03-0622-76fb-9096-9b9b468630f7.webp",
      "image_media": {
        "alt_text": "Modern gray kitchen with stainless steel microwave and sink, granite countertops, and a view of a dining area.",
        "public_id": "019fce03-0622-76fb-9096-9b9b468630f7",
        "storage_key": "property/6767906449166332/019fce03-0622-76fb-9096-9b9b468630f7.webp",
        "width": 1433,
        "height": 955
      },
      "title": "Apartment",
      "description": "Modern apartment kitchen with gray cabinets, granite countertops, and stainless-steel appliances opens to a blue-accent dining space.",
      "link": "",
      "alt_text": "Galley kitchen with gray cabinets, granite countertops, stainless appliances, and a doorway to a blue dining area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/35bad03d/dms3rep/multi/5767906449162442/6767906449166332/0847d4dd96af13deb9accfdeea93cc66.jpg"
    },
    {
      "id": "custom_3fb96c3e-8362-46d7-bb0c-f807ca379bdf",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166332",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/019fce03-07f6-7128-9831-1f41b19ef903.webp",
      "image_media": {
        "alt_text": "A staged bedroom with a bed, dresser, mirror, ceiling fan, and closet.",
        "public_id": "019fce03-07f6-7128-9831-1f41b19ef903",
        "storage_key": "property/6767906449166332/019fce03-07f6-7128-9831-1f41b19ef903.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "A modern, neutral-toned bedroom in a multifamily community showing a queen bed, wooden dresser, and ample closet space.",
      "link": "",
      "alt_text": "Bedroom in an apartment with a bed, dresser, round mirror, ceiling fan, and closet doors.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/35bad03d/dms3rep/multi/5767906449162442/6767906449166332/58cc808fa270a027644bb9783287ee97.webp"
    },
    {
      "id": "custom_a968ab1b-2f44-49fc-8a49-6a684e60f511",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166332",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/019fce03-085c-73ef-a4ef-b432af0ef6ec.webp",
      "image_media": {
        "alt_text": "Bedroom with a queen-size bed, patterned comforter, and a ceiling fan.",
        "public_id": "019fce03-085c-73ef-a4ef-b432af0ef6ec",
        "storage_key": "property/6767906449166332/019fce03-085c-73ef-a4ef-b432af0ef6ec.webp",
        "width": 1486,
        "height": 991
      },
      "title": "Apartment",
      "description": "A cozy, modern apartment bedroom with a natural wood bed frame, neutral decor, and soft bedside lighting.",
      "link": "",
      "alt_text": "Bedroom interior in a modern apartment with a wooden bed frame, two nightstands, and soft lighting.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/35bad03d/dms3rep/multi/5767906449162442/6767906449166332/df9547f3f38dec8230acffd36e8d343b.jpg"
    },
    {
      "id": "custom_baac9d9a-d22a-46ba-a700-96dd53852e85",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166332",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/019fce03-109f-72ae-bd63-ae6cd3f6c900.webp",
      "image_media": {
        "alt_text": "Modern bathroom with vanity, toilet, and shower/tub combo.",
        "public_id": "019fce03-109f-72ae-bd63-ae6cd3f6c900",
        "storage_key": "property/6767906449166332/019fce03-109f-72ae-bd63-ae6cd3f6c900.webp",
        "width": 1486,
        "height": 991
      },
      "title": "Apartment",
      "description": "Bright apartment bathroom with a tub/shower, curved rod, and white fixtures.",
      "link": "",
      "alt_text": "Bathroom with tub/shower, curved shower rod, white fixtures and sink.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/35bad03d/dms3rep/multi/5767906449162442/6767906449166332/3197ce87c0db6f8e1efbb2d0952841e8.jpg"
    },
    {
      "id": "custom_0f82001c-0dfd-43d2-a6ee-b95ed1064f5b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166332",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/019fce03-1212-703f-a78e-26585541a754.webp",
      "image_media": {
        "alt_text": "Modern living room with gray carpet, white sofa, two armchairs, coffee table, and TV.",
        "public_id": "019fce03-1212-703f-a78e-26585541a754",
        "storage_key": "property/6767906449166332/019fce03-1212-703f-a78e-26585541a754.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Experience comfortable living in this stylish apartment featuring a spacious living room with elegant furnishings and entertainment center.",
      "link": "",
      "alt_text": "Living room in a modern apartment with sofa, two armchairs, a coffee table, and a hallway doorway.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/35bad03d/dms3rep/multi/5767906449162442/6767906449166332/6786075faeddda11958fac16e7fcf132.webp"
    },
    {
      "id": "custom_77269ebf-f149-4c32-b24f-85d4482d152b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166332",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/019fce03-1337-7337-b92b-f3217678933c.webp",
      "image_media": {
        "alt_text": "Bedroom with a king-size bed, dresser, and en-suite bathroom.",
        "public_id": "019fce03-1337-7337-b92b-f3217678933c",
        "storage_key": "property/6767906449166332/019fce03-1337-7337-b92b-f3217678933c.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a comfortable king-size bed, a modern dresser, and direct access to an en-suite bathroom. Perfect for relaxation and rest.",
      "link": "",
      "alt_text": "Bedroom in an apartment with a large bed, wooden dresser, ceiling fan, and doorway to a bathroom.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/35bad03d/dms3rep/multi/5767906449162442/6767906449166332/c7649399c321556271c1b2d76106bf5e.webp"
    },
    {
      "id": "custom_d4dd6ec0-46b8-4674-9a5d-ea30897c92a0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166332",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/019fce03-1af4-702d-bedb-d63c22c614ac.webp",
      "image_media": {
        "alt_text": "Bar seating around a high-top table with a view of the outdoor swimming pool.",
        "public_id": "019fce03-1af4-702d-bedb-d63c22c614ac",
        "storage_key": "property/6767906449166332/019fce03-1af4-702d-bedb-d63c22c614ac.webp",
        "width": 1453,
        "height": 969
      },
      "title": "Community",
      "description": "Bright dining area in a modern apartment with a large window showing the pool outside.",
      "link": "",
      "alt_text": "Dining area in a modern apartment with a dark wood table and metal chairs, pool visible through a large window.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/35bad03d/dms3rep/multi/5767906449162442/6767906449166332/759f465a05410dfa4eedc57525da4b4e.jpg"
    },
    {
      "id": "custom_57d4d484-176a-4c1a-8dd5-4c2d83075d5c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166332",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/019fce03-1e32-76d4-b6fc-371c78f9c42c.webp",
      "image_media": {
        "alt_text": "Balcony with two chairs, a small table, and a plant overlooking apartment buildings and trees.",
        "public_id": "019fce03-1e32-76d4-b6fc-371c78f9c42c",
        "storage_key": "property/6767906449166332/019fce03-1e32-76d4-b6fc-371c78f9c42c.webp",
        "width": 1486,
        "height": 991
      },
      "title": "Apartment",
      "description": "Enjoy your morning coffee or evening relaxation on this private balcony, offering scenic views of the surrounding greenery and community.",
      "link": "",
      "alt_text": "Balcony seating with two black wicker chairs, a small table, cushions, and a plant, overlooking a residential complex.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/35bad03d/dms3rep/multi/5767906449162442/6767906449166332/fbd7bf3e25c4f915bc679ea01efad5f7.jpg"
    },
    {
      "id": "custom_16b8b0c3-bbe7-4aeb-9750-554c17878db4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166332",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/019fce03-2bda-7555-b6e1-a1df4b837254.webp",
      "image_media": {
        "alt_text": "Commercial laundry room with washers and dryers.",
        "public_id": "019fce03-2bda-7555-b6e1-a1df4b837254",
        "storage_key": "property/6767906449166332/019fce03-2bda-7555-b6e1-a1df4b837254.webp",
        "width": 1426,
        "height": 951
      },
      "title": "Community",
      "description": "A functional apartment community laundry room with multiple washers and dryers in a bright, utilitarian space.",
      "link": "",
      "alt_text": "Laundry room with several top-loading washers and front-loading dryers.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/35bad03d/dms3rep/multi/5767906449162442/6767906449166332/84d4590be9a25bed7455ed78b9dfb99f.jpg"
    },
    {
      "id": "custom_f11036a5-84d5-48ff-91fc-b2d40acf0f4d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166332",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/019fce03-35ed-7558-9eb2-877e80debb2c.webp",
      "image_media": {
        "alt_text": "Exterior view of a brick apartment building with balconies and a well-maintained lawn.",
        "public_id": "019fce03-35ed-7558-9eb2-877e80debb2c",
        "storage_key": "property/6767906449166332/019fce03-35ed-7558-9eb2-877e80debb2c.webp",
        "width": 1469,
        "height": 979
      },
      "title": "Community",
      "description": "Exterior shot of a multi-story brick apartment building with balconies and a manicured lawn, illustrating the community outdoor space.",
      "link": "",
      "alt_text": "Exterior view of brick apartment building with balconies and a green lawn courtyard.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/35bad03d/dms3rep/multi/5767906449162442/6767906449166332/0db1d942d842e75180db6f5ffc85a99c.jpg"
    },
    {
      "id": "custom_c1d54823-16ca-4eef-a31e-e05138e2e7cf",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166332",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/019fce03-397a-724b-a38f-8e865681686b.webp",
      "image_media": {
        "alt_text": "Exterior view of the apartment building with balconies and green lawn.",
        "public_id": "019fce03-397a-724b-a38f-8e865681686b",
        "storage_key": "property/6767906449166332/019fce03-397a-724b-a38f-8e865681686b.webp",
        "width": 1393,
        "height": 929
      },
      "title": "Community",
      "description": "Charming apartment building exterior featuring individual balconies, lush green lawns, and mature trees, creating a welcoming atmosphere.",
      "link": "",
      "alt_text": "Exterior view of a brick apartment building with balconies and a grassy lawn.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/35bad03d/dms3rep/multi/5767906449162442/6767906449166332/b3072442510dce7cc97ebb0737e62d64.jpg"
    },
    {
      "id": "custom_66b4b979-67ef-4495-a833-75da889bfd93",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166332",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/01a15f65-9c23-71ae-999e-fd0c78c267a2.webp",
      "image_media": {
        "alt_text": "Bedroom with a queen-sized bed, dresser, and window.",
        "public_id": "01a15f65-9c23-71ae-999e-fd0c78c267a2",
        "storage_key": "property/6767906449166332/01a15f65-9c23-71ae-999e-fd0c78c267a2.webp",
        "width": 3072,
        "height": 2061
      },
      "title": "Apartment",
      "description": "Relax in this beautifully appointed bedroom, featuring a comfortable queen-sized bed, ample storage, and a large window for natural light.",
      "link": "",
      "alt_text": "Bedroom with a queen-sized bed, dresser, and window.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_577ae7eb-2fae-4008-892c-01c12208ad83",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166332",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/01a15f65-9bcb-712c-89ab-0228a43262bc.webp",
      "image_media": {
        "alt_text": "Spacious living room with a modern gray sectional sofa, a dining area with a wooden table and green chairs, and a wall-mounted TV.",
        "public_id": "01a15f65-9bcb-712c-89ab-0228a43262bc",
        "storage_key": "property/6767906449166332/01a15f65-9bcb-712c-89ab-0228a43262bc.webp",
        "width": 3072,
        "height": 2061
      },
      "title": "Apartment",
      "description": "Relax in style in this beautifully appointed living room, featuring comfortable seating, a dedicated dining space, and an entertainment center.",
      "link": "",
      "alt_text": "Spacious living room with a modern gray sectional sofa, a dining area with a wooden table and green chairs, and a wall-mounted TV.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_a16605be-ac00-41c0-a26d-f7d0f1b5ca47",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166332",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/01a15f65-8512-700c-a96e-63ec3c3fe190.webp",
      "image_media": {
        "alt_text": "Spacious living room and dining area with modern furniture and decor.",
        "public_id": "01a15f65-8512-700c-a96e-63ec3c3fe190",
        "storage_key": "property/6767906449166332/01a15f65-8512-700c-a96e-63ec3c3fe190.webp",
        "width": 3072,
        "height": 2061
      },
      "title": "Apartment",
      "description": "Experience comfort and style in this beautifully appointed living and dining area, perfect for relaxation and entertaining guests.",
      "link": "",
      "alt_text": "Spacious living room and dining area with modern furniture and decor.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_24cfcec0-8e1c-470c-9f12-06e699d9ac23",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166332",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/01a15f65-77cc-722b-b12e-98657bcd786f.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with parking lot and mature trees.",
        "public_id": "01a15f65-77cc-722b-b12e-98657bcd786f",
        "storage_key": "property/6767906449166332/01a15f65-77cc-722b-b12e-98657bcd786f.webp",
        "width": 3072,
        "height": 2044
      },
      "title": "Community",
      "description": "Charming exterior of apartment buildings, featuring private entrances, well-maintained landscaping, and convenient parking.",
      "link": "",
      "alt_text": "Exterior view of apartment buildings with parking lot and mature trees.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_3d6fd47c-b239-4194-9313-42d93fc8c760",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166332",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/01a15f65-753a-7629-90d3-e553ed18c226.webp",
      "image_media": {
        "alt_text": "Dog park with a fence and a sign that says 'welcome to the DOG PARK'.",
        "public_id": "01a15f65-753a-7629-90d3-e553ed18c226",
        "storage_key": "property/6767906449166332/01a15f65-753a-7629-90d3-e553ed18c226.webp",
        "width": 3072,
        "height": 2044
      },
      "title": "Community",
      "description": "A dedicated dog park area for residents to enjoy with their pets, featuring amenities for canine fun and safety.",
      "link": "",
      "alt_text": "Dog park with a fence and a sign that says 'welcome to the DOG PARK'.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_7ba3f861-05c9-406b-89d0-3c17ec54bf9a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166332",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/01a15f65-739c-72cb-be96-308bb04d108b.webp",
      "image_media": {
        "alt_text": "Washer and dryer in a closet.",
        "public_id": "01a15f65-739c-72cb-be96-308bb04d108b",
        "storage_key": "property/6767906449166332/01a15f65-739c-72cb-be96-308bb04d108b.webp",
        "width": 3072,
        "height": 2044
      },
      "title": "Apartment",
      "description": "In-unit washer and dryer for your convenience.",
      "link": "",
      "alt_text": "Washer and dryer in a closet.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_ec756cc2-3ad7-497b-90fe-5a10f854f54c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166332",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/01a15f65-566a-743e-a392-3c450ac5bfd6.webp",
      "image_media": {
        "alt_text": "Bedroom with a king-size bed, nightstands, dresser, and a ceiling fan.",
        "public_id": "01a15f65-566a-743e-a392-3c450ac5bfd6",
        "storage_key": "property/6767906449166332/01a15f65-566a-743e-a392-3c450ac5bfd6.webp",
        "width": 3072,
        "height": 2061
      },
      "title": "Apartment",
      "description": "Relax in comfort in this beautifully appointed bedroom, featuring a plush king-size bed, elegant nightstands, and ample dresser storage. A ceiling fan ensures year-round comfort.",
      "link": "",
      "alt_text": "Bedroom with a king-size bed, nightstands, dresser, and a ceiling fan.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_99ef1a97-07cf-4578-ab8e-f343e4f7b490",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166332",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/01a15f65-6fa8-7404-a1ac-de70a2a5986c.webp",
      "image_media": {
        "alt_text": "Stackable washer and dryer next to a bathtub and toilet in a bathroom.",
        "public_id": "01a15f65-6fa8-7404-a1ac-de70a2a5986c",
        "storage_key": "property/6767906449166332/01a15f65-6fa8-7404-a1ac-de70a2a5986c.webp",
        "width": 3072,
        "height": 2044
      },
      "title": "Apartment",
      "description": "This bathroom features a stacked washer and dryer combo, a toilet, and a bathtub with a shower head. The space is well-lit and has modern finishes.",
      "link": "",
      "alt_text": "Stackable washer and dryer next to a bathtub and toilet in a bathroom.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_2158dc79-feee-4ad9-b7ef-d310937e50fb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166332",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/01a15f65-5caf-75bd-a36f-61fda8cd9212.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white cabinets, granite countertops, and black appliances.",
        "public_id": "01a15f65-5caf-75bd-a36f-61fda8cd9212",
        "storage_key": "property/6767906449166332/01a15f65-5caf-75bd-a36f-61fda8cd9212.webp",
        "width": 3072,
        "height": 2061
      },
      "title": "Apartment",
      "description": "Renovated kitchen featuring sleek white cabinetry, durable granite countertops, and a full suite of black appliances including a microwave, dishwasher, and stove.",
      "link": "",
      "alt_text": "Modern kitchen with white cabinets, granite countertops, and black appliances.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_c84c48d9-de56-44c5-98e5-68d32fd59cdb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166332",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/01a15f65-47f8-76cd-8ed9-93f6cb16cb66.webp",
      "image_media": {
        "alt_text": "Tennis and basketball court with surrounding trees and apartment buildings.",
        "public_id": "01a15f65-47f8-76cd-8ed9-93f6cb16cb66",
        "storage_key": "property/6767906449166332/01a15f65-47f8-76cd-8ed9-93f6cb16cb66.webp",
        "width": 3072,
        "height": 2044
      },
      "title": "Community",
      "description": "Enjoy a game of tennis or basketball on our full-size court. Perfect for staying active and having fun outdoors.",
      "link": "",
      "alt_text": "Tennis and basketball court with surrounding trees and apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_93c84647-1f2a-49de-815b-760a82b98d8f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166332",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/01a15f65-5222-74fc-8789-541993aaf2f6.webp",
      "image_media": {
        "alt_text": "Modern apartment kitchen with white cabinets, subway tile backsplash, stainless steel appliances, and granite countertops.",
        "public_id": "01a15f65-5222-74fc-8789-541993aaf2f6",
        "storage_key": "property/6767906449166332/01a15f65-5222-74fc-8789-541993aaf2f6.webp",
        "width": 3072,
        "height": 2044
      },
      "title": "Apartment",
      "description": "Step into this beautifully updated apartment kitchen, featuring sleek white cabinetry, a classic subway tile backsplash, and elegant granite countertops. The space is equipped with modern stainless steel appliances, including a dishwasher, stove, microwave, and refrigerator, perfect for all your culinary needs.",
      "link": "",
      "alt_text": "Modern apartment kitchen with white cabinets, subway tile backsplash, stainless steel appliances, and granite countertops.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_c17cc6c2-b1a4-40f6-8d39-a8f397565dc3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166332",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/01a15f65-5db5-713a-98fb-b4fe7ae21631.webp",
      "image_media": {
        "alt_text": "Modern bathroom with vanity, mirror, walk-in closet, and toilet.",
        "public_id": "01a15f65-5db5-713a-98fb-b4fe7ae21631",
        "storage_key": "property/6767906449166332/01a15f65-5db5-713a-98fb-b4fe7ae21631.webp",
        "width": 3072,
        "height": 2044
      },
      "title": "Apartment",
      "description": "Step into this stylish bathroom featuring a sleek vanity with a modern faucet, a spacious walk-in closet with built-in shelving, and a separate toilet area. Perfect for your daily routine.",
      "link": "",
      "alt_text": "Modern bathroom with vanity, mirror, walk-in closet, and toilet.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_4b55373c-4481-4162-845f-f5116d7b975c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166332",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/01a15f65-5825-7457-9dbe-540cd28748e1.webp",
      "image_media": {
        "alt_text": "Treadmills and exercise machines in a well-lit fitness center.",
        "public_id": "01a15f65-5825-7457-9dbe-540cd28748e1",
        "storage_key": "property/6767906449166332/01a15f65-5825-7457-9dbe-540cd28748e1.webp",
        "width": 3072,
        "height": 2044
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, equipped with cardio machines and strength-training equipment.",
      "link": "",
      "alt_text": "Treadmills and exercise machines in a well-lit fitness center.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_7a0a5d94-69e4-4702-b1ae-902c56b1b051",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166332",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/01a15f65-361c-7538-8694-905200d20288.webp",
      "image_media": {
        "alt_text": "Playground with swings and climbing structures.",
        "public_id": "01a15f65-361c-7538-8694-905200d20288",
        "storage_key": "property/6767906449166332/01a15f65-361c-7538-8694-905200d20288.webp",
        "width": 3072,
        "height": 2044
      },
      "title": "Community",
      "description": "Enjoy outdoor fun at our community playground, featuring a climbing net, slides, and swings for all ages.",
      "link": "",
      "alt_text": "Playground with swings and climbing structures.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_61f722e8-a8c9-47aa-b7b6-c553b39b275a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166332",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/01a15f65-50c7-7518-bc0d-b7e76645f265.webp",
      "image_media": {
        "alt_text": "Welcome flag at Avalon Apartment building entrance with stairs and landscaping.",
        "public_id": "01a15f65-50c7-7518-bc0d-b7e76645f265",
        "storage_key": "property/6767906449166332/01a15f65-50c7-7518-bc0d-b7e76645f265.webp",
        "width": 3072,
        "height": 2044
      },
      "title": "Community",
      "description": "Welcome guests with this striking flag at the Avalon Apartment community entrance. Beautiful landscaping and building architecture create an inviting first impression.",
      "link": "",
      "alt_text": "Welcome flag at Avalon Apartment building entrance with stairs and landscaping.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_fa86a0a6-962d-4e57-a55c-42ec324974b5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166332",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/01a15f65-3430-771f-ba32-e5162668e8d7.webp",
      "image_media": {
        "alt_text": "Pergola with benches and pool area in the background.",
        "public_id": "01a15f65-3430-771f-ba32-e5162668e8d7",
        "storage_key": "property/6767906449166332/01a15f65-3430-771f-ba32-e5162668e8d7.webp",
        "width": 3072,
        "height": 2044
      },
      "title": "Community",
      "description": "Relax under the shade of our charming pergola, complete with comfortable benches, and enjoy the view of the sparkling pool and lush landscaping.",
      "link": "",
      "alt_text": "Pergola with benches and pool area in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_e321d034-5912-4267-ad98-815e74b49741",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166332",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/01a15f65-2e6f-734f-9425-e966f39c8a44.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas next to brick buildings.",
        "public_id": "01a15f65-2e6f-734f-9425-e966f39c8a44",
        "storage_key": "property/6767906449166332/01a15f65-2e6f-734f-9425-e966f39c8a44.webp",
        "width": 3072,
        "height": 2044
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling swimming pool, surrounded by comfortable lounge chairs and vibrant umbrellas. Perfect for relaxing and soaking up the sun.",
      "link": "",
      "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas next to brick buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_4f930827-9a0d-4d23-876e-c54e520212ad",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166332",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/01a15f65-2c02-779c-b35e-516271aa0592.webp",
      "image_media": {
        "alt_text": "Outdoor picnic area with grills, tables, and a tennis court.",
        "public_id": "01a15f65-2c02-779c-b35e-516271aa0592",
        "storage_key": "property/6767906449166332/01a15f65-2c02-779c-b35e-516271aa0592.webp",
        "width": 3072,
        "height": 2044
      },
      "title": "Community",
      "description": "Enjoy al fresco dining and recreation with our outdoor picnic area, featuring grilling stations, comfortable seating, and a sports court.",
      "link": "",
      "alt_text": "Outdoor picnic area with grills, tables, and a tennis court.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_d633907f-46c0-4538-9be8-8ff07a145475",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166332",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/01a15f65-2e70-763a-b209-5c7833b1f226.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with orange lounge chairs and umbrellas",
        "public_id": "01a15f65-2e70-763a-b209-5c7833b1f226",
        "storage_key": "property/6767906449166332/01a15f65-2e70-763a-b209-5c7833b1f226.webp",
        "width": 3072,
        "height": 2044
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling swimming pool, surrounded by comfortable lounge chairs and vibrant orange umbrellas. Perfect for relaxing or soaking up the sun on a warm day.",
      "link": "",
      "alt_text": "Resort-style swimming pool with orange lounge chairs and umbrellas",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_6791eedd-120b-45d8-beb1-ac722aff97ba",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166332",
      "source": "custom",
      "poi_name": "Forager Coffee + Tea",
      "poi_type": "Restaurants",
      "poi_address": "122 Main St, Milford, OH 45150, USA",
      "poi_short_description": "Trendy, homey coffee shop dishing up espresso drinks and teas, plus pastries and baked goods, including vegan options.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/019fce03-4cfe-7701-b252-817712f502a2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce03-4cfe-7701-b252-817712f502a2",
        "storage_key": "property/6767906449166332/019fce03-4cfe-7701-b252-817712f502a2.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "http://www.foragercoffeetea.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5626601240556679281&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "forager-coffee--tea",
      "poi_latitude": "39.1734772",
      "poi_longitude": "-84.2956865",
      "poi_miles_from_property": "5.6 mi",
      "poi_walking_minutes": "2 hours 0 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 513-248-0042",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/019d0269-0f2e-774a-b3d3-b84bb20df575.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-0f2e-774a-b3d3-b84bb20df575",
        "storage_key": "property/6767906449166332/019d0269-0f2e-774a-b3d3-b84bb20df575.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJDYp5W42rQYgRcTAnbAS0FU4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_d8f7f547-b101-4fa4-afbb-248803396bf2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166332",
      "source": "custom",
      "poi_name": "May Cafe",
      "poi_type": "Restaurants",
      "poi_address": "5 Main St, Milford, OH 45150, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/019fce03-4c42-70ce-81d2-1537572c5891.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce03-4c42-70ce-81d2-1537572c5891",
        "storage_key": "property/6767906449166332/019fce03-4c42-70ce-81d2-1537572c5891.webp",
        "width": 1280,
        "height": 606
      },
      "poi_business_url": "http://maycafemilford.com/?redirect=false",
      "poi_directions_map_url": "https://maps.google.com/?cid=11499956213517259460&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "may-cafe",
      "poi_latitude": "39.1722121",
      "poi_longitude": "-84.2966308",
      "poi_miles_from_property": "5.7 mi",
      "poi_walking_minutes": "2 hours 3 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 513-831-2233",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/019d0269-0f2e-774a-b3d3-b84bb20df575.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-0f2e-774a-b3d3-b84bb20df575",
        "storage_key": "property/6767906449166332/019d0269-0f2e-774a-b3d3-b84bb20df575.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJ4W5gSs-qQYgRxBI-Lz8NmJ8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_2dce7ed3-f93f-4cb4-bed4-18db214ba366",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166332",
      "source": "custom",
      "poi_name": "The Governor",
      "poi_type": "Restaurants",
      "poi_address": "231 Main St, Milford, OH 45150, USA",
      "poi_short_description": "Modern diner and bar offering an eclectic menu of comfort food for breakfast, lunch, and dinner.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/019fce03-4d2d-7520-999c-dbdc341bf42d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce03-4d2d-7520-999c-dbdc341bf42d",
        "storage_key": "property/6767906449166332/019fce03-4d2d-7520-999c-dbdc341bf42d.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "http://www.governordiner.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18009159962817009561&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-governor",
      "poi_latitude": "39.17462310000001",
      "poi_longitude": "-84.2956102",
      "poi_miles_from_property": "5.5 mi",
      "poi_walking_minutes": "1 hour 59 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 513-239-8298",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/019d0269-0f2b-73fd-8fff-efa424df2120.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-0f2b-73fd-8fff-efa424df2120",
        "storage_key": "property/6767906449166332/019d0269-0f2b-73fd-8fff-efa424df2120.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJJ2kWGdirQYgRmRflzpFj7fk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_a73bc1db-afa8-4032-b0e8-9f9ca967cc5f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166332",
      "source": "custom",
      "poi_name": "20 Brix",
      "poi_type": "Restaurants",
      "poi_address": "101 Main St, Milford, OH 45150, USA",
      "poi_short_description": "Classy wine bar & eatery offering modern American dishes with Mediterranean flair plus a wine store.",
      "poi_long_description": "Classy wine bar & eatery offering modern American dishes with Mediterranean flair plus a wine store.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/019fce03-4cb0-7513-9a3a-cedf65798c26.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce03-4cb0-7513-9a3a-cedf65798c26",
        "storage_key": "property/6767906449166332/019fce03-4cb0-7513-9a3a-cedf65798c26.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.20brix.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13656248144761367337&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "20-brix",
      "poi_latitude": "39.173006",
      "poi_longitude": "-84.296392",
      "poi_miles_from_property": "5.6 mi",
      "poi_walking_minutes": "2 hours 1 min",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 513-831-2749",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/019d0269-0f2b-73fd-8fff-efa424df2120.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-0f2b-73fd-8fff-efa424df2120",
        "storage_key": "property/6767906449166332/019d0269-0f2b-73fd-8fff-efa424df2120.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1fC30siqQYgRKasWcVW9hL0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_efecb649-f81a-4229-9054-b00d982d271f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166332",
      "source": "custom",
      "poi_name": "Padrino",
      "poi_type": "Restaurants",
      "poi_address": "111 Main St, Milford, OH 45150, USA",
      "poi_short_description": "Casual parlor known for dishing specialty pizzas, pastas, salads & drinks in a vintage building.",
      "poi_long_description": "Casual parlor known for dishing specialty pizzas, pastas, salads & drinks in a vintage building.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/019fce03-52e2-77b9-91fd-3d9dc793bef6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce03-52e2-77b9-91fd-3d9dc793bef6",
        "storage_key": "property/6767906449166332/019fce03-52e2-77b9-91fd-3d9dc793bef6.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.padrinoitalian.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5604086702173028052&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "padrino",
      "poi_latitude": "39.1732483",
      "poi_longitude": "-84.2961883",
      "poi_miles_from_property": "5.6 mi",
      "poi_walking_minutes": "2 hours 1 min",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 513-965-0100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/019d0269-0f2b-73fd-8fff-efa424df2120.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-0f2b-73fd-8fff-efa424df2120",
        "storage_key": "property/6767906449166332/019d0269-0f2b-73fd-8fff-efa424df2120.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJkxBC1MiqQYgR1H6D9Sm3xU0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_3041c26d-5987-49a0-a043-358a290c7f18",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166332",
      "source": "custom",
      "poi_name": "Little Miami Brewing Company",
      "poi_type": "Restaurants",
      "poi_address": "208 Mill St, Milford, OH 45150, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/019fce03-5247-717f-88a5-44d8c3ebe069.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce03-5247-717f-88a5-44d8c3ebe069",
        "storage_key": "property/6767906449166332/019fce03-5247-717f-88a5-44d8c3ebe069.webp",
        "width": 992,
        "height": 558
      },
      "poi_business_url": "https://www.littlemiamibrewing.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8799920786167992783&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "little-miami-brewing-company",
      "poi_latitude": "39.1718142",
      "poi_longitude": "-84.2975962",
      "poi_miles_from_property": "5.7 mi",
      "poi_walking_minutes": "2 hours 5 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 513-713-1121",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/019d0269-0f2a-7174-a857-44a9586e5de6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-0f2a-7174-a857-44a9586e5de6",
        "storage_key": "property/6767906449166332/019d0269-0f2a-7174-a857-44a9586e5de6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJm-z-Q8-qQYgRz5Eev1SZH3o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_8d357af5-125f-4cc5-9bc6-b421baf8b44b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166332",
      "source": "custom",
      "poi_name": "Cincinnati Distilling",
      "poi_type": "Restaurants",
      "poi_address": "203 Mill St, Milford, OH 45150, USA",
      "poi_short_description": "Historic mill offering craft spirits and cocktails, plus a dining room and rooftop bar.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/019fce03-53b7-7338-8bf2-b42e6c2cdcdf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce03-53b7-7338-8bf2-b42e6c2cdcdf",
        "storage_key": "property/6767906449166332/019fce03-53b7-7338-8bf2-b42e6c2cdcdf.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "http://cincinnatidistilling.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15913011562542191938&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cincinnati-distilling",
      "poi_latitude": "39.1721246",
      "poi_longitude": "-84.2969509",
      "poi_miles_from_property": "5.7 mi",
      "poi_walking_minutes": "2 hours 3 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 513-378-5580",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/019d0269-0f2b-73fd-8fff-efa424df2120.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-0f2b-73fd-8fff-efa424df2120",
        "storage_key": "property/6767906449166332/019d0269-0f2b-73fd-8fff-efa424df2120.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJYQxlgRarQYgRQtUClLRf1tw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_10351072-e168-497f-8bb5-d049a35c669a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166332",
      "source": "custom",
      "poi_name": "Nation Kitchen & Bar Milford",
      "poi_type": "Restaurants",
      "poi_address": "203 Mill St, Milford, OH 45150, USA",
      "poi_short_description": "Energetic, relaxed eatery serving burgers and fries (and a deal for both), along with cocktails.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/019fce03-53c6-7440-8371-a5e7138db165.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce03-53c6-7440-8371-a5e7138db165",
        "storage_key": "property/6767906449166332/019fce03-53c6-7440-8371-a5e7138db165.webp",
        "width": 1280,
        "height": 850
      },
      "poi_business_url": "http://nationkitchenandbar.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1334568202037908454&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "nation-kitchen--bar-milford",
      "poi_latitude": "39.1723312",
      "poi_longitude": "-84.29723",
      "poi_miles_from_property": "5.7 mi",
      "poi_walking_minutes": "2 hours 4 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 513-248-0327",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/019d0269-0f2b-73fd-8fff-efa424df2120.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-0f2b-73fd-8fff-efa424df2120",
        "storage_key": "property/6767906449166332/019d0269-0f2b-73fd-8fff-efa424df2120.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJXeukGQarQYgR5lMAe7VWhRI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_0fe38f80-1554-4cea-859d-500e8a0b3beb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166332",
      "source": "custom",
      "poi_name": "Copper Blue",
      "poi_type": "Restaurants",
      "poi_address": "900 Main St, Milford, OH 45150, USA",
      "poi_short_description": "Relaxed, contemporary spot offering down-home, scratch-made American eats, craft brews & cocktails.",
      "poi_long_description": "Relaxed, contemporary spot offering down-home, scratch-made American eats, craft brews & cocktails.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/019fce03-57d7-7649-85c6-00eaacbc1de9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce03-57d7-7649-85c6-00eaacbc1de9",
        "storage_key": "property/6767906449166332/019fce03-57d7-7649-85c6-00eaacbc1de9.webp",
        "width": 1280,
        "height": 623
      },
      "poi_business_url": "https://copperbluemilford.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9658537509934623573&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "copper-blue",
      "poi_latitude": "39.1776798",
      "poi_longitude": "-84.28025950000001",
      "poi_miles_from_property": "4.7 mi",
      "poi_walking_minutes": "1 hour 41 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 513-248-1500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/019d0269-0f2b-73fd-8fff-efa424df2120.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-0f2b-73fd-8fff-efa424df2120",
        "storage_key": "property/6767906449166332/019d0269-0f2b-73fd-8fff-efa424df2120.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJBR1Igq2qQYgRVWtwMbEECoY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_199ab32d-ec46-46a6-aff8-c66a5d67149d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166332",
      "source": "custom",
      "poi_name": "Uncle Nai's Thai and Sushi",
      "poi_type": "Restaurants",
      "poi_address": "223 B Main St Old, Milford, OH 45150, USA",
      "poi_short_description": "Casual restaurant offering sushi, tempura, and other Japanese fare, plus Thai dishes.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/019fce03-59b7-7488-adfd-8d882e608919.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce03-59b7-7488-adfd-8d882e608919",
        "storage_key": "property/6767906449166332/019fce03-59b7-7488-adfd-8d882e608919.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://uncle-nai.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1692235211249732709&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "uncle-nais-thai-and-sushi",
      "poi_latitude": "39.1744821",
      "poi_longitude": "-84.2956118",
      "poi_miles_from_property": "5.5 mi",
      "poi_walking_minutes": "1 hour 59 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 513-444-4118",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/019d0269-0f2b-73fd-8fff-efa424df2120.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-0f2b-73fd-8fff-efa424df2120",
        "storage_key": "property/6767906449166332/019d0269-0f2b-73fd-8fff-efa424df2120.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJg2Jzg36rQYgRZczycvUGfBc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_fbc0d0de-46df-476e-b3ee-ffd7d3e47193",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166332",
      "source": "custom",
      "poi_name": "Bite Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "1279 OH-131, Milford, OH 45150, USA",
      "poi_short_description": "Quaint BYOB eatery offering organic mains & housemade desserts in rustic surrounds.",
      "poi_long_description": "Quaint BYOB eatery offering organic mains & housemade desserts in rustic surrounds.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/019fce03-5ab6-7488-9fd4-8eddb1add5d7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce03-5ab6-7488-9fd4-8eddb1add5d7",
        "storage_key": "property/6767906449166332/019fce03-5ab6-7488-9fd4-8eddb1add5d7.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.bitefoodie.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3941435085481067370&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bite-restaurant",
      "poi_latitude": "39.1758008",
      "poi_longitude": "-84.22337850000001",
      "poi_miles_from_property": "2.9 mi",
      "poi_walking_minutes": "1 hour 6 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 513-831-2483",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/019d0269-0f2b-73fd-8fff-efa424df2120.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-0f2b-73fd-8fff-efa424df2120",
        "storage_key": "property/6767906449166332/019d0269-0f2b-73fd-8fff-efa424df2120.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJp1HNz9UBQYgRakNc31PKsjY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_8fd0afe8-2254-4d77-99d0-fb06377a59f7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166332",
      "source": "custom",
      "poi_name": "By Golly's Milford",
      "poi_type": "Restaurants",
      "poi_address": "714 Lila Ave, Milford, OH 45150, USA",
      "poi_short_description": "Unassuming local bar & grill offering diverse pub food, live music & karaoke, plus a covered patio.",
      "poi_long_description": "Unassuming local bar & grill offering diverse pub food, live music & karaoke, plus a covered patio.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/019fce03-5abd-76fe-884e-64a8e040ef95.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce03-5abd-76fe-884e-64a8e040ef95",
        "storage_key": "property/6767906449166332/019fce03-5abd-76fe-884e-64a8e040ef95.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://bygollys.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16983968289408627515&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "by-gollys-milford",
      "poi_latitude": "39.1764912",
      "poi_longitude": "-84.28621",
      "poi_miles_from_property": "4.9 mi",
      "poi_walking_minutes": "1 hour 46 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 513-248-4444",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/019d0269-0f22-7588-923c-c52c2dfdf699.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-0f22-7588-923c-c52c2dfdf699",
        "storage_key": "property/6767906449166332/019d0269-0f22-7588-923c-c52c2dfdf699.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJwTLADrSqQYgROzOzniwts-s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_076b9a3d-068e-4faa-8227-3039c403662a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166332",
      "source": "custom",
      "poi_name": "Pickles & Bones Barbecue and Catering",
      "poi_type": "Restaurants",
      "poi_address": "887a Business 28, Milford, OH 45150, USA",
      "poi_short_description": "Casual eatery specializing in slow-smoked barbecue staples, along with sides, beer and cocktails.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/019fce03-5e42-747e-96f7-4e295608689e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce03-5e42-747e-96f7-4e295608689e",
        "storage_key": "property/6767906449166332/019fce03-5e42-747e-96f7-4e295608689e.webp",
        "width": 1280,
        "height": 1008
      },
      "poi_business_url": "https://www.picklesandbones.com/?utm_source=google&utm_medium=wix_google_business_profile&utm_campaign=8675048759843419710",
      "poi_directions_map_url": "https://maps.google.com/?cid=9118043216917522278&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pickles--bones-barbecue-and-catering",
      "poi_latitude": "39.1903398",
      "poi_longitude": "-84.25456659999999",
      "poi_miles_from_property": "0.3 mi",
      "poi_walking_minutes": "8 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 513-317-2214",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/019d0269-0f2b-73fd-8fff-efa424df2120.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-0f2b-73fd-8fff-efa424df2120",
        "storage_key": "property/6767906449166332/019d0269-0f2b-73fd-8fff-efa424df2120.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ2QThMC7-QIgRZmcHD__LiX4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_8edbf634-fa36-45aa-aa10-696d60010860",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166332",
      "source": "custom",
      "poi_name": "Maya Mexican Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "985 Lila Ave, Milford, OH 45150, USA",
      "poi_short_description": "Casual Mexican restaurant & bar serving classic dishes & kids' meals in a simple strip-mall space.",
      "poi_long_description": "Casual Mexican restaurant & bar serving classic dishes & kids' meals in a simple strip-mall space.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/019fce03-5ffd-70cc-af0f-7c3a6a2f1bb0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce03-5ffd-70cc-af0f-7c3a6a2f1bb0",
        "storage_key": "property/6767906449166332/019fce03-5ffd-70cc-af0f-7c3a6a2f1bb0.webp",
        "width": 1280,
        "height": 714
      },
      "poi_business_url": "https://mayamexicanrestaurantmilfordoh.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17393821136848307960&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "maya-mexican-restaurant",
      "poi_latitude": "39.1749063",
      "poi_longitude": "-84.277005",
      "poi_miles_from_property": "4.4 mi",
      "poi_walking_minutes": "1 hour 34 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 513-831-4661",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/019d0269-0f2b-73fd-8fff-efa424df2120.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-0f2b-73fd-8fff-efa424df2120",
        "storage_key": "property/6767906449166332/019d0269-0f2b-73fd-8fff-efa424df2120.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8Z2zNKmqQYgR-EaG5CpEY_E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_5fa17e21-f1fc-4097-b2bf-6df4ed9507be",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166332",
      "source": "custom",
      "poi_name": "The Talon Tavern",
      "poi_type": "Restaurants",
      "poi_address": "1151 OH-131, Milford, OH 45150, USA",
      "poi_short_description": "Relaxed haunt offering beer and cocktails, plus bar fare such as pizza, karaoke, and live music.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/019fce03-60d4-76cd-b2a6-dec46fb90cd5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce03-60d4-76cd-b2a6-dec46fb90cd5",
        "storage_key": "property/6767906449166332/019fce03-60d4-76cd-b2a6-dec46fb90cd5.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://talontavern.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16749926917575392301&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-talon-tavern",
      "poi_latitude": "39.1745276",
      "poi_longitude": "-84.235053",
      "poi_miles_from_property": "2.3 mi",
      "poi_walking_minutes": "53 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 513-248-2148",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/019d0269-0f22-7588-923c-c52c2dfdf699.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-0f22-7588-923c-c52c2dfdf699",
        "storage_key": "property/6767906449166332/019d0269-0f22-7588-923c-c52c2dfdf699.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ31ueFykAQYgRLbzVX8mxc-g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_4715c849-8202-4c2c-abc5-ccb20979132c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166332",
      "source": "custom",
      "poi_name": "Meijer",
      "poi_type": "Shopping",
      "poi_address": "1082 State Rte 28, Milford, OH 45150, USA",
      "poi_short_description": "Chain retailer featuring brand-name groceries plus apparel, electronics & more.",
      "poi_long_description": "Chain retailer featuring brand-name groceries plus apparel, electronics & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/019fce03-60da-707a-8ef7-d2c00fb967fb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce03-60da-707a-8ef7-d2c00fb967fb",
        "storage_key": "property/6767906449166332/019fce03-60da-707a-8ef7-d2c00fb967fb.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.meijer.com/shopping/store-locator/157.html?cmpid=LM:Web::::05112021::GoogleGrocery",
      "poi_directions_map_url": "https://maps.google.com/?cid=9275836902426447210&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "meijer",
      "poi_latitude": "39.1967582",
      "poi_longitude": "-84.2372742",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 513-576-5500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/019d0269-152d-77ef-8180-822e698be595.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-152d-77ef-8180-822e698be595",
        "storage_key": "property/6767906449166332/019d0269-152d-77ef-8180-822e698be595.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJO5BSZ8j_QIgRao2Wa4RkuoA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_3e6825e3-d5fa-4fdf-b6f1-460b8923782d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166332",
      "source": "custom",
      "poi_name": "Kroger",
      "poi_type": "Shopping",
      "poi_address": "824 Main St, Milford, OH 45150, USA",
      "poi_short_description": "Large supermarket chain with deli & bakery departments, plus health & beauty products.",
      "poi_long_description": "Large supermarket chain with deli & bakery departments, plus health & beauty products.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/019fce03-6404-714d-8de2-5bcf2efb4a14.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce03-6404-714d-8de2-5bcf2efb4a14",
        "storage_key": "property/6767906449166332/019fce03-6404-714d-8de2-5bcf2efb4a14.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://www.kroger.com/stores/grocery/oh/milford/milford/014/00411?cid=loc_01400411_gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=16777180959384242028&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kroger",
      "poi_latitude": "39.1761065",
      "poi_longitude": "-84.280546",
      "poi_miles_from_property": "4.6 mi",
      "poi_walking_minutes": "1 hour 40 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 513-965-3640",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/019d0269-152d-77ef-8180-822e698be595.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-152d-77ef-8180-822e698be595",
        "storage_key": "property/6767906449166332/019d0269-152d-77ef-8180-822e698be595.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJQ3aaSc-qQYgRbIeLeDGF1Og",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_99dd2c60-806f-45a9-98e3-49093ed865f7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166332",
      "source": "custom",
      "poi_name": "ALDI",
      "poi_type": "Shopping",
      "poi_address": "5959 Lorven Dr, Milford, OH 45150, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/019fce03-6617-71c3-922f-a400cb550729.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce03-6617-71c3-922f-a400cb550729",
        "storage_key": "property/6767906449166332/019fce03-6617-71c3-922f-a400cb550729.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://stores.aldi.us/oh/milford/5959-lorven-dr?utm_source=google&utm_medium=local&utm_campaign=brand&utm_content=storepage_webclick",
      "poi_directions_map_url": "https://maps.google.com/?cid=16057252380367938217&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "aldi",
      "poi_latitude": "39.1959107",
      "poi_longitude": "-84.2297806",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "34 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 855-955-2534",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/019d0269-152d-77ef-8180-822e698be595.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-152d-77ef-8180-822e698be595",
        "storage_key": "property/6767906449166332/019d0269-152d-77ef-8180-822e698be595.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJcbjbcgD_QIgRqWKgCPfR1t4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_2f464f78-f748-4861-a471-19cc880e3a3f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166332",
      "source": "custom",
      "poi_name": "Walmart Supercenter",
      "poi_type": "Shopping",
      "poi_address": "201 Chamber Dr, Milford, OH 45150, USA",
      "poi_short_description": "Chain offering discount groceries and electronics, plus apparel, toys, furniture and housewares.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/019fce03-6726-77f3-98c1-7acf3e966bb5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce03-6726-77f3-98c1-7acf3e966bb5",
        "storage_key": "property/6767906449166332/019fce03-6726-77f3-98c1-7acf3e966bb5.webp",
        "width": 1067,
        "height": 600
      },
      "poi_business_url": "https://www.walmart.com/store/5499-milford-oh/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=17608116874722704004&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-supercenter",
      "poi_latitude": "39.159445",
      "poi_longitude": "-84.2802188",
      "poi_miles_from_property": "8.1 mi",
      "poi_walking_minutes": "2 hours 56 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 513-248-0067",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/019d0269-152e-700e-bdf3-2ec447c4d9ad.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-152e-700e-bdf3-2ec447c4d9ad",
        "storage_key": "property/6767906449166332/019d0269-152e-700e-bdf3-2ec447c4d9ad.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ-zLFCpiqQYgRhHpoeQGZXPQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_4845234e-d455-4caa-908d-b86e201dd3d4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166332",
      "source": "custom",
      "poi_name": "The Home Depot",
      "poi_type": "Shopping",
      "poi_address": "1094 State Rte 28, Milford, OH 45150, USA",
      "poi_short_description": "Chain home improvement retailer for tools, appliances & other products (some offer truck rentals).",
      "poi_long_description": "Chain home improvement retailer for tools, appliances & other products (some offer truck rentals).",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/019fce03-664a-719d-815a-b3c17cca2752.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce03-664a-719d-815a-b3c17cca2752",
        "storage_key": "property/6767906449166332/019fce03-664a-719d-815a-b3c17cca2752.webp",
        "width": 704,
        "height": 292
      },
      "poi_business_url": "https://www.homedepot.com/l/Milford/OH/Milford/45150/3844?emt=MSGMBGoogleMaps",
      "poi_directions_map_url": "https://maps.google.com/?cid=17138991696967909775&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-home-depot",
      "poi_latitude": "39.1974003",
      "poi_longitude": "-84.2336377",
      "poi_miles_from_property": "1.3 mi",
      "poi_walking_minutes": "31 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 513-722-1706",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/019d0269-152e-700e-bdf3-2ec447c4d9ad.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-152e-700e-bdf3-2ec447c4d9ad",
        "storage_key": "property/6767906449166332/019d0269-152e-700e-bdf3-2ec447c4d9ad.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJsTl3HYr_QIgRj0EkYiTu2e0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_7fcf8928-8dd7-4048-8fd5-16a39fe8a519",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166332",
      "source": "custom",
      "poi_name": "Lowe's Home Improvement",
      "poi_type": "Shopping",
      "poi_address": "5694 Romar Dr, Milford, OH 45150, USA",
      "poi_short_description": "Home improvement chain for appliances & gardening supplies, plus tools & hardware.",
      "poi_long_description": "Home improvement chain for appliances & gardening supplies, plus tools & hardware.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/019fce03-68f8-764e-a2a8-e414c2a7e5a8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce03-68f8-764e-a2a8-e414c2a7e5a8",
        "storage_key": "property/6767906449166332/019fce03-68f8-764e-a2a8-e414c2a7e5a8.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://www.lowes.com/store/OH-Milford/1664?cm_mmc=lod-_-c-_-lcl-_-awr-_-yxt-_-go-_-1664-_-na-_-0-_-0&y_source=1_MTE4MzQ5MC03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=3104465488772156954&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lowes-home-improvement",
      "poi_latitude": "39.1856447",
      "poi_longitude": "-84.25951010000001",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 513-965-3280",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/019d0269-152e-700e-bdf3-2ec447c4d9ad.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-152e-700e-bdf3-2ec447c4d9ad",
        "storage_key": "property/6767906449166332/019d0269-152e-700e-bdf3-2ec447c4d9ad.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJK1TrteT_QIgRGk658-lGFSs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_76874b2e-0c8a-4abb-bc3e-00baca717897",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166332",
      "source": "custom",
      "poi_name": "Kohl's",
      "poi_type": "Shopping",
      "poi_address": "1164 State Rte 28, Milford, OH 45150, USA",
      "poi_short_description": "Chain department store offering a wide selection of clothing, accessories & homewares.",
      "poi_long_description": "Chain department store offering a wide selection of clothing, accessories & homewares.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/019fce03-6c3e-712b-a54a-f6f58590b482.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce03-6c3e-712b-a54a-f6f58590b482",
        "storage_key": "property/6767906449166332/019fce03-6c3e-712b-a54a-f6f58590b482.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.kohls.com/stores/oh/milford-627.shtml?utm_source=google&utm_medium=organic&utm_campaign=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=15053098352403710322&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kohls",
      "poi_latitude": "39.1995952",
      "poi_longitude": "-84.230353",
      "poi_miles_from_property": "1.6 mi",
      "poi_walking_minutes": "36 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 513-722-3040",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/019d0269-152e-700e-bdf3-2ec447c4d9ad.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-152e-700e-bdf3-2ec447c4d9ad",
        "storage_key": "property/6767906449166332/019d0269-152e-700e-bdf3-2ec447c4d9ad.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJiaaVebX_QIgRcoEKYDJZ59A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_d47a8f42-60c2-4f19-bb60-4fcda25a4eae",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166332",
      "source": "custom",
      "poi_name": "CVS",
      "poi_type": "Shopping",
      "poi_address": "1137 OH-131, Milford, OH 45150, USA",
      "poi_short_description": "Drugstore chain selling a variety of beauty & health products, plus some grocery & household items.",
      "poi_long_description": "Drugstore chain selling a variety of beauty & health products, plus some grocery & household items.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/019fce03-6d40-726e-b1aa-16783a24b093.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce03-6d40-726e-b1aa-16783a24b093",
        "storage_key": "property/6767906449166332/019fce03-6d40-726e-b1aa-16783a24b093.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.cvs.com/store-locator/milford-oh-pharmacies/1137-state-route-131-milford-oh-45150/storeid=3978?WT.mc_id=LS_GOOGLE_FS_3978",
      "poi_directions_map_url": "https://maps.google.com/?cid=3777816619745474046&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs",
      "poi_latitude": "39.1746135",
      "poi_longitude": "-84.2369532",
      "poi_miles_from_property": "2.3 mi",
      "poi_walking_minutes": "52 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 513-831-8225",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/019d0269-0f2a-7174-a857-44a9586e5de6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-0f2a-7174-a857-44a9586e5de6",
        "storage_key": "property/6767906449166332/019d0269-0f2a-7174-a857-44a9586e5de6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6Rxe5SgAQYgR_vV-LjOAbTQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_775cb70d-e7f6-4984-a5b8-83a385fb80a2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166332",
      "source": "custom",
      "poi_name": "Walgreens",
      "poi_type": "Shopping",
      "poi_address": "1243 State Rte 28, Milford, OH 45150, USA",
      "poi_short_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_long_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/019fce03-6d10-77db-a9c1-dac7ab7d1232.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce03-6d10-77db-a9c1-dac7ab7d1232",
        "storage_key": "property/6767906449166332/019fce03-6d10-77db-a9c1-dac7ab7d1232.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-1243+state+route+28-milford-oh-45150/id=7637",
      "poi_directions_map_url": "https://maps.google.com/?cid=6740877254833461277&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens",
      "poi_latitude": "39.2014936",
      "poi_longitude": "-84.2221637",
      "poi_miles_from_property": "2.0 mi",
      "poi_walking_minutes": "45 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 513-575-3469",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/019d0269-0f2a-7174-a857-44a9586e5de6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-0f2a-7174-a857-44a9586e5de6",
        "storage_key": "property/6767906449166332/019d0269-0f2a-7174-a857-44a9586e5de6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5yvQekn-QIgRHdjbCCZojF0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_87220e12-7bdb-49fd-a573-a2f005f81aef",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166332",
      "source": "custom",
      "poi_name": "Thorntons",
      "poi_type": "Shopping",
      "poi_address": "798 State Rte 28, Milford, OH 45150, USA",
      "poi_short_description": "Convenience-store chain with grab-&-go food, packaged snacks & drinks, plus gasoline.",
      "poi_long_description": "Convenience-store chain with grab-&-go food, packaged snacks & drinks, plus gasoline.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/019fce03-6ebe-77fa-a56f-e745b3826b1c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce03-6ebe-77fa-a56f-e745b3826b1c",
        "storage_key": "property/6767906449166332/019fce03-6ebe-77fa-a56f-e745b3826b1c.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.thorntonsinc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1514152013960580814&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "thorntons",
      "poi_latitude": "39.185295",
      "poi_longitude": "-84.26773999999999",
      "poi_miles_from_property": "5.6 mi",
      "poi_walking_minutes": "2 hours 3 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 513-248-1394",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/019d0269-157d-74b5-89e3-e5bc5dbb4b65.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-157d-74b5-89e3-e5bc5dbb4b65",
        "storage_key": "property/6767906449166332/019d0269-157d-74b5-89e3-e5bc5dbb4b65.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJOyN91f7_QIgRzg4QADxZAxU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_de288016-688a-4d58-b75e-2196ffb07184",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166332",
      "source": "custom",
      "poi_name": "Miami Preschool & Extended Day",
      "poi_type": "Education",
      "poi_address": "1039 OH-28, Milford, OH 45150, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.milfordschools.org/milford-preschool/extended-day-program/extended-day-program/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18065814986332058709&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "miami-preschool--extended-day",
      "poi_latitude": "39.1930322",
      "poi_longitude": "-84.242351",
      "poi_miles_from_property": "0.7 mi",
      "poi_walking_minutes": "17 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 513-831-9690",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/019d0269-14e4-769f-945f-f4982e794f22.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-14e4-769f-945f-f4982e794f22",
        "storage_key": "property/6767906449166332/019d0269-14e4-769f-945f-f4982e794f22.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJQRDLa8T_QIgRVTRAZgOrtvo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_fc17713d-236d-4e94-a973-18cbd7870f78",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166332",
      "source": "custom",
      "poi_name": "Mulberry Elementary School",
      "poi_type": "Education",
      "poi_address": "5950 Buckwheat Rd Basecamp 1, Milford, OH 45150, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.milfordschools.org/o/mbes",
      "poi_directions_map_url": "https://maps.google.com/?cid=3031563811834205436&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mulberry-elementary-school",
      "poi_latitude": "39.1945859",
      "poi_longitude": "-84.22015309999999",
      "poi_miles_from_property": "2.2 mi",
      "poi_walking_minutes": "50 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 513-722-3588",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/019d0269-14e4-769f-945f-f4982e794f22.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-14e4-769f-945f-f4982e794f22",
        "storage_key": "property/6767906449166332/019d0269-14e4-769f-945f-f4982e794f22.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJBStRzzX-QIgR_JROljlHEio",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_161084bf-cf75-42ee-87bb-de2705aa3e66",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166332",
      "source": "custom",
      "poi_name": "Pattison Elementary",
      "poi_type": "Education",
      "poi_address": "5330 S Milford Rd, Milford, OH 45150, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/019fce03-72bd-77d6-bdbd-70e704dac29b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce03-72bd-77d6-bdbd-70e704dac29b",
        "storage_key": "property/6767906449166332/019fce03-72bd-77d6-bdbd-70e704dac29b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.milfordschools.org/pattison-elementary",
      "poi_directions_map_url": "https://maps.google.com/?cid=12702230866698203823&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pattison-elementary",
      "poi_latitude": "39.1587942",
      "poi_longitude": "-84.29210139999999",
      "poi_miles_from_property": "6.7 mi",
      "poi_walking_minutes": "2 hours 26 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 513-831-6570",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/019d0269-14e4-769f-945f-f4982e794f22.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-14e4-769f-945f-f4982e794f22",
        "storage_key": "property/6767906449166332/019d0269-14e4-769f-945f-f4982e794f22.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJJa2XodCrQYgRr3KMiKxjR7A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_8ab4206b-d7d4-4c6c-bcbb-bafbafe25ed3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166332",
      "source": "custom",
      "poi_name": "Meadowview Elementary School",
      "poi_type": "Education",
      "poi_address": "5556 Mt Zion Rd, Milford, OH 45150, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/019fce03-736e-73a2-8976-9573e2e25e28.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce03-736e-73a2-8976-9573e2e25e28",
        "storage_key": "property/6767906449166332/019fce03-736e-73a2-8976-9573e2e25e28.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.milfordschools.org/o/mes",
      "poi_directions_map_url": "https://maps.google.com/?cid=2891670497333101057&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "meadowview-elementary-school",
      "poi_latitude": "39.1706153",
      "poi_longitude": "-84.195973",
      "poi_miles_from_property": "4.8 mi",
      "poi_walking_minutes": "1 hour 46 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 513-831-9170",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/019d0269-14e4-769f-945f-f4982e794f22.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-14e4-769f-945f-f4982e794f22",
        "storage_key": "property/6767906449166332/019d0269-14e4-769f-945f-f4982e794f22.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ_WOQteQBQYgRAUIEIf9GISg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_72d74796-efe1-4109-a6fa-c36a225b7a51",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166332",
      "source": "custom",
      "poi_name": "Boyd E. Smith Elementary School",
      "poi_type": "Education",
      "poi_address": "1052 Jer Les St, Milford, OH 45150, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/019fce03-7469-7113-9bc3-0eeb61b8b52d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce03-7469-7113-9bc3-0eeb61b8b52d",
        "storage_key": "property/6767906449166332/019fce03-7469-7113-9bc3-0eeb61b8b52d.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.milfordschools.org/o/beses",
      "poi_directions_map_url": "https://maps.google.com/?cid=7055862375092392538&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "boyd-e-smith-elementary-school",
      "poi_latitude": "39.2086605",
      "poi_longitude": "-84.2395836",
      "poi_miles_from_property": "2.8 mi",
      "poi_walking_minutes": "1 hour 3 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 513-575-1643",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/019d0269-14e4-769f-945f-f4982e794f22.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-14e4-769f-945f-f4982e794f22",
        "storage_key": "property/6767906449166332/019d0269-14e4-769f-945f-f4982e794f22.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJR9rhuLr_QIgRWhJtU3J162E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_d17c86ba-0138-4469-a527-13dbf3fd546a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166332",
      "source": "custom",
      "poi_name": "Charles L Seipelt Elementary School",
      "poi_type": "Education",
      "poi_address": "900 OH-131, Milford, OH 45150, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/019fce03-75eb-740b-9025-47c878f08243.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce03-75eb-740b-9025-47c878f08243",
        "storage_key": "property/6767906449166332/019fce03-75eb-740b-9025-47c878f08243.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.milfordschools.org/charles-l-seipelt-elementary/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7023911524647400055&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "charles-l-seipelt-elementary-school",
      "poi_latitude": "39.177954",
      "poi_longitude": "-84.25847999999999",
      "poi_miles_from_property": "3.4 mi",
      "poi_walking_minutes": "1 hour 14 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 513-831-9460",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/019d0269-14e4-769f-945f-f4982e794f22.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-14e4-769f-945f-f4982e794f22",
        "storage_key": "property/6767906449166332/019d0269-14e4-769f-945f-f4982e794f22.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJX9zTPh0AQYgRd3JhQFHyeWE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_8f84120e-60e6-4f38-af4a-a05b3b8b17b6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166332",
      "source": "custom",
      "poi_name": "Milford Middle School",
      "poi_type": "Education",
      "poi_address": "5735 Wolfpen Pleasant Hill Rd, Milford, OH 45150, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/019fce03-79d4-707d-ad26-c654c61404b5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce03-79d4-707d-ad26-c654c61404b5",
        "storage_key": "property/6767906449166332/019fce03-79d4-707d-ad26-c654c61404b5.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.milfordschools.org/o/mjhs",
      "poi_directions_map_url": "https://maps.google.com/?cid=6115198782618584976&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "milford-middle-school",
      "poi_latitude": "39.1816846",
      "poi_longitude": "-84.2393456",
      "poi_miles_from_property": "2.0 mi",
      "poi_walking_minutes": "46 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 513-831-1900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/019d0269-14e4-769f-945f-f4982e794f22.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-14e4-769f-945f-f4982e794f22",
        "storage_key": "property/6767906449166332/019d0269-14e4-769f-945f-f4982e794f22.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJcQlVF9f_QIgRkMfhoOSM3VQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_361ced1f-9793-404c-a595-6cd507b18376",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166332",
      "source": "custom",
      "poi_name": "Milford High School",
      "poi_type": "Education",
      "poi_address": "1 Eagles Watch Wy, Milford, OH 45150, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/019fce03-7a2b-76f9-b030-9c92c123b4ef.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce03-7a2b-76f9-b030-9c92c123b4ef",
        "storage_key": "property/6767906449166332/019fce03-7a2b-76f9-b030-9c92c123b4ef.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.milfordschools.org/milford-high-school/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14056404391428845552&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "milford-high-school",
      "poi_latitude": "39.179768",
      "poi_longitude": "-84.2410795",
      "poi_miles_from_property": "2.2 mi",
      "poi_walking_minutes": "51 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 513-831-2990",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/019d0269-14e4-769f-945f-f4982e794f22.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-14e4-769f-945f-f4982e794f22",
        "storage_key": "property/6767906449166332/019d0269-14e4-769f-945f-f4982e794f22.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJuayz89j_QIgR8G9b6lFhEsM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_06cbbe5e-a6af-4d53-9d24-6eb38dd369fd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166332",
      "source": "custom",
      "poi_name": "Live Oaks Career Campus",
      "poi_type": "Education",
      "poi_address": "5956 Buckwheat Rd, Milford, OH 45150, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/019fce03-7af1-712b-9d04-fd4f194af941.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce03-7af1-712b-9d04-fd4f194af941",
        "storage_key": "property/6767906449166332/019fce03-7af1-712b-9d04-fd4f194af941.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://hs.greatoaks.com/live",
      "poi_directions_map_url": "https://maps.google.com/?cid=5355130086817124925&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "live-oaks-career-campus",
      "poi_latitude": "39.197442",
      "poi_longitude": "-84.219968",
      "poi_miles_from_property": "2.1 mi",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 513-575-1900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/019d0269-14e4-769f-945f-f4982e794f22.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-14e4-769f-945f-f4982e794f22",
        "storage_key": "property/6767906449166332/019d0269-14e4-769f-945f-f4982e794f22.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJM0RhvzX-QIgRPdK99nA-UUo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_db7b0af1-f5ee-45e5-9cfe-c96fd6c567c1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166332",
      "source": "custom",
      "poi_name": "UC Clermont College",
      "poi_type": "Education",
      "poi_address": "4200 Clermont College Dr, Batavia, OH 45103, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/019fce03-7ce5-76f1-9f45-d3f828352580.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce03-7ce5-76f1-9f45-d3f828352580",
        "storage_key": "property/6767906449166332/019fce03-7ce5-76f1-9f45-d3f828352580.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.ucclermont.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11199487859864516124&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "uc-clermont-college",
      "poi_latitude": "39.0797116",
      "poi_longitude": "-84.1955973",
      "poi_miles_from_property": "14.3 mi",
      "poi_walking_minutes": "5 hours 17 mins",
      "poi_biking_minutes": "1 hour 9 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 513-732-5200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/019d0269-14e4-769f-945f-f4982e794f22.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-14e4-769f-945f-f4982e794f22",
        "storage_key": "property/6767906449166332/019d0269-14e4-769f-945f-f4982e794f22.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJbSpACLsGQYgRHDaGAd-SbJs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_d95cbc9b-6f23-4c78-9e1d-d0759f010505",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166332",
      "source": "custom",
      "poi_name": "Cinemark Milford 16",
      "poi_type": "Entertainment",
      "poi_address": "500 Rivers Edge Dr, Milford, OH 45150, USA",
      "poi_short_description": "Chain of movie theaters, some with multiple screens, stadium seats & self-service ticketing kiosks.",
      "poi_long_description": "Chain of movie theaters, some with multiple screens, stadium seats & self-service ticketing kiosks.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/019fce03-8008-7248-bd50-50f5c753d0ce.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce03-8008-7248-bd50-50f5c753d0ce",
        "storage_key": "property/6767906449166332/019fce03-8008-7248-bd50-50f5c753d0ce.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "https://www.cinemark.com/theatres/oh-milford/cinemark-milford-16?utm_medium=organic&utm_source=gmb&utm_campaign=local_listing_theater&utm_content=GMB_listing&y_source=1_MTc0OTI5NjQtNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=5448122125482512470&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cinemark-milford-16",
      "poi_latitude": "39.1633433",
      "poi_longitude": "-84.2705115",
      "poi_miles_from_property": "7.8 mi",
      "poi_walking_minutes": "2 hours 50 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 513-248-2169",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/019d0269-1b08-7007-887e-86cf3c81e9bf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-1b08-7007-887e-86cf3c81e9bf",
        "storage_key": "property/6767906449166332/019d0269-1b08-7007-887e-86cf3c81e9bf.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJu99boaCqQYgRVtBULjWem0s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_7c493151-6392-4510-b6b0-5fcddb1249cb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166332",
      "source": "custom",
      "poi_name": "Scene75 Entertainment Center | Cincinnati",
      "poi_type": "Entertainment",
      "poi_address": "876 OH-28, Milford, OH 45150, USA",
      "poi_short_description": "Huge family-friendly entertainment complex featuring arcade games, bumper cars, bowling, laser tag, go-karts and mini-golf, plus a 4D theater, a restaurant, two bars and a banquet hall.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/019fce03-8080-7690-bccc-c679dda684e5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce03-8080-7690-bccc-c679dda684e5",
        "storage_key": "property/6767906449166332/019fce03-8080-7690-bccc-c679dda684e5.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.scene75.com/cincinnati/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12121881805446774270&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "scene75-entertainment-center--cincinnati",
      "poi_latitude": "39.1917733",
      "poi_longitude": "-84.2580014",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "13 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 513-965-4050",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/019d0269-0f2a-7174-a857-44a9586e5de6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-0f2a-7174-a857-44a9586e5de6",
        "storage_key": "property/6767906449166332/019d0269-0f2a-7174-a857-44a9586e5de6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7Vjgo-__QIgR_v3sDkeTOag",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_afe9b125-3afa-48de-b031-65b188d5255c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166332",
      "source": "custom",
      "poi_name": "Cincinnati Nature Center",
      "poi_type": "Entertainment",
      "poi_address": "4949 Tealtown Rd, Milford, OH 45150, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/019fce03-827f-72dd-8734-c2a2aae1e58a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce03-827f-72dd-8734-c2a2aae1e58a",
        "storage_key": "property/6767906449166332/019fce03-827f-72dd-8734-c2a2aae1e58a.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.cincynature.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1688270722564007801&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cincinnati-nature-center",
      "poi_latitude": "39.12650319999999",
      "poi_longitude": "-84.2456414",
      "poi_miles_from_property": "12.8 mi",
      "poi_walking_minutes": "4 hours 43 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 513-831-1711",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/019d0269-1bea-725f-8b96-17449f75af8e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-1bea-725f-8b96-17449f75af8e",
        "storage_key": "property/6767906449166332/019d0269-1bea-725f-8b96-17449f75af8e.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJw880ByD8QIgReace_0bxbRc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_7d1cb276-e1d7-4f00-a21d-bb20e7a02217",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166332",
      "source": "custom",
      "poi_name": "Promont House",
      "poi_type": "Entertainment",
      "poi_address": "906 Main St, Milford, OH 45150, USA",
      "poi_short_description": "Breathtaking 3-story mansion, built c. 1860, for tours & events, plus afternoon tea.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/019fce03-840a-755b-8cb9-264004789ffd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce03-840a-755b-8cb9-264004789ffd",
        "storage_key": "property/6767906449166332/019fce03-840a-755b-8cb9-264004789ffd.webp",
        "width": 1151,
        "height": 1280
      },
      "poi_business_url": "http://www.milfordhistory.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8863283898172324319&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "promont-house",
      "poi_latitude": "39.1770845",
      "poi_longitude": "-84.279518",
      "poi_miles_from_property": "4.8 mi",
      "poi_walking_minutes": "1 hour 45 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 513-248-0324",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/019d0269-1c4e-700d-9a76-de3154a596b2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-1c4e-700d-9a76-de3154a596b2",
        "storage_key": "property/6767906449166332/019d0269-1c4e-700d-9a76-de3154a596b2.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJSz57mK2qQYgR3zkA5r61AHs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_482ed44c-d792-42d9-9b32-4bbd628f26ea",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166332",
      "source": "custom",
      "poi_name": "Five Points Landing Park",
      "poi_type": "Entertainment",
      "poi_address": "527 Lila Ave, Milford, OH 45150, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/019fce03-866d-7688-9e60-c42ac8c88bf2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce03-866d-7688-9e60-c42ac8c88bf2",
        "storage_key": "property/6767906449166332/019fce03-866d-7688-9e60-c42ac8c88bf2.webp",
        "width": 1280,
        "height": 956
      },
      "poi_business_url": "http://www.milfordohio.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13148819709192262727&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "five-points-landing-park",
      "poi_latitude": "39.1769362",
      "poi_longitude": "-84.28900089999999",
      "poi_miles_from_property": "5.1 mi",
      "poi_walking_minutes": "1 hour 51 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 513-831-4192",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/019d0269-1bea-725f-8b96-17449f75af8e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-1bea-725f-8b96-17449f75af8e",
        "storage_key": "property/6767906449166332/019d0269-1bea-725f-8b96-17449f75af8e.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJSQje5jurQYgRR1QPLtz9ebY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_8df026fb-4631-4444-9e53-a8d8fee0e111",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166332",
      "source": "custom",
      "poi_name": "Little Miami Brewing Company",
      "poi_type": "Entertainment",
      "poi_address": "208 Mill St, Milford, OH 45150, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/019fce03-5247-717f-88a5-44d8c3ebe069.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce03-5247-717f-88a5-44d8c3ebe069",
        "storage_key": "property/6767906449166332/019fce03-5247-717f-88a5-44d8c3ebe069.webp",
        "width": 992,
        "height": 558
      },
      "poi_business_url": "https://www.littlemiamibrewing.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8799920786167992783&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "little-miami-brewing-company",
      "poi_latitude": "39.1718142",
      "poi_longitude": "-84.2975962",
      "poi_miles_from_property": "5.7 mi",
      "poi_walking_minutes": "2 hours 5 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 513-713-1121",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/019d0269-0f2a-7174-a857-44a9586e5de6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-0f2a-7174-a857-44a9586e5de6",
        "storage_key": "property/6767906449166332/019d0269-0f2a-7174-a857-44a9586e5de6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJm-z-Q8-qQYgRz5Eev1SZH3o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_f2865b84-d4ed-47d2-866b-f56d82b43e99",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166332",
      "source": "custom",
      "poi_name": "Valley View Nature Preserve",
      "poi_type": "Entertainment",
      "poi_address": "790 Garfield Ave, 5320 S Milford Rd, Milford, OH 45150, USA",
      "poi_short_description": "Hiker-friendly preserve featuring a river, birdlife, ponds, a garden and free parking.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/019fce03-87fe-760f-b008-487dc316d657.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce03-87fe-760f-b008-487dc316d657",
        "storage_key": "property/6767906449166332/019fce03-87fe-760f-b008-487dc316d657.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.valleyviewpreserve.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15847293455672191205&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "valley-view-nature-preserve",
      "poi_latitude": "39.16864109999999",
      "poi_longitude": "-84.2871189",
      "poi_miles_from_property": "5.5 mi",
      "poi_walking_minutes": "1 hour 59 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 513-218-1098",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/019d0269-1bea-725f-8b96-17449f75af8e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-1bea-725f-8b96-17449f75af8e",
        "storage_key": "property/6767906449166332/019d0269-1bea-725f-8b96-17449f75af8e.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6ezXYZWqQYgR5ai2dG_l7Ns",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_f900d1e8-9ad6-4a60-9715-6b377a5ad5c8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166332",
      "source": "custom",
      "poi_name": "Loveland Castle Museum",
      "poi_type": "Entertainment",
      "poi_address": "12025 Shore Dr, Loveland, OH 45140, USA",
      "poi_short_description": "This castle, built in the '20s, features an extensive sword collection & riverside picnic areas.",
      "poi_long_description": "This castle, built in the '20s, features an extensive sword collection & riverside picnic areas.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/019fce03-89b1-701e-b621-4f649c148faf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce03-89b1-701e-b621-4f649c148faf",
        "storage_key": "property/6767906449166332/019fce03-89b1-701e-b621-4f649c148faf.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://lovelandcastle.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16537415557646357574&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "loveland-castle-museum",
      "poi_latitude": "39.2835347",
      "poi_longitude": "-84.2659789",
      "poi_miles_from_property": "9.3 mi",
      "poi_walking_minutes": "3 hours 25 mins",
      "poi_biking_minutes": "54 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 513-683-4686",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/019d0269-1c4e-700d-9a76-de3154a596b2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-1c4e-700d-9a76-de3154a596b2",
        "storage_key": "property/6767906449166332/019d0269-1c4e-700d-9a76-de3154a596b2.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJGwVV3qH4QIgRRpSHqNSzgOU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_ed555c9e-679c-4281-b661-49c77ac6c8df",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166332",
      "source": "custom",
      "poi_name": "Milford Trailhead",
      "poi_type": "Entertainment",
      "poi_address": "5 OH-126, Milford, OH 45243, USA",
      "poi_short_description": "Scenic, paved trail along a river that’s popular for biking, hiking and walking.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/019fce03-8bd8-75cf-90da-5a3b6b64e0ac.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce03-8bd8-75cf-90da-5a3b6b64e0ac",
        "storage_key": "property/6767906449166332/019fce03-8bd8-75cf-90da-5a3b6b64e0ac.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.milfordohio.org/departments/public_works_department/parks_and_recreation/milford_bike_trail.php",
      "poi_directions_map_url": "https://maps.google.com/?cid=13154954685311207057&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "milford-trailhead",
      "poi_latitude": "39.1717506",
      "poi_longitude": "-84.2996105",
      "poi_miles_from_property": "5.9 mi",
      "poi_walking_minutes": "2 hours 8 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/019d0269-1bea-725f-8b96-17449f75af8e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-1bea-725f-8b96-17449f75af8e",
        "storage_key": "property/6767906449166332/019d0269-1bea-725f-8b96-17449f75af8e.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJkcGems-qQYgRkcZVnpbJj7Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_97f26cb5-50f7-4e8a-9e6f-19bf8dc7af4e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166332",
      "source": "custom",
      "poi_name": "Row House Gallery",
      "poi_type": "Entertainment",
      "poi_address": "211 Main St, Milford, OH 45150, USA",
      "poi_short_description": "Gallery displaying works, often by local artists, with a framing service to ensconce them.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/019fce03-8d89-703f-8dd0-af07f082a889.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce03-8d89-703f-8dd0-af07f082a889",
        "storage_key": "property/6767906449166332/019fce03-8d89-703f-8dd0-af07f082a889.webp",
        "width": 723,
        "height": 1280
      },
      "poi_business_url": "https://www.rowhouse.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5020856272211610074&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "row-house-gallery",
      "poi_latitude": "39.1741429",
      "poi_longitude": "-84.2957357",
      "poi_miles_from_property": "5.5 mi",
      "poi_walking_minutes": "2 hours 0 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 513-831-7230",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/019d0269-0f2a-7174-a857-44a9586e5de6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-0f2a-7174-a857-44a9586e5de6",
        "storage_key": "property/6767906449166332/019d0269-0f2a-7174-a857-44a9586e5de6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-eBTJcmqQYgR2gl3jS2qrUU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_a15fc400-b878-468e-9fd7-5670b9da4191",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166332",
      "source": "custom",
      "poi_name": "Mercy Health - Clermont Hospital",
      "poi_type": "Health",
      "poi_address": "3000 Hospital Dr, Batavia, OH 45103, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/019fce03-8fd4-7439-b537-238c70785c79.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce03-8fd4-7439-b537-238c70785c79",
        "storage_key": "property/6767906449166332/019fce03-8fd4-7439-b537-238c70785c79.webp",
        "width": 704,
        "height": 396
      },
      "poi_business_url": "https://www.mercy.com/locations/hospitals/cincinnati/mercy-health-clermont-hospital",
      "poi_directions_map_url": "https://maps.google.com/?cid=14580036950875791963&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mercy-health---clermont-hospital",
      "poi_latitude": "39.0798998",
      "poi_longitude": "-84.14453809999999",
      "poi_miles_from_property": "13.1 mi",
      "poi_walking_minutes": "4 hours 53 mins",
      "poi_biking_minutes": "1 hour 19 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 513-732-8200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/019d0269-1de1-7075-9101-7de95e38916b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-1de1-7075-9101-7de95e38916b",
        "storage_key": "property/6767906449166332/019d0269-1de1-7075-9101-7de95e38916b.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJE2j7tmIEQYgRW2IFxVuyVso",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_5d806dea-c36a-4169-a1e3-b66367a83317",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166332",
      "source": "custom",
      "poi_name": "Mercy Health Urgent Care, Milford",
      "poi_type": "Health",
      "poi_address": "1064 State Rte 28 F, Milford, OH 45150, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/019fce03-9037-7770-ae4c-910062264efc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce03-9037-7770-ae4c-910062264efc",
        "storage_key": "property/6767906449166332/019fce03-9037-7770-ae4c-910062264efc.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.mercy.com/locations/urgent-care/cincinnati/mercy-health-urgent-care-milford?utm_source=google&utm_medium=organic&utm_content=local_website_link",
      "poi_directions_map_url": "https://maps.google.com/?cid=10173057561220313511&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mercy-health-urgent-care-milford",
      "poi_latitude": "39.1948738",
      "poi_longitude": "-84.23783639999999",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 513-981-4050",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/019d0269-0f2a-7174-a857-44a9586e5de6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-0f2a-7174-a857-44a9586e5de6",
        "storage_key": "property/6767906449166332/019d0269-0f2a-7174-a857-44a9586e5de6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJvTEPYbH_QIgRp3Ej6PP1LY0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_4b9fb215-7da4-4e61-aed8-c6ed63b56afa",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166332",
      "source": "custom",
      "poi_name": "Hometown Urgent Care & Occupational Health",
      "poi_type": "Health",
      "poi_address": "1068 State Rte 28, Milford, OH 45150, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/019fce03-92b0-7259-b61d-4b117e709003.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce03-92b0-7259-b61d-4b117e709003",
        "storage_key": "property/6767906449166332/019fce03-92b0-7259-b61d-4b117e709003.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://myhometownuc.com/locations/milford-ohio/?utm_source=yext&utm_medium=lociqyext&utm_campaign=Milford%2COH-5220",
      "poi_directions_map_url": "https://maps.google.com/?cid=3258164996138690033&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hometown-urgent-care--occupational-health",
      "poi_latitude": "39.1956313",
      "poi_longitude": "-84.2362529",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 513-831-5900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/019d0269-0f2a-7174-a857-44a9586e5de6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-0f2a-7174-a857-44a9586e5de6",
        "storage_key": "property/6767906449166332/019d0269-0f2a-7174-a857-44a9586e5de6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJgyuxUc__QIgR8WV1Ls1TNy0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_ff276885-b4bc-4d67-a042-7a527863d4b9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166332",
      "source": "custom",
      "poi_name": "CareFirst Urgent Care - Milford",
      "poi_type": "Health",
      "poi_address": "846 State Rte 28, Milford, OH 45150, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/019fce03-9345-7698-b873-ff5d738fbf7b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce03-9345-7698-b873-ff5d738fbf7b",
        "storage_key": "property/6767906449166332/019fce03-9345-7698-b873-ff5d738fbf7b.webp",
        "width": 661,
        "height": 374
      },
      "poi_business_url": "https://www.carefirsturgentcares.com/locations/milford-oh/?utm_source=Google&utm_medium=Local+Listing&utm_campaign=Yext",
      "poi_directions_map_url": "https://maps.google.com/?cid=3865846725985359481&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "carefirst-urgent-care---milford",
      "poi_latitude": "39.189389",
      "poi_longitude": "-84.259796",
      "poi_miles_from_property": "0.7 mi",
      "poi_walking_minutes": "16 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 513-831-8555",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/019d0269-0f2a-7174-a857-44a9586e5de6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-0f2a-7174-a857-44a9586e5de6",
        "storage_key": "property/6767906449166332/019d0269-0f2a-7174-a857-44a9586e5de6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJjXIAXej_QIgRedZ2eh0_pjU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_e9b6d78b-5c74-4d03-9f88-017b7ee377a6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166332",
      "source": "custom",
      "poi_name": "Kroger Pharmacy",
      "poi_type": "Health",
      "poi_address": "1093 State Rte 28, Milford, OH 45150, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/019fce03-952a-71d9-b03b-b79b7ff04a40.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce03-952a-71d9-b03b-b79b7ff04a40",
        "storage_key": "property/6767906449166332/019fce03-952a-71d9-b03b-b79b7ff04a40.webp",
        "width": 796,
        "height": 503
      },
      "poi_business_url": "https://www.kroger.com/rx/pharmacy/details/014/00921?cid=loc_01400921P_gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=10540102333171495716&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kroger-pharmacy",
      "poi_latitude": "39.1929873",
      "poi_longitude": "-84.2349357",
      "poi_miles_from_property": "1.2 mi",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 513-583-3810",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/019d0269-2077-745a-88bf-ff981061284d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-2077-745a-88bf-ff981061284d",
        "storage_key": "property/6767906449166332/019d0269-2077-745a-88bf-ff981061284d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJO9b_5M7_QIgRJPPzaDr3RZI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_eaa9d2b1-b049-427a-b860-933c6564cde6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166332",
      "source": "custom",
      "poi_name": "CVS",
      "poi_type": "Health",
      "poi_address": "1137 OH-131, Milford, OH 45150, USA",
      "poi_short_description": "Drugstore chain selling a variety of beauty & health products, plus some grocery & household items.",
      "poi_long_description": "Drugstore chain selling a variety of beauty & health products, plus some grocery & household items.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/019fce03-6d40-726e-b1aa-16783a24b093.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce03-6d40-726e-b1aa-16783a24b093",
        "storage_key": "property/6767906449166332/019fce03-6d40-726e-b1aa-16783a24b093.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.cvs.com/store-locator/milford-oh-pharmacies/1137-state-route-131-milford-oh-45150/storeid=3978?WT.mc_id=LS_GOOGLE_FS_3978",
      "poi_directions_map_url": "https://maps.google.com/?cid=3777816619745474046&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs",
      "poi_latitude": "39.1746135",
      "poi_longitude": "-84.2369532",
      "poi_miles_from_property": "2.3 mi",
      "poi_walking_minutes": "52 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 513-831-8225",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/019d0269-0f2a-7174-a857-44a9586e5de6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-0f2a-7174-a857-44a9586e5de6",
        "storage_key": "property/6767906449166332/019d0269-0f2a-7174-a857-44a9586e5de6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6Rxe5SgAQYgR_vV-LjOAbTQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_61515b46-7335-434b-844a-13f3fa7865b5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166332",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health",
      "poi_address": "1075 State Rte 28, Milford, OH 45150, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/019fce03-963c-72a2-8771-0e9de916e010.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce03-963c-72a2-8771-0e9de916e010",
        "storage_key": "property/6767906449166332/019fce03-963c-72a2-8771-0e9de916e010.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/milford-oh?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=2847888697591214835&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "39.19172",
      "poi_longitude": "-84.2368706",
      "poi_miles_from_property": "1.2 mi",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 513-340-4131",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/019d0269-0f2a-7174-a857-44a9586e5de6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-0f2a-7174-a857-44a9586e5de6",
        "storage_key": "property/6767906449166332/019d0269-0f2a-7174-a857-44a9586e5de6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJcYhJDM__QIgR8zLGg667hSc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_013a4bc1-fc93-464f-977f-ed277b179baf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166332",
      "source": "custom",
      "poi_name": "CrossFit Symmetry",
      "poi_type": "Health",
      "poi_address": "1003 Lila Ave, Milford, OH 45150, USA",
      "poi_short_description": "Membership-only chain gym at the Milford Shopping Center with a welcoming community and coaches for all fitness levels.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/019fce03-9886-7482-9e4d-f902855e9d47.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce03-9886-7482-9e4d-f902855e9d47",
        "storage_key": "property/6767906449166332/019fce03-9886-7482-9e4d-f902855e9d47.webp",
        "width": 1280,
        "height": 774
      },
      "poi_business_url": "http://crossfitsymmetry.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=504973400386256944&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "crossfit-symmetry",
      "poi_latitude": "39.17460000000001",
      "poi_longitude": "-84.2749267",
      "poi_miles_from_property": "4.2 mi",
      "poi_walking_minutes": "1 hour 32 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 513-509-1909",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/019d0269-0f2a-7174-a857-44a9586e5de6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-0f2a-7174-a857-44a9586e5de6",
        "storage_key": "property/6767906449166332/019d0269-0f2a-7174-a857-44a9586e5de6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9yvzM6mqQYgRMEAL16EGAgc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_f6bbe3e2-8a24-44c0-8433-4bc02b98a805",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166332",
      "source": "custom",
      "poi_name": "Pilates On Main",
      "poi_type": "Health",
      "poi_address": "101 Main St Studio B, Milford, OH 45150, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/019fce03-98fa-7648-b6a3-1a5e579319a1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce03-98fa-7648-b6a3-1a5e579319a1",
        "storage_key": "property/6767906449166332/019fce03-98fa-7648-b6a3-1a5e579319a1.webp",
        "width": 1280,
        "height": 926
      },
      "poi_business_url": "https://www.pilatesonmain.org/?utm_source=google&utm_medium=wix_google_business_profile&utm_campaign=4321143121244028191",
      "poi_directions_map_url": "https://maps.google.com/?cid=3978748743772830764&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pilates-on-main",
      "poi_latitude": "39.1729977",
      "poi_longitude": "-84.2963738",
      "poi_miles_from_property": "5.6 mi",
      "poi_walking_minutes": "2 hours 1 min",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 503-519-9719",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/019d0269-14e4-769f-945f-f4982e794f22.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-14e4-769f-945f-f4982e794f22",
        "storage_key": "property/6767906449166332/019d0269-14e4-769f-945f-f4982e794f22.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJIXwSNderQYgRLHwc8-ZaNzc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_95b4bc14-f02d-4490-92b2-80b71d6ba3ca",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166332",
      "source": "custom",
      "poi_name": "Thrive Wellness PT & Personal Pilates",
      "poi_type": "Health",
      "poi_address": "1110 Main St Suite A, Milford, OH 45150, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/019fce03-9abf-7309-bc20-ddd4a7b684cf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce03-9abf-7309-bc20-ddd4a7b684cf",
        "storage_key": "property/6767906449166332/019fce03-9abf-7309-bc20-ddd4a7b684cf.webp",
        "width": 853,
        "height": 1280
      },
      "poi_business_url": "https://www.thrivewellnessptpilates.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2937387301541200090&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "thrive-wellness-pt--personal-pilates",
      "poi_latitude": "39.1813729",
      "poi_longitude": "-84.2743576",
      "poi_miles_from_property": "5.1 mi",
      "poi_walking_minutes": "1 hour 52 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 513-600-5164",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/019d0269-0f2a-7174-a857-44a9586e5de6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-0f2a-7174-a857-44a9586e5de6",
        "storage_key": "property/6767906449166332/019d0269-0f2a-7174-a857-44a9586e5de6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJj0dSTI9VQIgR2kAbFDCywyg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_ba3b2f02-e94a-49b9-9e91-3ee987c12ee8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166332",
      "source": "custom",
      "poi_name": "Cincinnati Nature Center",
      "poi_type": "Outdoor",
      "poi_address": "4949 Tealtown Rd, Milford, OH 45150, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/019fce03-827f-72dd-8734-c2a2aae1e58a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce03-827f-72dd-8734-c2a2aae1e58a",
        "storage_key": "property/6767906449166332/019fce03-827f-72dd-8734-c2a2aae1e58a.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.cincynature.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1688270722564007801&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cincinnati-nature-center",
      "poi_latitude": "39.12650319999999",
      "poi_longitude": "-84.2456414",
      "poi_miles_from_property": "12.8 mi",
      "poi_walking_minutes": "4 hours 43 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 513-831-1711",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/019d0269-1bea-725f-8b96-17449f75af8e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-1bea-725f-8b96-17449f75af8e",
        "storage_key": "property/6767906449166332/019d0269-1bea-725f-8b96-17449f75af8e.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJw880ByD8QIgReace_0bxbRc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_30ef7079-03a6-4e7a-b7ab-38c952439e35",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166332",
      "source": "custom",
      "poi_name": "Valley View Nature Preserve",
      "poi_type": "Outdoor",
      "poi_address": "790 Garfield Ave, 5320 S Milford Rd, Milford, OH 45150, USA",
      "poi_short_description": "Hiker-friendly preserve featuring a river, birdlife, ponds, a garden and free parking.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/019fce03-87fe-760f-b008-487dc316d657.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce03-87fe-760f-b008-487dc316d657",
        "storage_key": "property/6767906449166332/019fce03-87fe-760f-b008-487dc316d657.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.valleyviewpreserve.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15847293455672191205&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "valley-view-nature-preserve",
      "poi_latitude": "39.16864109999999",
      "poi_longitude": "-84.2871189",
      "poi_miles_from_property": "5.5 mi",
      "poi_walking_minutes": "1 hour 59 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 513-218-1098",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/019d0269-1bea-725f-8b96-17449f75af8e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-1bea-725f-8b96-17449f75af8e",
        "storage_key": "property/6767906449166332/019d0269-1bea-725f-8b96-17449f75af8e.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6ezXYZWqQYgR5ai2dG_l7Ns",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_9ca9d6a0-0d01-4682-8597-610c4d73ed08",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166332",
      "source": "custom",
      "poi_name": "Shor Park",
      "poi_type": "Outdoor",
      "poi_address": "4659 Tealtown Rd, Milford, OH 45150, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/019fce03-9ce2-747b-8c35-1346c4012d26.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce03-9ce2-747b-8c35-1346c4012d26",
        "storage_key": "property/6767906449166332/019fce03-9ce2-747b-8c35-1346c4012d26.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.clermontparks.org/shor-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17544468133185299046&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "shor-park",
      "poi_latitude": "39.1091509",
      "poi_longitude": "-84.23879339999999",
      "poi_miles_from_property": "11.9 mi",
      "poi_walking_minutes": "4 hours 23 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 513-732-2977",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/019d0269-1bea-725f-8b96-17449f75af8e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-1bea-725f-8b96-17449f75af8e",
        "storage_key": "property/6767906449166332/019d0269-1bea-725f-8b96-17449f75af8e.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJI70nWMMAQYgRZqKrA9B4evM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_505b799b-4660-48d0-9e77-f3c589dd568f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166332",
      "source": "custom",
      "poi_name": "Carriage Way Park",
      "poi_type": "Outdoor",
      "poi_address": "651 Riverside Dr, Milford, OH 45150, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/019fce03-9f55-729f-99c1-706e7b7e53b8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce03-9f55-729f-99c1-706e7b7e53b8",
        "storage_key": "property/6767906449166332/019fce03-9f55-729f-99c1-706e7b7e53b8.webp",
        "width": 964,
        "height": 1280
      },
      "poi_business_url": "http://www.milfordohio.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14229801797395298820&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "carriage-way-park",
      "poi_latitude": "39.1800061",
      "poi_longitude": "-84.2896523",
      "poi_miles_from_property": "5.3 mi",
      "poi_walking_minutes": "1 hour 54 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 513-248-5090",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/019d0269-1bea-725f-8b96-17449f75af8e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-1bea-725f-8b96-17449f75af8e",
        "storage_key": "property/6767906449166332/019d0269-1bea-725f-8b96-17449f75af8e.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ2y81P7WqQYgRBDr2jVdpesU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_25592eb8-1efc-48b3-81bc-4040e08aa880",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166332",
      "source": "custom",
      "poi_name": "Riverside Park",
      "poi_type": "Outdoor",
      "poi_address": "425 Victor Stier Dr, Milford, OH 45150, USA",
      "poi_short_description": "Family-friendly park with river views, a playground, picnic tables, and a seasonal restroom.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/019fce03-a0fd-720b-94e8-d530940fde7b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce03-a0fd-720b-94e8-d530940fde7b",
        "storage_key": "property/6767906449166332/019fce03-a0fd-720b-94e8-d530940fde7b.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.milfordohio.org/departments/public_works_department/parks_and_recreation/riverside_park_(playground).php",
      "poi_directions_map_url": "https://maps.google.com/?cid=10667013285426415765&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "riverside-park",
      "poi_latitude": "39.1763884",
      "poi_longitude": "-84.2959952",
      "poi_miles_from_property": "5.5 mi",
      "poi_walking_minutes": "1 hour 59 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 513-831-4192",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/019d0269-1bea-725f-8b96-17449f75af8e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-1bea-725f-8b96-17449f75af8e",
        "storage_key": "property/6767906449166332/019d0269-1bea-725f-8b96-17449f75af8e.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-Y0jFxKrQYgRlcg2HBHYCJQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_93f99388-1781-40ed-98fa-6be325730bfd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166332",
      "source": "custom",
      "poi_name": "Milford Trailhead",
      "poi_type": "Outdoor",
      "poi_address": "5 OH-126, Milford, OH 45243, USA",
      "poi_short_description": "Scenic, paved trail along a river that’s popular for biking, hiking and walking.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/019fce03-8bd8-75cf-90da-5a3b6b64e0ac.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce03-8bd8-75cf-90da-5a3b6b64e0ac",
        "storage_key": "property/6767906449166332/019fce03-8bd8-75cf-90da-5a3b6b64e0ac.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.milfordohio.org/departments/public_works_department/parks_and_recreation/milford_bike_trail.php",
      "poi_directions_map_url": "https://maps.google.com/?cid=13154954685311207057&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "milford-trailhead",
      "poi_latitude": "39.1717506",
      "poi_longitude": "-84.2996105",
      "poi_miles_from_property": "5.9 mi",
      "poi_walking_minutes": "2 hours 8 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/019d0269-1bea-725f-8b96-17449f75af8e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-1bea-725f-8b96-17449f75af8e",
        "storage_key": "property/6767906449166332/019d0269-1bea-725f-8b96-17449f75af8e.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJkcGems-qQYgRkcZVnpbJj7Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_01c6b717-d721-4f33-a4c7-56ba456e9d3a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166332",
      "source": "custom",
      "poi_name": "Leming House",
      "poi_type": "Outdoor",
      "poi_address": "5951 Buckwheat Rd, Milford, OH 45150, USA",
      "poi_short_description": "Casual park featuring a frisbee golf course, tennis courts and volleyball nets.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/019fce03-a1d0-7114-b1af-5df14e519622.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce03-a1d0-7114-b1af-5df14e519622",
        "storage_key": "property/6767906449166332/019fce03-a1d0-7114-b1af-5df14e519622.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.miamitwpoh.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2898342178432378603&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "leming-house",
      "poi_latitude": "39.193043",
      "poi_longitude": "-84.22346259999999",
      "poi_miles_from_property": "2.6 mi",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 513-248-3727",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/019d0269-1bea-725f-8b96-17449f75af8e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-1bea-725f-8b96-17449f75af8e",
        "storage_key": "property/6767906449166332/019d0269-1bea-725f-8b96-17449f75af8e.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6TJz9zP-QIgR62b-7tr6OCg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_43458989-bb63-450b-96c4-a2dc37c3b40f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166332",
      "source": "custom",
      "poi_name": "Miami Meadows Park",
      "poi_type": "Outdoor",
      "poi_address": "1546 OH-131, Milford, OH 45150, USA",
      "poi_short_description": "Sprawling park featuring ball fields, a playground and a skate park, plus a lake for fishing.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/019fce03-a406-70ff-b2e7-6cdf6cc38adb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce03-a406-70ff-b2e7-6cdf6cc38adb",
        "storage_key": "property/6767906449166332/019fce03-a406-70ff-b2e7-6cdf6cc38adb.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.miamitwpoh.gov/meadows.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=930838075605038405&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "miami-meadows-park",
      "poi_latitude": "39.17699349999999",
      "poi_longitude": "-84.2009303",
      "poi_miles_from_property": "3.8 mi",
      "poi_walking_minutes": "1 hour 25 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 513-248-3727",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/019d0269-1bea-725f-8b96-17449f75af8e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-1bea-725f-8b96-17449f75af8e",
        "storage_key": "property/6767906449166332/019d0269-1bea-725f-8b96-17449f75af8e.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJSUx3-x3-QIgRRbXYR0wA6ww",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_18942882-6f58-45c0-961f-fb8fa9321196",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166332",
      "source": "custom",
      "poi_name": "Paxton Ramsey Park",
      "poi_type": "Outdoor",
      "poi_address": "6265 Price Rd, Loveland, OH 45140, USA",
      "poi_short_description": "Relaxed park featuring baseball fields, playgrounds and trails.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/019fce03-a704-777c-950a-7e09db9e6d86.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce03-a704-777c-950a-7e09db9e6d86",
        "storage_key": "property/6767906449166332/019fce03-a704-777c-950a-7e09db9e6d86.webp",
        "width": 964,
        "height": 1280
      },
      "poi_business_url": "https://www.miamitwpoh.gov/paxton.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=3279322673459347012&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "paxton-ramsey-park",
      "poi_latitude": "39.2211846",
      "poi_longitude": "-84.27100519999999",
      "poi_miles_from_property": "8.8 mi",
      "poi_walking_minutes": "3 hours 13 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 513-248-3725",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/019d0269-1bea-725f-8b96-17449f75af8e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-1bea-725f-8b96-17449f75af8e",
        "storage_key": "property/6767906449166332/019d0269-1bea-725f-8b96-17449f75af8e.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJt7YOH4BVQIgRRL5tz5h-gi0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_c3c230bc-6880-4cbd-bec4-07c6d1be0f1c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166332",
      "source": "custom",
      "poi_name": "Lake Isabella",
      "poi_type": "Outdoor",
      "poi_address": "10174 E Loveland Madeira Rd, Loveland, OH 45140, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/019fce03-a78c-77e9-8df8-3a36432598ae.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce03-a78c-77e9-8df8-3a36432598ae",
        "storage_key": "property/6767906449166332/019fce03-a78c-77e9-8df8-3a36432598ae.webp",
        "width": 1280,
        "height": 608
      },
      "poi_business_url": "http://www.greatparks.org/parks/lake-isabella",
      "poi_directions_map_url": "https://maps.google.com/?cid=3625774360889078570&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lake-isabella",
      "poi_latitude": "39.2355614",
      "poi_longitude": "-84.30338499999999",
      "poi_miles_from_property": "16.8 mi",
      "poi_walking_minutes": "6 hours 8 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 513-791-1663",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/019d0269-1bea-725f-8b96-17449f75af8e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-1bea-725f-8b96-17449f75af8e",
        "storage_key": "property/6767906449166332/019d0269-1bea-725f-8b96-17449f75af8e.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJf1YQlrBVQIgRKjODMJJWUTI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_d7f97123-8dba-458b-8c74-b3cd227bb522",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166332",
      "source": "custom",
      "poi_name": "Cincinnati/Northern Kentucky International Airport",
      "poi_type": "Transit",
      "poi_address": "3087 Terminal Dr, Hebron, KY 41048, USA",
      "poi_short_description": "This Midwest-area airport features a range of restaurants & shops as well as free WiFi.",
      "poi_long_description": "This Midwest-area airport features a range of restaurants & shops as well as free WiFi.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/019fce03-a852-74ca-b3d2-c59e86def1cc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce03-a852-74ca-b3d2-c59e86def1cc",
        "storage_key": "property/6767906449166332/019fce03-a852-74ca-b3d2-c59e86def1cc.webp",
        "width": 1280,
        "height": 753
      },
      "poi_business_url": "https://www.cvgairport.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12365270883012791774&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cincinnatinorthern-kentucky-international-airport",
      "poi_latitude": "39.051351",
      "poi_longitude": "-84.6671453",
      "poi_miles_from_property": "30.5 mi",
      "poi_walking_minutes": "11 hours 27 mins",
      "poi_biking_minutes": "3 hours 14 mins",
      "poi_driving_minutes": "37 mins",
      "poi_business_phone": "+1 859-767-3151",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/019d0269-2171-74ca-b03b-25be7a9d28bf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-2171-74ca-b03b-25be7a9d28bf",
        "storage_key": "property/6767906449166332/019d0269-2171-74ca-b03b-25be7a9d28bf.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJn2Ux9vLIQYgR3k11pVpEmqs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_5d793c09-1c71-4f36-b808-35a02a89e131",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166332",
      "source": "custom",
      "poi_name": "Cincinnati Union Terminal",
      "poi_type": "Transit",
      "poi_address": "Cincinnati Museum Center, 1301 Western Ave, Cincinnati, OH 45203, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/019fce03-ab7e-73c9-aafb-ba42bbbc0b0e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce03-ab7e-73c9-aafb-ba42bbbc0b0e",
        "storage_key": "property/6767906449166332/019fce03-ab7e-73c9-aafb-ba42bbbc0b0e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.amtrak.com/servlet/ContentServer?pagename=am/am2Station/Station_Page&code=CIN",
      "poi_directions_map_url": "https://maps.google.com/?cid=1631030112950745244&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cincinnati-union-terminal",
      "poi_latitude": "39.1099204",
      "poi_longitude": "-84.5376308",
      "poi_miles_from_property": "20.9 mi",
      "poi_walking_minutes": "7 hours 51 mins",
      "poi_biking_minutes": "2 hours 3 mins",
      "poi_driving_minutes": "31 mins",
      "poi_business_phone": "+1 800-872-7245",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/019d0269-210d-772d-9f49-26c8772e367f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-210d-772d-9f49-26c8772e367f",
        "storage_key": "property/6767906449166332/019d0269-210d-772d-9f49-26c8772e367f.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJX7j59h20QYgRnPhkBD-VohY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_fe21bf3d-bddf-4bcf-a298-eb5f00246857",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166332",
      "source": "custom",
      "poi_name": "Milford High School",
      "poi_type": "Transit",
      "poi_address": "1 Eagles Watch Wy, Milford, OH 45150, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/019fce03-7a2b-76f9-b030-9c92c123b4ef.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce03-7a2b-76f9-b030-9c92c123b4ef",
        "storage_key": "property/6767906449166332/019fce03-7a2b-76f9-b030-9c92c123b4ef.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.milfordschools.org/milford-high-school/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14056404391428845552&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "milford-high-school",
      "poi_latitude": "39.179768",
      "poi_longitude": "-84.2410795",
      "poi_miles_from_property": "2.2 mi",
      "poi_walking_minutes": "51 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 513-831-2990",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/019d0269-14e4-769f-945f-f4982e794f22.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-14e4-769f-945f-f4982e794f22",
        "storage_key": "property/6767906449166332/019d0269-14e4-769f-945f-f4982e794f22.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJuayz89j_QIgR8G9b6lFhEsM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_1ae05c89-507d-487d-a5b3-3dec33542151",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166332",
      "source": "custom",
      "poi_name": "Kroger",
      "poi_type": "Transit",
      "poi_address": "824 Main St, Milford, OH 45150, USA",
      "poi_short_description": "Large supermarket chain with deli & bakery departments, plus health & beauty products.",
      "poi_long_description": "Large supermarket chain with deli & bakery departments, plus health & beauty products.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/019fce03-6404-714d-8de2-5bcf2efb4a14.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce03-6404-714d-8de2-5bcf2efb4a14",
        "storage_key": "property/6767906449166332/019fce03-6404-714d-8de2-5bcf2efb4a14.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://www.kroger.com/stores/grocery/oh/milford/milford/014/00411?cid=loc_01400411_gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=16777180959384242028&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kroger",
      "poi_latitude": "39.1761065",
      "poi_longitude": "-84.280546",
      "poi_miles_from_property": "4.6 mi",
      "poi_walking_minutes": "1 hour 40 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 513-965-3640",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/019d0269-152d-77ef-8180-822e698be595.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-152d-77ef-8180-822e698be595",
        "storage_key": "property/6767906449166332/019d0269-152d-77ef-8180-822e698be595.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJQ3aaSc-qQYgRbIeLeDGF1Og",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_c5a443f3-0dc8-45b6-b633-934709af6c76",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166332",
      "source": "custom",
      "poi_name": "Union Township Civic Center",
      "poi_type": "Transit",
      "poi_address": "4350 Aicholtz Rd, Cincinnati, OH 45245, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/019fce03-ae65-771b-9691-bf28660efbd8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce03-ae65-771b-9691-bf28660efbd8",
        "storage_key": "property/6767906449166332/019fce03-ae65-771b-9691-bf28660efbd8.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.utclermont.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13134572143512413692&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "union-township-civic-center",
      "poi_latitude": "39.0913421",
      "poi_longitude": "-84.2736973",
      "poi_miles_from_property": "13.4 mi",
      "poi_walking_minutes": "4 hours 58 mins",
      "poi_biking_minutes": "1 hour 4 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 513-752-1741",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/019d0269-222f-7785-abbc-76dddd960eb1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-222f-7785-abbc-76dddd960eb1",
        "storage_key": "property/6767906449166332/019d0269-222f-7785-abbc-76dddd960eb1.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJU1rVA_ypQYgR_GXMSsZfR7Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_71a2b190-e5f4-4ec9-b000-dd0ed25f86d2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166332",
      "source": "custom",
      "poi_name": "Clermont County Transportation",
      "poi_type": "Transit",
      "poi_address": "4003 Filager Rd, Batavia, OH 45103, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://ctc.clermontcountyohio.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13370330569996939011&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "clermont-county-transportation",
      "poi_latitude": "39.0951141",
      "poi_longitude": "-84.1874818",
      "poi_miles_from_property": "11.9 mi",
      "poi_walking_minutes": "4 hours 19 mins",
      "poi_biking_minutes": "56 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 513-732-7433",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/019d0269-0f2a-7174-a857-44a9586e5de6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-0f2a-7174-a857-44a9586e5de6",
        "storage_key": "property/6767906449166332/019d0269-0f2a-7174-a857-44a9586e5de6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJh3voDlUBQYgRA682etD0jLk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_e8df8db2-61be-4c79-a5cc-8c5c2d2973fa",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166332",
      "source": "custom",
      "poi_name": "EastGate Mall",
      "poi_type": "Transit",
      "poi_address": "4601 Eastgate Blvd, Cincinnati, OH 45245, USA",
      "poi_short_description": "Mall with a whimsical atrium, major department stores, brand chains, personal services & quick eats.",
      "poi_long_description": "Mall with a whimsical atrium, major department stores, brand chains, personal services & quick eats.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/019fce03-ae66-72f3-a971-4192e5385952.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce03-ae66-72f3-a971-4192e5385952",
        "storage_key": "property/6767906449166332/019fce03-ae66-72f3-a971-4192e5385952.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://visiteastgatemall.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11133692944476035563&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "eastgate-mall",
      "poi_latitude": "39.1030232",
      "poi_longitude": "-84.2779731",
      "poi_miles_from_property": "14.0 mi",
      "poi_walking_minutes": "5 hours 11 mins",
      "poi_biking_minutes": "1 hour 1 min",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 513-653-7667",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/019d0269-152e-700e-bdf3-2ec447c4d9ad.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-152e-700e-bdf3-2ec447c4d9ad",
        "storage_key": "property/6767906449166332/019d0269-152e-700e-bdf3-2ec447c4d9ad.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJqc-7eASqQYgR61nEgb7Sgpo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_ffba38b7-5fcb-4610-9aea-9c69fedc159e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166332",
      "source": "custom",
      "poi_name": "Meijer",
      "poi_type": "Transit",
      "poi_address": "1082 State Rte 28, Milford, OH 45150, USA",
      "poi_short_description": "Chain retailer featuring brand-name groceries plus apparel, electronics & more.",
      "poi_long_description": "Chain retailer featuring brand-name groceries plus apparel, electronics & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/019fce03-60da-707a-8ef7-d2c00fb967fb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce03-60da-707a-8ef7-d2c00fb967fb",
        "storage_key": "property/6767906449166332/019fce03-60da-707a-8ef7-d2c00fb967fb.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.meijer.com/shopping/store-locator/157.html?cmpid=LM:Web::::05112021::GoogleGrocery",
      "poi_directions_map_url": "https://maps.google.com/?cid=9275836902426447210&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "meijer",
      "poi_latitude": "39.1967582",
      "poi_longitude": "-84.2372742",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 513-576-5500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/019d0269-152d-77ef-8180-822e698be595.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-152d-77ef-8180-822e698be595",
        "storage_key": "property/6767906449166332/019d0269-152d-77ef-8180-822e698be595.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJO5BSZ8j_QIgRao2Wa4RkuoA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_d77b645d-8e48-45f9-9af1-9f607aab4713",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166332",
      "source": "custom",
      "poi_name": "St. Thomas More Church",
      "poi_type": "Transit",
      "poi_address": "800 Ohio Pike, Cincinnati, OH 45245, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/019fce03-aeca-715e-b37d-d75ed5d1626a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce03-aeca-715e-b37d-d75ed5d1626a",
        "storage_key": "property/6767906449166332/019fce03-aeca-715e-b37d-d75ed5d1626a.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.sttm.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17833003331852826079&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "st-thomas-more-church",
      "poi_latitude": "39.065543",
      "poi_longitude": "-84.2816172",
      "poi_miles_from_property": "11.1 mi",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "1 hour 10 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 513-752-2080",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/019d0269-2501-74d1-8d1f-c1fe55322e09.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-2501-74d1-8d1f-c1fe55322e09",
        "storage_key": "property/6767906449166332/019d0269-2501-74d1-8d1f-c1fe55322e09.webp",
        "width": 144,
        "height": 192
      },
      "poi_google_place_id": "ChIJpSfG68-pQYgR3_VxCQyOe_c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_8ce962ef-1111-463c-af17-5a743f26bca3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166332",
      "source": "custom",
      "poi_name": "MILFORD Siemens",
      "poi_type": "Offices",
      "poi_address": "2000 Eastman Dr, Milford, OH 45150, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/019fce03-b27c-714f-a3c7-e4d5652c26bb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce03-b27c-714f-a3c7-e4d5652c26bb",
        "storage_key": "property/6767906449166332/019fce03-b27c-714f-a3c7-e4d5652c26bb.webp",
        "width": 1036,
        "height": 691
      },
      "poi_business_url": "http://www.usa.siemens.com/usa",
      "poi_directions_map_url": "https://maps.google.com/?cid=7042172218311312670&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "milford-siemens",
      "poi_latitude": "39.1584858",
      "poi_longitude": "-84.2456545",
      "poi_miles_from_property": "5.7 mi",
      "poi_walking_minutes": "2 hours 8 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 513-576-2400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/019d0269-0f2a-7174-a857-44a9586e5de6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-0f2a-7174-a857-44a9586e5de6",
        "storage_key": "property/6767906449166332/019d0269-0f2a-7174-a857-44a9586e5de6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJFzsSez8AQYgRHgWST1LSumE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_0405df77-f0db-443c-a065-8e6693f20f98",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166332",
      "source": "custom",
      "poi_name": "Tata Consultancy Services",
      "poi_type": "Offices",
      "poi_address": "1000 Summit Dr, Milford, OH 45150, USA",
      "poi_short_description": "Chain business management consultancy requiring appointments.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/019fce03-b4e4-766e-8656-ea0c0dd6cb97.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce03-b4e4-766e-8656-ea0c0dd6cb97",
        "storage_key": "property/6767906449166332/019fce03-b4e4-766e-8656-ea0c0dd6cb97.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.tcs.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15178972413087011617&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tata-consultancy-services",
      "poi_latitude": "39.1497254",
      "poi_longitude": "-84.244659",
      "poi_miles_from_property": "6.2 mi",
      "poi_walking_minutes": "2 hours 18 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 513-677-6500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/019d0269-0f2a-7174-a857-44a9586e5de6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-0f2a-7174-a857-44a9586e5de6",
        "storage_key": "property/6767906449166332/019d0269-0f2a-7174-a857-44a9586e5de6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJLX9XgkMAQYgRIVOB8fyKptI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_0fb946a1-4fef-4777-b078-823948ce8e07",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166332",
      "source": "custom",
      "poi_name": "UC Clermont College",
      "poi_type": "Offices",
      "poi_address": "4200 Clermont College Dr, Batavia, OH 45103, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/019fce03-7ce5-76f1-9f45-d3f828352580.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce03-7ce5-76f1-9f45-d3f828352580",
        "storage_key": "property/6767906449166332/019fce03-7ce5-76f1-9f45-d3f828352580.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.ucclermont.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11199487859864516124&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "uc-clermont-college",
      "poi_latitude": "39.0797116",
      "poi_longitude": "-84.1955973",
      "poi_miles_from_property": "14.3 mi",
      "poi_walking_minutes": "5 hours 17 mins",
      "poi_biking_minutes": "1 hour 9 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 513-732-5200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/019d0269-14e4-769f-945f-f4982e794f22.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-14e4-769f-945f-f4982e794f22",
        "storage_key": "property/6767906449166332/019d0269-14e4-769f-945f-f4982e794f22.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJbSpACLsGQYgRHDaGAd-SbJs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_b1d9a216-203d-4c52-a626-9dfa882a1206",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166332",
      "source": "custom",
      "poi_name": "Mercy Health - Clermont Hospital",
      "poi_type": "Offices",
      "poi_address": "3000 Hospital Dr, Batavia, OH 45103, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/019fce03-8fd4-7439-b537-238c70785c79.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce03-8fd4-7439-b537-238c70785c79",
        "storage_key": "property/6767906449166332/019fce03-8fd4-7439-b537-238c70785c79.webp",
        "width": 704,
        "height": 396
      },
      "poi_business_url": "https://www.mercy.com/locations/hospitals/cincinnati/mercy-health-clermont-hospital",
      "poi_directions_map_url": "https://maps.google.com/?cid=14580036950875791963&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mercy-health---clermont-hospital",
      "poi_latitude": "39.0798998",
      "poi_longitude": "-84.14453809999999",
      "poi_miles_from_property": "13.1 mi",
      "poi_walking_minutes": "4 hours 53 mins",
      "poi_biking_minutes": "1 hour 19 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 513-732-8200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/019d0269-1de1-7075-9101-7de95e38916b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-1de1-7075-9101-7de95e38916b",
        "storage_key": "property/6767906449166332/019d0269-1de1-7075-9101-7de95e38916b.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJE2j7tmIEQYgRW2IFxVuyVso",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_062742ec-c155-4c0d-93be-f39afa04cd62",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166332",
      "source": "custom",
      "poi_name": "Clermont County Common Pleas Court",
      "poi_type": "Offices",
      "poi_address": "270 E Main St # 7, Batavia, OH 45103, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/019fce03-b73b-74c5-8049-2959a31e66b0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce03-b73b-74c5-8049-2959a31e66b0",
        "storage_key": "property/6767906449166332/019fce03-b73b-74c5-8049-2959a31e66b0.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.clermontcommonpleas.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12695867774784540041&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "clermont-county-common-pleas-court",
      "poi_latitude": "39.0765002",
      "poi_longitude": "-84.176075",
      "poi_miles_from_property": "12.6 mi",
      "poi_walking_minutes": "4 hours 38 mins",
      "poi_biking_minutes": "1 hour 3 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 513-732-7108",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/019d0269-222f-7785-abbc-76dddd960eb1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-222f-7785-abbc-76dddd960eb1",
        "storage_key": "property/6767906449166332/019d0269-222f-7785-abbc-76dddd960eb1.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-WUk9BkEQYgRiY1cv3nIMLA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_319028c6-b76c-462b-814d-fbcb7818af10",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166332",
      "source": "custom",
      "poi_name": "Clermont County Board of County Commissioners",
      "poi_type": "Offices",
      "poi_address": "101 E Main St, Batavia, OH 45103, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/019fce03-b4ff-75df-954f-8e3e094684ac.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce03-b4ff-75df-954f-8e3e094684ac",
        "storage_key": "property/6767906449166332/019fce03-b4ff-75df-954f-8e3e094684ac.webp",
        "width": 1280,
        "height": 497
      },
      "poi_business_url": "http://bcc.clermontcountyohio.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16931175156632301946&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "clermont-county-board-of-county-commissioners",
      "poi_latitude": "39.0775985",
      "poi_longitude": "-84.1786678",
      "poi_miles_from_property": "12.4 mi",
      "poi_walking_minutes": "4 hours 35 mins",
      "poi_biking_minutes": "1 hour 3 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 513-732-7300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/019d0269-222f-7785-abbc-76dddd960eb1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-222f-7785-abbc-76dddd960eb1",
        "storage_key": "property/6767906449166332/019d0269-222f-7785-abbc-76dddd960eb1.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJYe_FxBsEQYgRerH8iBme9-o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_c25beef0-1d76-4705-9a02-928a4f78efb5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166332",
      "source": "custom",
      "poi_name": "Milford Exempted Village School District",
      "poi_type": "Offices",
      "poi_address": "1099 OH-131, Milford, OH 45150, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.milfordschools.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15587688478912400620&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "milford-exempted-village-school-district",
      "poi_latitude": "39.1743774",
      "poi_longitude": "-84.23996509999999",
      "poi_miles_from_property": "2.5 mi",
      "poi_walking_minutes": "56 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 513-831-1314",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/019d0269-14e4-769f-945f-f4982e794f22.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-14e4-769f-945f-f4982e794f22",
        "storage_key": "property/6767906449166332/019d0269-14e4-769f-945f-f4982e794f22.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJwydQ3nsBQYgR7MwFnxWYUtg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_c4fae74c-a911-4bf4-870c-745626a33688",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166332",
      "source": "custom",
      "poi_name": "The Kroger Co. Corporate Headquarters",
      "poi_type": "Offices",
      "poi_address": "1014 Vine St, Cincinnati, OH 45202, USA",
      "poi_short_description": "Large supermarket chain with deli & bakery departments, plus health & beauty aids.",
      "poi_long_description": "Large supermarket chain with deli & bakery departments, plus health & beauty aids.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/019fce03-b8be-779f-a3db-aebc3a843be7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce03-b8be-779f-a3db-aebc3a843be7",
        "storage_key": "property/6767906449166332/019fce03-b8be-779f-a3db-aebc3a843be7.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.thekrogerco.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14592949496921750256&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-kroger-co-corporate-headquarters",
      "poi_latitude": "39.1068195",
      "poi_longitude": "-84.5141589",
      "poi_miles_from_property": "19.6 mi",
      "poi_walking_minutes": "7 hours 21 mins",
      "poi_biking_minutes": "1 hour 56 mins",
      "poi_driving_minutes": "29 mins",
      "poi_business_phone": "+1 513-762-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/019d0269-152d-77ef-8180-822e698be595.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-152d-77ef-8180-822e698be595",
        "storage_key": "property/6767906449166332/019d0269-152d-77ef-8180-822e698be595.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ2UJnrFexQYgR8Ho8LUCShMo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_2e5de5db-25f8-4e34-ab23-4e6bd180a8a1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166332",
      "source": "custom",
      "poi_name": "GE Aviation",
      "poi_type": "Offices",
      "poi_address": "1 Neumann Way, Cincinnati, OH 45215, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/019fce03-bbd9-732a-b243-d5b07e10bd64.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce03-bbd9-732a-b243-d5b07e10bd64",
        "storage_key": "property/6767906449166332/019fce03-bbd9-732a-b243-d5b07e10bd64.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.geaerospace.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6835781543147292045&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ge-aviation",
      "poi_latitude": "39.2448741",
      "poi_longitude": "-84.4431261",
      "poi_miles_from_property": "17.8 mi",
      "poi_walking_minutes": "6 hours 35 mins",
      "poi_biking_minutes": "1 hour 30 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 513-243-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/019d0269-0f2a-7174-a857-44a9586e5de6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-0f2a-7174-a857-44a9586e5de6",
        "storage_key": "property/6767906449166332/019d0269-0f2a-7174-a857-44a9586e5de6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJg2K3y41NQIgRjUV3kRiT3V4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_fd400048-d416-4884-bc70-5b772241a90f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166332",
      "source": "custom",
      "poi_name": "Cintas Corporation",
      "poi_type": "Offices",
      "poi_address": "6800 Cintas Blvd, Mason, OH 45040, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/019fce03-bb47-7788-8114-04fefcd1c3d5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce03-bb47-7788-8114-04fefcd1c3d5",
        "storage_key": "property/6767906449166332/019fce03-bb47-7788-8114-04fefcd1c3d5.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.cintas.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11313333694386927973&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cintas-corporation",
      "poi_latitude": "39.34118160000001",
      "poi_longitude": "-84.282986",
      "poi_miles_from_property": "14.2 mi",
      "poi_walking_minutes": "5 hours 15 mins",
      "poi_biking_minutes": "1 hour 19 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 513-459-1200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/019d0269-0f2a-7174-a857-44a9586e5de6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-0f2a-7174-a857-44a9586e5de6",
        "storage_key": "property/6767906449166332/019d0269-0f2a-7174-a857-44a9586e5de6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJIVYB6vBXQIgRZflj7w0JAZ0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    }
  ],
  "office_hours": [
    {
      "id": "custom_22a707e3-37aa-49b6-aae0-e82e71c8241e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166332",
      "day": "MON",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_1874f94d-dace-402b-b5d7-d4ca22b26bcb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166332",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_b77fae24-5d22-4139-a36f-0da2edd04733",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166332",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_60208fa9-b002-4bd3-ad1c-f051d794b898",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166332",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_86703377-5dc5-4e10-8547-b7a71ff0cc8c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166332",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_44bf2380-ffcc-4bce-94c9-45a0c9bc7370",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166332",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "ec_4d388586f1cd644bcaf97ff1",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166332",
      "rating": "5",
      "name": "Betty Thibodeaux",
      "text": "I visited the apartments for a family member. Love what you are doing and all the changes. Staff were very friendly and helpful. Made me feel so welcome. Great place!",
      "date": "2025-08-08",
      "title": "false"
    },
    {
      "id": "ec_01ff1071a6f57265ff1ed6b8",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166332",
      "rating": "5",
      "name": "Scott Luck",
      "text": "Zach! Welcome, and thank you. You were so prompt in fixing our disposal - and it was so nice to talk with you a minute. You were great! Thank you!",
      "date": "2025-11-16",
      "title": "false"
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_92513657-51bc-4811-8cc2-60760b7a304a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166332",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/019fce6c-3f10-72e4-8fde-445efe32c4a4.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Dining room with a wooden table and chairs, leading to a kitchen.",
        "public_id": "019fce6c-3f10-72e4-8fde-445efe32c4a4",
        "storage_key": "property/6767906449166332/019fce6c-3f10-72e4-8fde-445efe32c4a4.webp",
        "width": 1920,
        "height": 1280
      },
      "virtual_tour_title": "Millcroft Apartments & Townhomes",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://tour.tourbuilder.com?tour=6aac979e49e01b4df9fd3491"
    }
  ],
  "faqs": [],
  "fees": [
    {
      "id": "ec_85a6fc15cea42e7c884cf997",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166332",
      "source": "engrain",
      "external_id": "429383",
      "name": "Admin Fee",
      "description": "false",
      "amount": 100,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "One-time, due at application",
      "category": "contracting",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_a4ce6709dbcd8856d53167ef",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166332",
      "source": "engrain",
      "external_id": "429384",
      "name": "Amenity Fee",
      "description": "false",
      "amount": 125,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "One-time, due at move-in",
      "category": "community",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_77f90cae3b3800c418db432e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166332",
      "source": "engrain",
      "external_id": "429385",
      "name": "Application Fee",
      "description": "Per applicant.",
      "amount": 75,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "One-time, due at application",
      "category": "contracting",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_65f4b67438d2f4cfb697d85c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166332",
      "source": "engrain",
      "external_id": "429386",
      "name": "Security Deposit",
      "description": "Deposit amount applies with approved credit and may be higher for conditional approvals.",
      "amount": 750,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "One-time, due at move-in",
      "category": "contracting",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": true,
      "is_taxable": false
    },
    {
      "id": "ec_64f14b5d7546bab9927ba8ae",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166332",
      "source": "engrain",
      "external_id": "429387",
      "name": "Month To Month Fee",
      "description": "false",
      "amount": 350,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Monthly",
      "category": "contracting",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_9b2e1d9b75f787b56c432b72",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166332",
      "source": "engrain",
      "external_id": "429388",
      "name": "Pest Control",
      "description": "false",
      "amount": 5,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Monthly, due at move-in",
      "category": "utilities",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_8ced472e713db0d1702152a4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166332",
      "source": "engrain",
      "external_id": "429389",
      "name": "Pet Fee",
      "description": "false",
      "amount": 350,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "One-time, due at move-in",
      "category": "pets_other",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_11dd2ccb1639f7b1714e4ecb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166332",
      "source": "engrain",
      "external_id": "429390",
      "name": "Pet Rent",
      "description": "false",
      "amount": 50,
      "amount_max": 0,
      "amount_raw": "50.00 / 25.00",
      "amount_type": "text",
      "timing": "Monthly, due at move-in",
      "category": "pets_other",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_24d146d8ed64eee58fd96c7b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166332",
      "source": "engrain",
      "external_id": "429392",
      "name": "Transfer Fee",
      "description": "false",
      "amount": 500,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Per occurrence",
      "category": "contracting",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_a802b6f2e938709e5ba7d5a2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166332",
      "source": "engrain",
      "external_id": "429394",
      "name": "Trash Service",
      "description": "false",
      "amount": 15,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Monthly, due at move-in",
      "category": "utilities",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_73c5004d4b8e30135063e5a6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166332",
      "source": "engrain",
      "external_id": "484482",
      "name": "Reservation Fee",
      "description": "false",
      "amount": 200,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "One-time, due at application",
      "category": "contracting",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_57211e0f2058c9d2e5d83a07",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166332",
      "source": "engrain",
      "external_id": "541003",
      "name": "Utility - Water/Sewer Service",
      "description": "false",
      "amount": 59,
      "amount_max": 124,
      "amount_raw": "false",
      "amount_type": "range",
      "timing": "Monthly, due at move-in",
      "category": "utilities",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_00a5a7e38ed0ab873e7223e8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166332",
      "source": "engrain",
      "external_id": "543075",
      "name": "Utility - Electric Service",
      "description": "false",
      "amount": 0,
      "amount_max": 0,
      "amount_raw": "Usage-Based (Utilities)",
      "amount_type": "text",
      "timing": "Monthly, due at move-in",
      "category": "utilities",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_721d8b7a90240e30b33f5df1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166332",
      "source": "engrain",
      "external_id": "835158",
      "name": "Late Fee",
      "description": "false",
      "amount": 10,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "percentage",
      "timing": "Per occurrence",
      "category": "penalties",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_be165602daef7d3ace340bef",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166332",
      "source": "engrain",
      "external_id": "835159",
      "name": "Amenity Fee - Renewal",
      "description": "false",
      "amount": 100,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Annually, due at move-in",
      "category": "community",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_2c459d87dd17490e5b0acc17",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166332",
      "source": "engrain",
      "external_id": "835172",
      "name": "Buy-Out Fee",
      "description": "false",
      "amount": 0,
      "amount_max": 0,
      "amount_raw": "Two Month's Rent",
      "amount_type": "text",
      "timing": "One-time",
      "category": "contracting",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_d47fbd9539e5622453df0bf3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166332",
      "source": "engrain",
      "external_id": "835189",
      "name": "NSF/Returned Check Fee",
      "description": "false",
      "amount": 50,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Per occurrence",
      "category": "contracting",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    }
  ],
  "pet_policies": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019a1318-8ebd-76f7-aeb5-b339ddd02da4",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "aion-millcroft-apartments--townhomes-auto",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166332"
    },
    {
      "lead_collector_id": "019c3043-7c84-7448-ad45-fe57044f58f2",
      "lead_source": "FACEBOOK_ADS",
      "name": "millcroft-apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166332"
    },
    {
      "lead_collector_id": "019c3043-7cf4-732b-bcc8-eadc39578cd0",
      "lead_source": "LANDING_PAGE",
      "name": "millcroft-apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166332"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166332",
      "source": "custom",
      "page_item_url": "pet-friendly-apartments-milford-oh-922",
      "search_query": "pet friendly apartments Milford OH",
      "category": "Amenity",
      "h1_title": "Pet-Friendly Apartments in Milford, OH",
      "h2_subtitle": "Discover pet-friendly living at Millcroft Apartments in Milford, OH. Enjoy amenities that cater to you and your furry friend.",
      "page_copy": "Millcroft Apartments & Townhomes is the perfect place for you and your furry family members in Milford, OH. Our pet-friendly community welcomes you with open arms and offers spacious one and two-bedroom apartments designed with both comfort and style in mind. Explore our amenities, including a dedicated dog park where your pets can play while you enjoy the vibrant community life.\n\nSituated in a serene part of Clermont County, Millcroft Apartments provides residents with a modern living experience that includes on-site maintenance and a community clubhouse. Spend a sunny afternoon lounging by the pool or enjoy a family picnic in our designated areas. Experience the joy of having a welcoming home with the convenience of being close to all the action in Milford. Your pets are sure to love their new neighborhood just as much as you do!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/01a015da-bdfd-7048-97c0-f9b430e44694.webp",
      "featured_image_media": {
        "alt_text": "Swimming pool with lounge chairs and umbrellas",
        "public_id": "01a015da-bdfd-7048-97c0-f9b430e44694",
        "storage_key": "property/6767906449166332/01a015da-bdfd-7048-97c0-f9b430e44694.webp",
        "width": 1478,
        "height": 986
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pet-Friendly Apartments in Milford, OH",
      "seo_description": "Find your next pet-friendly home at Millcroft Apartments in Milford, OH. Enjoy spacious living and amenities for you and your pets.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166332",
      "source": "custom",
      "page_item_url": "apartments-with-pool-clermont-county-665",
      "search_query": "apartments with pool Clermont County",
      "category": "Amenity",
      "h1_title": "Apartments with Pool in Clermont County",
      "h2_subtitle": "Dive into relaxation at Millcroft Apartments & Townhomes with our sparkling pool. Enjoy premium amenities in Clermont County.",
      "page_copy": "At Millcroft Apartments & Townhomes, enjoy the benefits of living in a community that features a refreshing swimming pool, perfect for leisurely swims or unwinding after a long day. Located in the heart of Clermont County, OH, our spacious one and two-bedroom apartments provide the ideal setting for a comfortable and convenient lifestyle.\n\nMore than just a place to live, Millcroft offers a complete living experience with additional amenities like a clubhouse, picnic area, and sundeck. Whether you're soaking in the sun by the pool or gathering with friends in our communal spaces, Millcroft Apartments delivers a sense of community and leisure right to your doorstep in Clermont County. Come and discover why our residents love living here!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/01a015da-bdfd-7048-97c0-f9b430e44694.webp",
      "featured_image_media": {
        "alt_text": "Swimming pool with lounge chairs and umbrellas",
        "public_id": "01a015da-bdfd-7048-97c0-f9b430e44694",
        "storage_key": "property/6767906449166332/01a015da-bdfd-7048-97c0-f9b430e44694.webp",
        "width": 1478,
        "height": 986
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Pool in Clermont County",
      "seo_description": "Enjoy premium living in Clermont County at Millcroft Apartments with a sparkling swimming pool and community-focused amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166332",
      "source": "custom",
      "page_item_url": "dog-park-apartments-near-45150-611",
      "search_query": "dog park apartments near 45150",
      "category": "Amenity",
      "h1_title": "Dog Park Apartments Near 45150",
      "h2_subtitle": "Find ideal pet-friendly living at Millcroft Apartments near 45150. Our dog park is perfect for your furry friends.",
      "page_copy": "Millcroft Apartments & Townhomes offers a welcoming environment for pet owners in the Milford, OH area, located conveniently near the 45150 zip code. Designed with pet lovers in mind, our property includes a spacious dog park where your pets can run and socialize, providing both exercise and fun.\n\nIn addition to our dedicated pet-friendly amenities, Millcroft Apartments features a range of additional conveniences from our swimming pool to a community clubhouse for all residents. Experience community living with a touch of personal comfort in our one and two-bedroom apartments. Embrace a lifestyle that caters to both you and your pets, making Millcroft the perfect choice for dog park apartments near you.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/01a015da-bdfd-7048-97c0-f9b430e44694.webp",
      "featured_image_media": {
        "alt_text": "Swimming pool with lounge chairs and umbrellas",
        "public_id": "01a015da-bdfd-7048-97c0-f9b430e44694",
        "storage_key": "property/6767906449166332/01a015da-bdfd-7048-97c0-f9b430e44694.webp",
        "width": 1478,
        "height": 986
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Dog Park Apartments Near 45150",
      "seo_description": "Discover pet-friendly apartments with a dog park at Millcroft, near 45150. Ideal for you and your pets, with plenty of amenities to enjoy.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166332",
      "source": "custom",
      "page_item_url": "fitness-center-townhomes-milford-27",
      "search_query": "fitness center townhomes in Milford",
      "category": "Amenity",
      "h1_title": "Townhomes with Fitness Center in Milford",
      "h2_subtitle": "Discover comfort and convenience with Millcroft Townhomes. Enjoy access to nearby fitness facilities in Milford, OH.",
      "page_copy": "Discover a new level of living at Millcroft Apartments & Townhomes in Milford, OH. While our community doesn’t feature an on-site fitness center, residents can easily access nearby fitness facilities in the vibrant Milford area. Our spacious townhomes are perfect for those who prioritize a healthy, active lifestyle and wish to stay connected with all that Milford has to offer.\n\nAt Millcroft, you’ll not only enjoy easy access to local fitness options but also benefit from our array of community features, including a swimming pool, clubhouse, and inviting picnic area. Whether you’re relaxing by the sundeck or engaging in community activities, Millcroft provides a comfortable, community-driven environment, making it the perfect setting for an active lifestyle in Milford.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/01a015da-bdfd-7048-97c0-f9b430e44694.webp",
      "featured_image_media": {
        "alt_text": "Swimming pool with lounge chairs and umbrellas",
        "public_id": "01a015da-bdfd-7048-97c0-f9b430e44694",
        "storage_key": "property/6767906449166332/01a015da-bdfd-7048-97c0-f9b430e44694.webp",
        "width": 1478,
        "height": 986
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Townhomes with Fitness Center in Milford",
      "seo_description": "Explore Millcroft Townhomes in Milford, offering convenient access to fitness centers and a vibrant community lifestyle.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166332",
      "source": "custom",
      "page_item_url": "amenity-rich-apartments-clermont-county-897",
      "search_query": "amenity-rich apartments in Clermont County",
      "category": "Amenity",
      "h1_title": "Amenity-Rich Apartments in Clermont County",
      "h2_subtitle": "Experience a vibrant living atmosphere with Millcroft Apartments, brimming with amenities in Clermont County.",
      "page_copy": "Millcroft Apartments & Townhomes is the epitome of comfort and convenience in Clermont County, OH, offering a lifestyle rich with amenities designed to enhance your living experience. From our sparkling swimming pool to the inviting clubhouse, our community ensures you have everything you need right at your doorstep. Our one and two-bedroom floor plans offer spacious living options perfect for any lifestyle.\n\nResidents here also enjoy an on-site picnic area and sundeck, providing the perfect spaces for relaxation and gathering with friends. Millcroft is not just a place to live—it's a community where you can thrive. With accessible on-site maintenance and community events, Millcroft Apartments & Townhomes embodies amenity-rich living at its best in Clermont County.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/01a015da-bdfd-7048-97c0-f9b430e44694.webp",
      "featured_image_media": {
        "alt_text": "Swimming pool with lounge chairs and umbrellas",
        "public_id": "01a015da-bdfd-7048-97c0-f9b430e44694",
        "storage_key": "property/6767906449166332/01a015da-bdfd-7048-97c0-f9b430e44694.webp",
        "width": 1478,
        "height": 986
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Amenity-Rich Apartments in Clermont County",
      "seo_description": "Millcroft Apartments offer amenity-rich living in Clermont County with features like a pool, clubhouse, and more.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166332",
      "source": "custom",
      "page_item_url": "one-bedroom-apartments-milford-oh-65",
      "search_query": "one bedroom apartments milford oh",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in Milford, OH",
      "h2_subtitle": "Discover your ideal one-bedroom apartment at Millcroft in Milford, OH. Our residences offer comfort and convenience.",
      "page_copy": "Located in the heart of Milford, OH, Millcroft Apartments & Townhomes provides comfortable and stylish one-bedroom apartments designed for modern living. Each unit offers spacious layouts that ensure convenience and ease, making it the perfect home for individuals seeking a blend of comfort and community.\n\nAt Millcroft, residents have access to excellent amenities such as a refreshing swimming pool, a welcoming clubhouse, and serene picnic areas. Situated in a vibrant neighborhood, our one-bedroom apartments are ideal for those looking to be part of a friendly community while enjoying the ease of living in Milford. Experience the best of apartment living with all the conveniences you need just steps from your door.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/01a015da-bdfd-7048-97c0-f9b430e44694.webp",
      "featured_image_media": {
        "alt_text": "Swimming pool with lounge chairs and umbrellas",
        "public_id": "01a015da-bdfd-7048-97c0-f9b430e44694",
        "storage_key": "property/6767906449166332/01a015da-bdfd-7048-97c0-f9b430e44694.webp",
        "width": 1478,
        "height": 986
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments in Milford, OH",
      "seo_description": "Explore one-bedroom apartments at Millcroft in Milford, OH. Enjoy spacious living with access to great amenities and community features.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166332",
      "source": "custom",
      "page_item_url": "two-bedroom-townhomes-clermont-county-169",
      "search_query": "two bedroom townhomes in clermont county",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Townhomes in Clermont County",
      "h2_subtitle": "Explore spacious two-bedroom townhomes at Millcroft, offering a perfect blend of comfort and community in Clermont County.",
      "page_copy": "Discover the ideal two-bedroom townhomes at Millcroft Apartments & Townhomes, located conveniently in Clermont County, OH. These spacious townhomes offer ample room for you to create a home that's truly yours, combining modern living with community spirit. Each unit provides a perfect setting for families or individuals seeking comfort and style.\n\nMillcroft features a wealth of community amenities, including a swimming pool, a sociable clubhouse, and an inviting picnic area—all enhancing the appeal of living in our Clermont County community. Embrace the advantage of on-site maintenance and community events that make Millcroft more than just a place to live. Experience the perfect two-bedroom townhome lifestyle in the heart of Clermont County.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/01a015da-bdfd-7048-97c0-f9b430e44694.webp",
      "featured_image_media": {
        "alt_text": "Swimming pool with lounge chairs and umbrellas",
        "public_id": "01a015da-bdfd-7048-97c0-f9b430e44694",
        "storage_key": "property/6767906449166332/01a015da-bdfd-7048-97c0-f9b430e44694.webp",
        "width": 1478,
        "height": 986
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Townhomes in Clermont County",
      "seo_description": "Discover spacious two-bedroom townhomes at Millcroft in Clermont County, featuring modern amenities and a welcoming community.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166332",
      "source": "custom",
      "page_item_url": "apartments-near-mulberry-elementary-milford-oh-907",
      "search_query": "apartments near Mulberry Elementary School Milford OH",
      "category": "School",
      "h1_title": "Apartments Near Mulberry Elementary, Milford OH",
      "h2_subtitle": "Find your home at Millcroft Apartments, conveniently located near Mulberry Elementary School in Milford, OH.",
      "page_copy": "Millcroft Apartments & Townhomes offers an ideal location for families and individuals seeking a home near Mulberry Elementary School in Milford, OH. Our community features spacious one and two-bedroom options that blend convenience, comfort, and style. Located just a short distance from the school, Millcroft is the perfect choice for those who value a quick and easy commute.\n\nIn addition to its prime location, Millcroft provides a wealth of amenities such as a swimming pool, clubhouse, and picnic area. The community fosters a welcoming and vibrant atmosphere, making it a great place for families and professionals alike. Discover the perfect apartment living experience near Mulberry Elementary School at Millcroft in Milford, OH.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/01a015da-bdfd-7048-97c0-f9b430e44694.webp",
      "featured_image_media": {
        "alt_text": "Swimming pool with lounge chairs and umbrellas",
        "public_id": "01a015da-bdfd-7048-97c0-f9b430e44694",
        "storage_key": "property/6767906449166332/01a015da-bdfd-7048-97c0-f9b430e44694.webp",
        "width": 1478,
        "height": 986
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Mulberry Elementary, Milford OH",
      "seo_description": "Explore Millcroft Apartments near Mulberry Elementary School in Milford, OH. Enjoy a convenient lifestyle with community-focused amenities and spacious floor plans.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166332",
      "source": "custom",
      "page_item_url": "apartments-close-to-pattison-elementary-clermont-county-81",
      "search_query": "apartments close to Pattison Elementary Clermont County",
      "category": "School",
      "h1_title": "Apartments Close to Pattison Elementary",
      "h2_subtitle": "Discover Millcroft Apartments, offering comfortable living close to Pattison Elementary in Clermont County.",
      "page_copy": "Millcroft Apartments & Townhomes provides a perfect location for families looking to live near Pattison Elementary School in Clermont County, OH. Our community offers one and two-bedroom apartment options designed with both style and practicality in mind, making it ideal for residents who desire proximity to quality education.\n\nBeyond its strategic location, Millcroft features top-notch amenities like a swimming pool and a vibrant clubhouse, ensuring a well-rounded living experience. The community atmosphere is fostered by engaging resident activities and convenient on-site maintenance. If you're searching for a home close to Pattison Elementary, Millcroft Apartments in Clermont County is your ideal choice for comfort and convenience.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/01a015da-bdfd-7048-97c0-f9b430e44694.webp",
      "featured_image_media": {
        "alt_text": "Swimming pool with lounge chairs and umbrellas",
        "public_id": "01a015da-bdfd-7048-97c0-f9b430e44694",
        "storage_key": "property/6767906449166332/01a015da-bdfd-7048-97c0-f9b430e44694.webp",
        "width": 1478,
        "height": 986
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Pattison Elementary",
      "seo_description": "Discover Millcroft Apartments in Clermont County, featuring spacious living and amenities near Pattison Elementary School.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166332",
      "source": "custom",
      "page_item_url": "rentals-by-meadowview-elementary-school-45150-295",
      "search_query": "rentals by Meadowview Elementary School 45150",
      "category": "School",
      "h1_title": "Rentals by Meadowview Elementary School",
      "h2_subtitle": "Explore rentals at Millcroft Apartments, conveniently located near Meadowview Elementary School in the 45150 area.",
      "page_copy": "Located just minutes away from Meadowview Elementary School, Millcroft Apartments & Townhomes offers the perfect rental solution in the 45150 area. Our community boasts spacious one and two-bedroom floor plans designed for modern living, ensuring convenience and comfort for families and individuals alike.\n\nEnjoy a host of amenities such as a refreshing swimming pool, a welcoming clubhouse, and a serene picnic area—all enhancing the community spirit at Millcroft. With on-site maintenance and a vibrant community atmosphere, Millcroft makes daily life enjoyable and stress-free. Choose Millcroft Apartments as your home near Meadowview Elementary School in the heart of Milford, OH, and embrace an unparalleled rental lifestyle.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/01a015da-bdfd-7048-97c0-f9b430e44694.webp",
      "featured_image_media": {
        "alt_text": "Swimming pool with lounge chairs and umbrellas",
        "public_id": "01a015da-bdfd-7048-97c0-f9b430e44694",
        "storage_key": "property/6767906449166332/01a015da-bdfd-7048-97c0-f9b430e44694.webp",
        "width": 1478,
        "height": 986
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Rentals by Meadowview Elementary School",
      "seo_description": "Find comfortable rentals at Millcroft Apartments near Meadowview Elementary School, offering modern amenities in the 45150 area.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166332",
      "source": "custom",
      "page_item_url": "living-near-boyd-e-smith-elementary-milford-895",
      "search_query": "living near Boyd E. Smith Elementary School Milford",
      "category": "School",
      "h1_title": "Living Near Boyd E. Smith Elementary",
      "h2_subtitle": "Enjoy a vibrant lifestyle at Millcroft Apartments, located close to Boyd E. Smith Elementary School in Milford.",
      "page_copy": "Experience the convenience of living near Boyd E. Smith Elementary School by making Millcroft Apartments & Townhomes your new home in Milford, OH. This community provides a perfect blend of comfort and accessibility with its spacious one and two-bedroom apartments, ideal for both families and individuals who prioritize education and community living.\n\nMillcroft offers more than just proximity to schools; indulge in amenities like a shimmering swimming pool, a cozy clubhouse, and an inviting picnic area. The atmosphere here is warm and inviting, fostering a sense of belonging with regular resident activities. Opt for Millcroft Apartments for a seamless living experience near Boyd E. Smith Elementary School and enjoy all that Milford has to offer.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/01a015da-bdfd-7048-97c0-f9b430e44694.webp",
      "featured_image_media": {
        "alt_text": "Swimming pool with lounge chairs and umbrellas",
        "public_id": "01a015da-bdfd-7048-97c0-f9b430e44694",
        "storage_key": "property/6767906449166332/01a015da-bdfd-7048-97c0-f9b430e44694.webp",
        "width": 1478,
        "height": 986
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Living Near Boyd E. Smith Elementary, Milford",
      "seo_description": "Discover Millcroft Apartments near Boyd E. Smith Elementary School in Milford. Enjoy spacious living and community amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166332",
      "source": "custom",
      "page_item_url": "apartments-close-to-charles-l-seipelt-elementary-679",
      "search_query": "apartments close to Charles L Seipelt Elementary School OH",
      "category": "School",
      "h1_title": "Apartments Near Charles L Seipelt Elementary",
      "h2_subtitle": "Find your new home at Millcroft Apartments, conveniently located near Charles L Seipelt Elementary School in Ohio.",
      "page_copy": "At Millcroft Apartments & Townhomes, residents enjoy the convenience of living near Charles L Seipelt Elementary School in Milford, OH. Our spacious one and two-bedroom floor plans are perfect for families or individuals who value proximity to quality education while enjoying a comfortable apartment living experience.\n\nBeyond our prime location, Millcroft boasts a variety of amenities including a gleaming swimming pool and a relaxing clubhouse. Our on-site maintenance and community activities ensure that comfort and engagement are part of your everyday life. Choose Millcroft Apartments for a hassle-free lifestyle near Charles L Seipelt Elementary and embrace a welcoming community atmosphere in vibrant Milford.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/01a015da-bdfd-7048-97c0-f9b430e44694.webp",
      "featured_image_media": {
        "alt_text": "Swimming pool with lounge chairs and umbrellas",
        "public_id": "01a015da-bdfd-7048-97c0-f9b430e44694",
        "storage_key": "property/6767906449166332/01a015da-bdfd-7048-97c0-f9b430e44694.webp",
        "width": 1478,
        "height": 986
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Charles L Seipelt Elementary OH",
      "seo_description": "Explore Millcroft Apartments, located near Charles L Seipelt Elementary in OH, offering a comfortable and convenient living experience.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166332",
      "source": "custom",
      "page_item_url": "townhomes-by-milford-middle-school-clermont-704",
      "search_query": "townhomes by Milford Middle School Clermont County",
      "category": "School",
      "h1_title": "Townhomes by Milford Middle School",
      "h2_subtitle": "Discover spacious townhomes at Millcroft near Milford Middle School, right in Clermont County.",
      "page_copy": "Millcroft Apartments & Townhomes offers an ideal location near Milford Middle School in the scenic Clermont County, ensuring a perfect balance of educational convenience and community charm. Our spacious townhomes provide a comfortable setting suitable for families or individuals who seek quality schooling nearby.\n\nWith key amenities including an inviting swimming pool and a bustling clubhouse, Millcroft fosters a vibrant community atmosphere. Residents enjoy regular community events and the added convenience of on-site maintenance. Choose Millcroft Townhomes for an enriching lifestyle in Clermont County, combining educational proximity with leisure and relaxation.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/01a015da-bdfd-7048-97c0-f9b430e44694.webp",
      "featured_image_media": {
        "alt_text": "Swimming pool with lounge chairs and umbrellas",
        "public_id": "01a015da-bdfd-7048-97c0-f9b430e44694",
        "storage_key": "property/6767906449166332/01a015da-bdfd-7048-97c0-f9b430e44694.webp",
        "width": 1478,
        "height": 986
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Townhomes Near Milford Middle School",
      "seo_description": "Experience the comfort of Millcroft Townhomes near Milford Middle School in Clermont County, offering spacious living and community amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166332",
      "source": "custom",
      "page_item_url": "millcroft-apartments-near-milford-high-school-442",
      "search_query": "Millcroft Apartments near Milford High School",
      "category": "School",
      "h1_title": "Millcroft Apartments by Milford High School",
      "h2_subtitle": "Discover Millcroft Apartments, conveniently located close to Milford High School, offering a blend of comfort and community.",
      "page_copy": "Find the ideal living space at Millcroft Apartments & Townhomes, located just a short distance from Milford High School. Our community in Milford, OH, offers a selection of spacious one and two-bedroom apartments that cater to those who value educational access and a lively residential environment.\n\nMillcroft provides a welcoming atmosphere with amenities such as a refreshing swimming pool and a vibrant clubhouse. Residents also benefit from engaging community activities, perfect for getting to know neighbors. Choose Millcroft Apartments for a seamless blend of academic proximity and community life, right near Milford High School.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/01a015da-bdfd-7048-97c0-f9b430e44694.webp",
      "featured_image_media": {
        "alt_text": "Swimming pool with lounge chairs and umbrellas",
        "public_id": "01a015da-bdfd-7048-97c0-f9b430e44694",
        "storage_key": "property/6767906449166332/01a015da-bdfd-7048-97c0-f9b430e44694.webp",
        "width": 1478,
        "height": 986
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Millcroft Apartments Near Milford High School",
      "seo_description": "Explore Millcroft Apartments, located near Milford High School, providing comfortable living with exceptional amenities and a community-focused atmosphere.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166332",
      "source": "custom",
      "page_item_url": "living-near-live-oaks-career-campus-milford-269",
      "search_query": "living near Live Oaks Career Campus Milford OH",
      "category": "School",
      "h1_title": "Living Near Live Oaks Career Campus",
      "h2_subtitle": "Experience the convenience of living near Live Oaks Career Campus at Millcroft Apartments in Milford, OH.",
      "page_copy": "At Millcroft Apartments & Townhomes, residents enjoy not only an engaging living environment but also the convenience of being located near Live Oaks Career Campus in Milford, OH. This prime location is ideal for students and families who seek both educational opportunities and a comfortable home setting.\n\nOur community offers spacious floor plans, a sparkling swimming pool, and a vibrant clubhouse, making it easy to unwind and socialize. With on-site maintenance and a schedule full of resident activities, living at Millcroft means embracing a hassle-free lifestyle. Experience the benefits of a connected community and easy access to Live Oaks Career Campus at Millcroft Apartments.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/01a015da-bdfd-7048-97c0-f9b430e44694.webp",
      "featured_image_media": {
        "alt_text": "Swimming pool with lounge chairs and umbrellas",
        "public_id": "01a015da-bdfd-7048-97c0-f9b430e44694",
        "storage_key": "property/6767906449166332/01a015da-bdfd-7048-97c0-f9b430e44694.webp",
        "width": 1478,
        "height": 986
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Millcroft: Near Live Oaks Career Campus",
      "seo_description": "Millcroft Apartments offers a convenient lifestyle near Live Oaks Career Campus in Milford, OH, with spacious living and top-notch amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166332",
      "source": "custom",
      "page_item_url": "apartments-close-to-uc-clermont-college-45150-101",
      "search_query": "apartments close to UC Clermont College 45150",
      "category": "School",
      "h1_title": "Apartments Near UC Clermont College",
      "h2_subtitle": "Millcroft Apartments offers a prime location close to UC Clermont College, making it ideal for students and faculty.",
      "page_copy": "Situated conveniently in Milford, OH, Millcroft Apartments & Townhomes provides an excellent living option for those seeking proximity to UC Clermont College. Our community offers spacious one and two-bedroom apartments designed to meet the needs of students and faculty seeking a balance of convenience and comfort.\n\nResidents enjoy access to a variety of amenities, including a refreshing swimming pool and a lively clubhouse, ideal for relaxation and socializing. Additionally, our site management provides attentive on-site maintenance, ensuring a hassle-free living experience. Choose Millcroft Apartments as your home base close to UC Clermont College and enjoy the best of both academics and community life.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/01a015da-bdfd-7048-97c0-f9b430e44694.webp",
      "featured_image_media": {
        "alt_text": "Swimming pool with lounge chairs and umbrellas",
        "public_id": "01a015da-bdfd-7048-97c0-f9b430e44694",
        "storage_key": "property/6767906449166332/01a015da-bdfd-7048-97c0-f9b430e44694.webp",
        "width": 1478,
        "height": 986
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Millcroft: Close to UC Clermont College",
      "seo_description": "Discover Millcroft Apartments, ideally located near UC Clermont College in Milford, OH 45150, offering comfort and community amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166332",
      "source": "custom",
      "page_item_url": "apartments-near-mercy-health-clermont-hospital-119",
      "search_query": "apartments near Mercy Health - Clermont Hospital Milford OH",
      "category": "Hospital",
      "h1_title": "Apartments Near Mercy Health Clermont Hospital",
      "h2_subtitle": "Find convenience and comfort at Millcroft Apartments, located near Mercy Health - Clermont Hospital in Milford, OH.",
      "page_copy": "If you're searching for a home near Mercy Health - Clermont Hospital, Millcroft Apartments & Townhomes is the perfect choice. Located in Milford, OH, our community provides quick access to the hospital, making it ideal for healthcare professionals and their families.\n\nEnjoy spacious living with our one and two-bedroom floor plans, complemented by enticing amenities like a swimming pool and a welcoming dog park. Our vibrant community hosts a variety of resident activities, offering a pleasant atmosphere to meet and socialize with neighbors. Choose Millcroft Apartments for a lifestyle that balances work proximity with leisure and community engagement.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/01a015da-bdfd-7048-97c0-f9b430e44694.webp",
      "featured_image_media": {
        "alt_text": "Swimming pool with lounge chairs and umbrellas",
        "public_id": "01a015da-bdfd-7048-97c0-f9b430e44694",
        "storage_key": "property/6767906449166332/01a015da-bdfd-7048-97c0-f9b430e44694.webp",
        "width": 1478,
        "height": 986
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Millcroft: Near Mercy Health Clermont Hospital",
      "seo_description": "Conveniently located near Mercy Health - Clermont Hospital, Millcroft Apartments in Milford, OH offer spacious living with excellent amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166332",
      "source": "custom",
      "page_item_url": "apartments-near-cincinnati-nature-center-730",
      "search_query": "apartments near cincinnati nature center milford oh",
      "category": "Park",
      "h1_title": "Apartments Near Cincinnati Nature Center",
      "h2_subtitle": "Discover tranquil living at Millcroft Apartments near the scenic Cincinnati Nature Center in Milford, OH.",
      "page_copy": "Millcroft Apartments & Townhomes offers the perfect blend of nature and convenience, situated close to the captivating Cincinnati Nature Center in Milford, OH. Residents who appreciate outdoor adventures will love our proximity to this natural oasis, ideal for hiking, birdwatching, and relaxation.\n\nOur community provides spacious floor plans and amenities that include a sun-kissed swimming pool and a picnic area, creating a serene escape after exploring nearby nature trails. With on-site maintenance and engaging resident activities, Millcroft ensures a rewarding living experience. Embrace the serene surroundings and community life at Millcroft Apartments, all while staying near the beauty of the Cincinnati Nature Center.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/01a015da-bdfd-7048-97c0-f9b430e44694.webp",
      "featured_image_media": {
        "alt_text": "Swimming pool with lounge chairs and umbrellas",
        "public_id": "01a015da-bdfd-7048-97c0-f9b430e44694",
        "storage_key": "property/6767906449166332/01a015da-bdfd-7048-97c0-f9b430e44694.webp",
        "width": 1478,
        "height": 986
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Millcroft: Near Cincinnati Nature Center",
      "seo_description": "Experience serene living at Millcroft Apartments near the Cincinnati Nature Center in Milford, OH, featuring spacious homes and relaxing amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166332",
      "source": "custom",
      "page_item_url": "millcroft-apartments-near-valley-view-nature-preserve-179",
      "search_query": "millcroft apartments close to valley view nature preserve",
      "category": "Park",
      "h1_title": "Millcroft Apartments Near Valley View",
      "h2_subtitle": "Discover Millcroft Apartments, conveniently located near Valley View Nature Preserve, offering a perfect blend of comfort and nature in Milford, OH.",
      "page_copy": "For those who love the outdoors, Millcroft Apartments & Townhomes offers a prime location near the picturesque Valley View Nature Preserve. Nestled in Milford, OH, our community provides easy access to the preserve's serene walking trails and captivating landscapes, perfect for weekend adventures or daily escapes.\n\nLiving at Millcroft means enjoying spacious one and two-bedroom apartments with a host of amenities designed for relaxation and entertainment, including a sunny swimming pool and a welcoming clubhouse. With vibrant resident activities and on-site maintenance, our community promises a fulfilling lifestyle close to nature. Choose Millcroft Apartments for a unique blend of comfort and outdoor adventure near Valley View Nature Preserve.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/01a015da-bdfd-7048-97c0-f9b430e44694.webp",
      "featured_image_media": {
        "alt_text": "Swimming pool with lounge chairs and umbrellas",
        "public_id": "01a015da-bdfd-7048-97c0-f9b430e44694",
        "storage_key": "property/6767906449166332/01a015da-bdfd-7048-97c0-f9b430e44694.webp",
        "width": 1478,
        "height": 986
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Millcroft: Close to Valley View Nature Preserve",
      "seo_description": "Beautiful Millcroft Apartments near Valley View Nature Preserve in Milford, OH, provide spacious living with great amenities for nature lovers.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166332",
      "source": "custom",
      "page_item_url": "living-near-shor-park-milford-ohio-215",
      "search_query": "living near shor park milford ohio",
      "category": "Park",
      "h1_title": "Living Near Shor Park",
      "h2_subtitle": "Embrace a lifestyle near Shor Park in Milford, OH, with Millcroft Apartments, where comfort meets outdoor fun.",
      "page_copy": "Experience the best of Milford with Millcroft Apartments & Townhomes, located just a short drive from Shor Park. Perfect for outdoor enthusiasts, living near Shor Park means easy access to expansive green spaces, walking trails, and family-friendly areas, making it a great addition to your backyard experience.\n\nAt Millcroft, you'll enjoy spacious living options complemented by amenities such as a sparkling swimming pool and a versatile clubhouse. Engage in our vibrant community with resident activities while being part of a friendly neighborhood. Choose Millcroft Apartments for a harmonious blend of natural beauty and community spirit, all from a location that offers quick access to Shor Park's recreational opportunities.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/01a015da-bdfd-7048-97c0-f9b430e44694.webp",
      "featured_image_media": {
        "alt_text": "Swimming pool with lounge chairs and umbrellas",
        "public_id": "01a015da-bdfd-7048-97c0-f9b430e44694",
        "storage_key": "property/6767906449166332/01a015da-bdfd-7048-97c0-f9b430e44694.webp",
        "width": 1478,
        "height": 986
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Millcroft: Living Close to Shor Park",
      "seo_description": "Live near Shor Park at Millcroft Apartments in Milford, OH, and enjoy spacious units with great amenities in a vibrant community.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166332",
      "source": "custom",
      "page_item_url": "apartments-by-carriage-way-park-clermont-county-523",
      "search_query": "apartments by carriage way park clermont county",
      "category": "Park",
      "h1_title": "Apartments by Carriage Way Park",
      "h2_subtitle": "Explore Millcroft Apartments, conveniently situated by Carriage Way Park in Clermont County for the perfect blend of leisure and comfort.",
      "page_copy": "Nestled in the heart of Milford, OH, Millcroft Apartments & Townhomes offers an ideal living experience just moments away from Carriage Way Park in Clermont County. This proximity provides residents with ample opportunities for picnics, leisurely walks, and enjoying the natural beauty that surrounds the park.\n\nOur community features spacious one and two-bedroom apartments paired with top-notch amenities such as a refreshing swimming pool and a sociable clubhouse. With vibrant resident events and reliable on-site maintenance, Millcroft ensures a welcoming environment where you can thrive. Experience the convenience and comfort of living near Carriage Way Park while enjoying all that Millcroft Apartments has to offer.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/01a015da-bdfd-7048-97c0-f9b430e44694.webp",
      "featured_image_media": {
        "alt_text": "Swimming pool with lounge chairs and umbrellas",
        "public_id": "01a015da-bdfd-7048-97c0-f9b430e44694",
        "storage_key": "property/6767906449166332/01a015da-bdfd-7048-97c0-f9b430e44694.webp",
        "width": 1478,
        "height": 986
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Millcroft Apartments Near Carriage Way Park",
      "seo_description": "Discover Millcroft Apartments in Clermont County, offering spacious homes and amenities near Carriage Way Park in Milford, OH.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166332",
      "source": "custom",
      "page_item_url": "millcroft-homes-near-riverside-park-milford-61",
      "search_query": "millcroft homes near riverside park milford",
      "category": "Park",
      "h1_title": "Millcroft Homes Near Riverside Park",
      "h2_subtitle": "Discover Millcroft Homes located near Riverside Park in Milford, offering a perfect blend of scenic beauty and modern comfort.",
      "page_copy": "Located in the vibrant community of Milford, OH, Millcroft Apartments & Townhomes provide an exceptional living experience just a stone's throw away from the charming Riverside Park. Enjoy the scenic landscapes and family-friendly activities that Riverside Park offers, while basking in the comfort of spacious one and two-bedroom homes at Millcroft.\n\nOur community is designed with your lifestyle in mind, featuring a refreshing swimming pool and a variety of resident events. With amenities that cater to leisure and convenience, such as our modern clubhouse and on-site maintenance, Millcroft is the perfect place to call home, balancing the tranquility of Riverside Park with the vibrancy of Milford living.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/01a015da-bdfd-7048-97c0-f9b430e44694.webp",
      "featured_image_media": {
        "alt_text": "Swimming pool with lounge chairs and umbrellas",
        "public_id": "01a015da-bdfd-7048-97c0-f9b430e44694",
        "storage_key": "property/6767906449166332/01a015da-bdfd-7048-97c0-f9b430e44694.webp",
        "width": 1478,
        "height": 986
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Millcroft Homes by Riverside Park, Milford",
      "seo_description": "Live near Riverside Park at Millcroft Homes in Milford, OH. Enjoy spacious living with modern amenities in a scenic, convenient location.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166332",
      "source": "custom",
      "page_item_url": "apartments-close-to-leming-house-milford-oh-943",
      "search_query": "apartments close to leming house milford oh",
      "category": "Park",
      "h1_title": "Apartments Close to Leming House",
      "h2_subtitle": "Find your perfect home at Millcroft Apartments, ideally close to Leming House in Milford, OH, blending modern living with historical charm.",
      "page_copy": "At Millcroft Apartments & Townhomes, enjoy the comfort and convenience of living near Leming House in Milford, OH. This historic gem serves as a community hub for events and gatherings, offering a unique connection to Milford's rich heritage.\n\nChoose from a variety of spacious floor plans, complemented by amenities like a rejuvenating swimming pool and our inviting community clubhouse. Millcroft provides a welcoming atmosphere with multiple resident activities and a dedicated dog park, enhancing your living experience. Revel in the charm of historic Milford while being just minutes away from Leming House, ensuring a lifestyle that balances modern amenities with local culture.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/01a015da-bdfd-7048-97c0-f9b430e44694.webp",
      "featured_image_media": {
        "alt_text": "Swimming pool with lounge chairs and umbrellas",
        "public_id": "01a015da-bdfd-7048-97c0-f9b430e44694",
        "storage_key": "property/6767906449166332/01a015da-bdfd-7048-97c0-f9b430e44694.webp",
        "width": 1478,
        "height": 986
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Millcroft Apartments Near Leming House, Milford",
      "seo_description": "Discover Millcroft Apartments near Leming House in Milford, OH. Enjoy spacious living with modern amenities close to local history and community events.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166332",
      "source": "custom",
      "page_item_url": "residences-near-miami-meadows-park-clermont-county-249",
      "search_query": "residences near miami meadows park clermont county",
      "category": "Park",
      "h1_title": "Residences Near Miami Meadows Park",
      "h2_subtitle": "Experience Millcroft, a community of residences near Miami Meadows Park in Clermont County. Enjoy nature's beauty with modern amenities.",
      "page_copy": "Embrace the tranquility of nature by choosing Millcroft Apartments & Townhomes, ideally situated near Miami Meadows Park in Clermont County. Our residences offer easy access to a plethora of outdoor activities such as walking trails, sporting facilities, and serene picnic spots at the park.\n\nMillcroft combines a peaceful setting with contemporary living, featuring spacious one and two-bedroom homes. Enjoy our on-site amenities—including a sparkling swimming pool and a welcoming clubhouse—that cater to a vibrant lifestyle. Residents enjoy seamless access to the area's natural beauty while benefitting from convenient onsite maintenance and engaging community events at Millcroft.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/01a015da-bdfd-7048-97c0-f9b430e44694.webp",
      "featured_image_media": {
        "alt_text": "Swimming pool with lounge chairs and umbrellas",
        "public_id": "01a015da-bdfd-7048-97c0-f9b430e44694",
        "storage_key": "property/6767906449166332/01a015da-bdfd-7048-97c0-f9b430e44694.webp",
        "width": 1478,
        "height": 986
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Millcroft Homes Near Miami Meadows Park",
      "seo_description": "Live at Millcroft, residences close to Miami Meadows Park in Clermont County. Enjoy modern living with nature at your doorstep.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166332",
      "source": "custom",
      "page_item_url": "living-near-paxton-ramsey-park-milford-ohio-589",
      "search_query": "living near paxton ramsey park milford ohio",
      "category": "Park",
      "h1_title": "Living Near Paxton Ramsey Park",
      "h2_subtitle": "Discover Millcroft Apartments, offering comfortable living near Paxton Ramsey Park in Milford, Ohio. Enjoy the best of both worlds.",
      "page_copy": "Imagine living at Millcroft Apartments & Townhomes, where the charm of Milford, Ohio, is at your doorstep, complemented by proximity to Paxton Ramsey Park. This park is a local favorite, offering lush green spaces and recreational activities for all ages, perfect for leisurely strolls or vibrant family outings.\n\nOur community provides spacious one and two-bedroom layouts with amenities that enhance your lifestyle, including a refreshing swimming pool and a lively resident clubhouse. Embrace a balanced life where modern comforts meet natural beauty. Whether enjoying the onsite picnic area or exploring nearby trails, Millcroft is your gateway to a fulfilling, active lifestyle near Paxton Ramsey Park.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/01a015da-bdfd-7048-97c0-f9b430e44694.webp",
      "featured_image_media": {
        "alt_text": "Swimming pool with lounge chairs and umbrellas",
        "public_id": "01a015da-bdfd-7048-97c0-f9b430e44694",
        "storage_key": "property/6767906449166332/01a015da-bdfd-7048-97c0-f9b430e44694.webp",
        "width": 1478,
        "height": 986
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Millcroft Apartments Near Paxton Ramsey Park",
      "seo_description": "Live at Millcroft Apartments near Paxton Ramsey Park in Milford, Ohio. Enjoy modern amenities and natural beauty in a vibrant community.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166332",
      "source": "custom",
      "page_item_url": "homes-near-lake-isabella-45150-921",
      "search_query": "homes near lake isabella 45150",
      "category": "Park",
      "h1_title": "Homes Near Lake Isabella 45150",
      "h2_subtitle": "Explore Millcroft Apartments & Townhomes, your ideal homes near Lake Isabella in the 45150 area. Enjoy a blend of comfort and scenic beauty.",
      "page_copy": "Millcroft Apartments & Townhomes offers a delightful living experience near Lake Isabella, located in the serene 45150 area. Our homes provide a picturesque setting for residents who appreciate the tranquility of lakeside living. Whether you enjoy fishing, hiking, or picnicking by the water, Lake Isabella offers a scenic escape just moments from your doorstep.\n\nChoose from our variety of spacious floor plans that enhance your lifestyle with modern conveniences and select amenities like a sparkling swimming pool and vibrant community activities. At Millcroft, you're not just finding a home near Lake Isabella—you're joining a community dedicated to enhancing your living experience with the best of nature and comfort.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/01a015da-bdfd-7048-97c0-f9b430e44694.webp",
      "featured_image_media": {
        "alt_text": "Swimming pool with lounge chairs and umbrellas",
        "public_id": "01a015da-bdfd-7048-97c0-f9b430e44694",
        "storage_key": "property/6767906449166332/01a015da-bdfd-7048-97c0-f9b430e44694.webp",
        "width": 1478,
        "height": 986
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Millcroft Homes Near Lake Isabella 45150",
      "seo_description": "Find homes near Lake Isabella in the 45150 area at Millcroft. Enjoy spacious living with modern amenities and stunning lake views.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166332",
      "source": "custom",
      "page_item_url": "apartments-near-cincinnati-northern-kentucky-airport-618",
      "search_query": "apartments near Cincinnati/Northern Kentucky International Airport",
      "category": "Transit",
      "h1_title": "Apartments Near CVG Airport",
      "h2_subtitle": "Discover Millcroft Apartments, ideally situated near Cincinnati/Northern Kentucky International Airport. Perfect for frequent flyers seeking convenience.",
      "page_copy": "For those frequently traveling through Cincinnati/Northern Kentucky International Airport, Millcroft Apartments & Townhomes offers a convenient living solution. Located just a short drive away, our community provides easy access to the airport while nestled in the picturesque surroundings of Milford, OH. This makes it an ideal choice for professionals and travelers alike looking for apartments near the airport.\n\nAt Millcroft, residents can enjoy spacious living in one and two-bedroom layouts equipped with contemporary amenities such as a refreshing swimming pool, vibrant clubhouse, and welcoming picnic area. With our strategic location, you can enjoy a tranquil home base that doesn't sacrifice proximity to vital travel hubs and the charming features of local living in Milford.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166332/01a015da-bdfd-7048-97c0-f9b430e44694.webp",
      "featured_image_media": {
        "alt_text": "Swimming pool with lounge chairs and umbrellas",
        "public_id": "01a015da-bdfd-7048-97c0-f9b430e44694",
        "storage_key": "property/6767906449166332/01a015da-bdfd-7048-97c0-f9b430e44694.webp",
        "width": 1478,
        "height": 986
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Millcroft Apartments Near CVG Airport",
      "seo_description": "Find convenient living at Millcroft Apartments near CVG Airport. Enjoy easy travel access with spacious accommodations and modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "jordanh@repli360.com"
    },
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "5069"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "9976267640"
    },
    {
      "ID": "custom_realpage_id",
      "type": "STRING",
      "value": "5478513"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-WBVQQWRD"
    },
    {
      "ID": "custom_perq_script_url",
      "type": "STRING",
      "value": "https://millcroftapts.fatwin.com/api/websites/resources/1?x=SU1oVnBUeVhKZmZvUndBcUQ3Vm9ta290NVlUQzBSRVdaRFliMlo4d281eCtycGs5WHYwakNHM1Rlcm1XdS8yajRjNWZ6ZjBnSXFNcHdVRHAyL1JOQ3c9PQ2"
    },
    {
      "ID": "custom_vibesites_theme",
      "type": "STRING",
      "value": "Belmont"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "58895523170"
    },
    {
      "ID": "custom_engrain_sitemap_url",
      "type": "STRING",
      "value": "https://sightmap.com/embed/zlpo627npg4"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "turnkey"
    },
    {
      "ID": "custom_eliseai_building_token",
      "type": "STRING",
      "value": "3c80cd06-13f1-11f0-b724-0b9b7dd03671"
    },
    {
      "ID": "custom_eliseai_tour_scheduler",
      "type": "STRING",
      "value": "https://app.meetelise.com/4bbc32e5-b155-40a7-886b-b483419a5646/3c80cd06-13f1-11f0-b724-0b9b7dd03671/tour?hideScrollBars=true"
    },
    {
      "ID": "custom_eliseai_organization_id",
      "type": "STRING",
      "value": "4bbc32e5-b155-40a7-886b-b483419a5646"
    },
    {
      "ID": "custom_eliseai_tour_button_popup",
      "type": "STRING",
      "value": "<button onclick=\"window.eliseAi.onOpenSST()\">Schedule A Tour</button>"
    },
    {
      "ID": "custom_eliseai_tour_scheduler_url",
      "type": "STRING",
      "value": "https://app.meetelise.com/4bbc32e5-b155-40a7-886b-b483419a5646/3c80cd06-13f1-11f0-b724-0b9b7dd03671/tour?hideScrollBars=true"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6IkRkTkhqNFJ0UnR2a0hUZEtLYk56S2c9PSIsInZhbHVlIjoidmVWcStZQVArYllnSlBrbGF0MHZldz09IiwibWFjIjoiYTkyZTg1Mjc0ZjJkM2Q4MjkwMzM3NGI4MTQzOGMyZTE3MTJkNTJlYWUyZDJhYTNiODFhMjgyM2UxNDUxZDExMCJ9"
    },
    {
      "ID": "custom_loft_resident_download_apple",
      "type": "STRING",
      "value": "https://apps.apple.com/us/app/loft-living/id333244247"
    },
    {
      "ID": "custom_loft_resident_download_google",
      "type": "STRING",
      "value": "https://play.google.com/store/apps/details?id=com.activebuilding.residents"
    }
  ],
  "custom_csm": "jordanh@repli360.com",
  "custom_qb_id": "5069",
  "custom_repli_id": "9976267640",
  "custom_realpage_id": "5478513",
  "custom_google_gtm_id": "GTM-WBVQQWRD",
  "custom_perq_script_url": "https://millcroftapts.fatwin.com/api/websites/resources/1?x=SU1oVnBUeVhKZmZvUndBcUQ3Vm9ta290NVlUQzBSRVdaRFliMlo4d281eCtycGs5WHYwakNHM1Rlcm1XdS8yajRjNWZ6ZjBnSXFNcHdVRHAyL1JOQ3c9PQ2",
  "custom_vibesites_theme": "Belmont",
  "custom_ads_subscription": "none",
  "custom_seo_subscription": "essential",
  "custom_hubspot_company_id": "58895523170",
  "custom_engrain_sitemap_url": "https://sightmap.com/embed/zlpo627npg4",
  "custom_social_subscription": "none",
  "custom_website_subscription": "turnkey",
  "custom_eliseai_building_token": "3c80cd06-13f1-11f0-b724-0b9b7dd03671",
  "custom_eliseai_tour_scheduler": "https://app.meetelise.com/4bbc32e5-b155-40a7-886b-b483419a5646/3c80cd06-13f1-11f0-b724-0b9b7dd03671/tour?hideScrollBars=true",
  "custom_eliseai_organization_id": "4bbc32e5-b155-40a7-886b-b483419a5646",
  "custom_eliseai_tour_button_popup": "<button onclick=\"window.eliseAi.onOpenSST()\">Schedule A Tour</button>",
  "custom_eliseai_tour_scheduler_url": "https://app.meetelise.com/4bbc32e5-b155-40a7-886b-b483419a5646/3c80cd06-13f1-11f0-b724-0b9b7dd03671/tour?hideScrollBars=true",
  "custom_apartmentsync_javascript_id": "eyJpdiI6IkRkTkhqNFJ0UnR2a0hUZEtLYk56S2c9PSIsInZhbHVlIjoidmVWcStZQVArYllnSlBrbGF0MHZldz09IiwibWFjIjoiYTkyZTg1Mjc0ZjJkM2Q4MjkwMzM3NGI4MTQzOGMyZTE3MTJkNTJlYWUyZDJhYTNiODFhMjgyM2UxNDUxZDExMCJ9",
  "custom_loft_resident_download_apple": "https://apps.apple.com/us/app/loft-living/id333244247",
  "custom_loft_resident_download_google": "https://play.google.com/store/apps/details?id=com.activebuilding.residents",
  "custom_audioeye_site_id": "7e836473-c5b4-4c02-8d1c-e5968ea02908",
  "custom_audioeye_site_hash": "00778116fa69b3cb0fd103ffd1d6443c"
};

export const generatedAt = '2026-10-22T20:06:27.774Z';
